import React, { useState, useEffect, useContext, useRef } from "react"
import Section from "../sections/section"
import RightSideBar from "../sections/section-right-side-bar"
import { SectionContext } from "../context/sectionContext"
import { PageContext } from "../context/pageContext"
import { JourneyContext } from "../context/journeyContext"
import { ErrorContext } from "../context/errorContext"
import { ConditionContext } from "../context/conditionContext"
import { componentRenderCheck, multiConditionComponentRenderCheck } from "../services/componentRenderCheck"
import { refreshToken } from "../../interceptors/jwt-interceptor"
// import { window, document } from "browser-monads";
import {
  saveApplication,
  saveApplicationDetailsOverall,
  generateBI,
  fetchApplicationDetails,
  getAllInputQuotations,
  saveTransactionDetails,
  getIpAddress,
  getJWTTokenForIp,
  checkPaymentStatus,
  paymentTextDecrypt,
  digilocker,
  saveEnachTransactionDetails,
  verifyCorpDiscOtp,
  checkTPA,
  updateUserTrackerDetails,
  verifyCaptcha,
  saveBasbaTransactionLogs,
  getConfigByType,
  getConfigurationsByType
} from "../../services/apiservice"
import { findCurrentJourneyCode, getKeyFromValueLookup, getValueFromLookup, getLastPageAndLastSection, getAge, DataLayerIntegration } from "../services/helperFunctions"
import { convertJson, dataLayerConvertJson } from "../services/dataLayerMapper"
import * as lookup from "../../../static/lookup.json"
import * as callBiKeyJson from "../../../static/callBiKey.json"
import * as freezeJson from "../../../static/freezeDataOnApiCalls.json"
import { validateP2PBusinessRules } from "../services/p2pBusinessRuleValidator"

//static pages
import ProvideYourConsent from "../sections/provide-your-consent"
import Ekyc from "../sections/ekyc/ekyc"
import Ckyc from "../sections/ckyc"
import BenefitIllustration from "../sections/benefit-illustration"
import Payment from "../sections/payment"
import UploadDocuments from "../sections/upload-documents"
import ChooseYourPlan from "../sections/choose-your-plan"
import SuccessfulTransactions from "../sections/successful-transaction"
import Declaration from "../sections/declaration"
import Submission from "../sections/submission"
import UnsuccessfulTransaction from "../sections/unsuccessful-transaction"
import PendingTransaction from "../sections/pending-transaction"
import BenefitIllustrationPos from "../sections/BI-POS"
import BenefitIllustrationUlip from "../sections/BI-ULIP"
import EasyBachatPremium from "../sections/easyBachatPremium"
import Invest4GFundValue from "../sections/invest4gFundValue"
import ReviewDetails from "../sections/review-details"
import ChooseYourPlanYoungTerm from "../sections/choose-your-plan-youngTerm"
import { element } from "prop-types"
import { errorToastr, successToastr, clearToastr } from "../../services/error-handler"
import { success } from "toastr"
import BenefitIllustrationGSP from "../sections/BenefitIllustrationGSP"
import ENachPhysicalMandate from "../sections/Enach-physicalMandate"
import TeleMer from "../sections/tele-MER"
import YoungTermBenefitIllustration from "../sections/youngtermbenefit-illustration"
import SalesConfidentialReport from "../sections/salesConfidentialReport"
import ThankYou from "../sections/Thank-You"
import moment from "moment"
import BookTPASlot from '../sections/bookTPASlots'
import { TpaContext } from "../context/tpaContext"
import BookTPASlotSA from "../sections/bookTPASlotsSA"
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import PendingTransactionBasba from "../sections/pending-transaction-basba"
import Promise2ProtectBenefitIllustration from "../sections/promise2protect-benefit-illustration"
import ChooseYourPlanP2P from "../sections/choose-your-plan-P2P"

const Page = props => {
  //{local component states}
  // const sections = props.sections;
  const [currentSectionIndex, setCurrentSectionIndex] = useState(0)
  const [showError, setShowError] = useState(false)
  const [nvestFilterResult, setNvestFilterResult] = useState()
  const [saveApplicationCounter, setSaveApplicationCounter] = useState(0)

  //handeling context{context states}
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [pageState, setPageState] = useContext(PageContext)
  const [journeyState, setJourneyState, isFirstProposalPageCovered2] = useContext(JourneyContext)
  const [errorState, setErrorState] = useContext(ErrorContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [firstPassForFreezingDataSections, setFirstPassForFreezingDataSections] = useState({
    "personalDetailsSection": true,
    "residenceDetailsSection": true,
    "professionalDetailSection": true,
    "sectionISelect360ProfessionalDetail": true,
    "healthAndLifeStyleDetailSection": true,
    "spouseQuestionnaire": true,
    "spouseMedicalQuestionnaire": true,
    "SectionPOSFPSPersonalDetails": true,
    "SectionPOSCommunicationAddress": true,
    "SectionPOSOccupationDetails": true,
    "SectionPOSProposerDetails": true,
    "riskDetailSection":true
  })
  const [firstPassForPremiumPaymentBicall, setFirstPassForPremiumPaymentBicall] = useState(true)
  const [firstPageAutoFillApiCall, setFirstPageAutoFillApiCall] = useState(false)
  const [journeyDataState, setJourneyDataState] = useState()
  const {setTpaState,tpaState,tpaStateSA,setTpaStateSA} = useContext(TpaContext)
  const { executeRecaptcha } = useGoogleReCaptcha();

  const [callBi, setCallBi] = useState(false)
  const [p2pBusinessRulesConfig, setP2pBusinessRulesConfig] = useState(null)
  // console.log(journeyState);
  const [utmParams, setUtmParams] = useState({});

  const sections = props.sections?.filter(element => {
    if (element.conditions.length === 1) {
      if (componentRenderCheck(element.conditions[0],conditionState[element.conditions[0].watchKey], journeyState)){
        return element
      }
    } else if(element.conditions.length > 1){
      if(multiConditionComponentRenderCheck(element.conditions,conditionState, journeyState)){
        return element
      }
    }else {
      return element
    }
  })

  function applicationDataInJourneyFormat(value, typeOfMandate, statusOfMandate) {
    console.log(typeOfMandate);
    if(!sectionState){
      return {}
    }
    let sectionStateToPass = JSON.parse(JSON.stringify(sectionState))
    if (!sectionStateToPass.sectionId) {
      sectionStateToPass.sectionId = sections?.[currentSectionIndex]?.sectionId
    }
    if(value && value.length){
      sectionStateToPass.sectionData[value[0]] = value[1]
    }

    let pageData = pageState?.pageData.filter(
      element => element.sectionId !== sectionStateToPass?.sectionId
    )
    let journeyData = journeyState.journeyData.filter(
      element => element.pageId !== props.pages?.[props.currentPageIndex]?.pageId
    )

    let LoadPaylod = [
      ...journeyData,
      {
        pageId: props.pages?.[props.currentPageIndex]?.pageId,
        pageData: [...pageData, sectionStateToPass],
      },
    ]
    console.log(LoadPaylod, "LoadPaylodForDataLayer")
    let loadPayloadJson = convertJson(LoadPaylod)
    console.log(loadPayloadJson);
    let journeyFormatData = dataLayerConvertJson(loadPayloadJson, journeyState.journeyIdFromStrapi, props.pages[props.currentPageIndex].pageId, sections[currentSectionIndex]?.sectionId)
    journeyFormatData["basicDetails"] = {
      paymentMode: journeyState.paymentMode,
      premium: journeyState.premium,
      applicationNumber: journeyState.applicationNo,
      illustrationNumber: journeyState.illustrationNumber,
      paymentOption: props.currentPageIndex > 1 ? journeyState.paymentStep : "",
      existingCustomer: props.currentPageIndex >= 1 ? "N" : "",
      isPhysicalMandateOpt: typeOfMandate === "physicalMandate" ? true : (typeOfMandate === "enach" ? false : journeyState.isPhysicalMandateOpt),
      enachSuccess: statusOfMandate === "enachSuccess" ? true : (statusOfMandate === "enachFail" ? false : journeyState.enachSuccess),
      nachStatus: statusOfMandate === "nachSuccess" ? true : journeyState.nachStatus
  }

    console.log(journeyFormatData, "journeyFormatData")
    return journeyFormatData
  }
  //Code to call datalayer fn in every landing page  
  useEffect(() => {
    let journeyFormatData =  applicationDataInJourneyFormat()
    const isPaymentData = Boolean(props.paymentData || props.lienData)
    if (isPaymentData && ["sectionP2PPersonalDetailsSection","personalDetailsSection"].includes(sections?.[currentSectionIndex]?.sectionId)){
      return;
    }
    if (props.resumeJourneyData && currentSectionIndex === 0 && ["sectionP2PPersonalDetailsSection"].includes(sections?.[currentSectionIndex]?.sectionId)){
      return;
    }
    if (["sectionP2PPersonalDetailsSection"].includes(sections?.[currentSectionIndex]?.sectionId)){
      const events = window.dataLayer
      if (events && events.length > 0){
        let lastManualEvent = null;
        for (let i = events.length - 1; i >= 0; i--) {
          if (events[i]?.ProductName) {
            lastManualEvent = events[i];
            break;
          }
        }
        if (lastManualEvent?.event === "P2P_Buy_ChooseYourPlan_Back"){
          DataLayerIntegration(journeyFormatData,"",sections?.[currentSectionIndex]?.sectionId,"secondPageLanded", journeyState)
          return;
        }
      }
    }
    if (["sectionBookSlot"].includes(sections?.[currentSectionIndex]?.sectionId)){
      if (!tpaState.medicalType || !tpaState.tpaName){
        return;
      }
    }

    if (["sectionBookSlotSA"].includes(sections?.[currentSectionIndex]?.sectionId)){
      if (!tpaStateSA.medicalType || !tpaStateSA.tpaName){
        return;
      }
    }

    if(!journeyState.journeyId){
      DataLayerIntegration(journeyFormatData,"",sections?.[currentSectionIndex]?.sectionId,"landing", journeyState)
    }else{
      DataLayerIntegration(journeyFormatData, "landing", sections?.[currentSectionIndex]?.sectionId, "", journeyState)
    }
   }, [currentSectionIndex])

  //Code to scroll to top
  useEffect(() => {
    window.scroll(0,0);
  }, [currentSectionIndex])

  useEffect(() => {
    if (window && window.location){
      const queryString = window.location.search;
      const searchParams = new URLSearchParams(queryString);
      const utms = {};
  
      for (const [key, value] of searchParams.entries()) {
        if (key.startsWith('utm_')) {
          utms[key] = value;
        }
      }
      setUtmParams(utms);
    }
  },[])

  //Code for decryptData
  useEffect(() => {
    //case of redirection from bank source
    if(props.decryptData){
      setPageState(props.decryptData?.journeyPayload[0])
      setSectionState(prev => {
        return ({
          ...prev,
          sectionId: props.decryptData?.journeyPayload[0].pageData[0].sectionId,
          sectionFirstPass: true,
          sectionData: {...prev.sectionData, ...props.decryptData?.journeyPayload[0].pageData[0].sectionData}
        })
      })

      setJourneyState(prev => {
        return({
          ...prev,
          subChannel: props.decryptData?.subChannel,
          planName: props.decryptData?.planName
        })
      })
    }
    // const urlParams = new URLSearchParams(window.location.search)
    // let urlPart  =window.location.search.toLowerCase()
    // if(urlPart.includes('hsbc')){
    //   document.body.style.backgroundColor = "#ededed";
    // }
  }, [])

  //Code for redirection from payment page
  useEffect(() => {
    //case of redirection from payment page
    let lastPage
    let status
    if (props.paymentData && props.paymentData.payloadJson) {
      status = props.paymentData.payloadJson.status
      let payloadForSaveTransaction = {
        journeyId: props.paymentData.payloadJson.journeyId,
        ...props.paymentData.decryptData
      }
      console.log(payloadForSaveTransaction, "payloadForSaveTransaction-redirectCase")
      saveTransactionDetails(payloadForSaveTransaction).then((res) => {
        console.log("save transaction details 'res'")
        let payload = {
          _id: props.paymentData.payloadJson.journeyId
        }
        fetchApplicationDetails(payload)
          .then(res => {
            const biJsonFirstYear = res?.journeyData?.productDetails?.BIJson
              ? JSON.parse(res.journeyData.productDetails.BIJson)[0]
              : {}

            const dataLayerObj = {
              annualPremiumEquivalent:
                res?.journeyData?.productDetails?.annulizedPremium ??
                biJsonFirstYear?.ANN_PREM_PAYABLE_BASE ??
                "",
              premium:
                res?.journeyData?.productDetails?.premWithOutTax != null
                  ? Math.floor(
                      res.journeyData.productDetails.premWithOutTax
                    ).toString()
                  : biJsonFirstYear?.MODAL_PREM ?? "",
              totalPremium:
                res?.journeyData?.productDetails?.paymentKey ??
                biJsonFirstYear?.MODAL_PREM_TAX ??
                "",
              proceedWith : res?.journeyData?.lifeAssuredDetails?.proceedWith || ""
            }
            // Save to sessionStorage
            sessionStorage.setItem("dataLayer", JSON.stringify(dataLayerObj))
            sessionStorage.setItem("isResidentDetailsSubmitted", true)
            sessionStorage.setItem("isNomineeDetailsSubmitted", true)
            sessionStorage.setItem("isCustomiseDetailsSubmitted",true)
            sessionStorage.setItem("isSpouseDetailsSubmitted",true)
            
            lastPage = res.journeyData.lastPage
            let temp = journeyState.journeySteps
            let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "makePayment")
            let pageShowWithTransactionStatus
            if (status === "Success") {
              pageShowWithTransactionStatus = temp.pages[tempPageIndexToChange].sections.filter(element => { return (element.sectionId !== "unsuccessful-transaction" && element.sectionId !== "pending-transaction" && element.sectionId !== "pending-transaction-basba") })
            } else if (status === "Pending") {
              pageShowWithTransactionStatus = temp.pages[tempPageIndexToChange].sections.filter(element => { return (element.sectionId !== "unsuccessful-transaction" && element.sectionId !== "successful-transaction" && element.sectionId !== "pending-transaction-basba") })
            } else if (status === "Failed") {
              pageShowWithTransactionStatus = temp.pages[tempPageIndexToChange].sections.filter(element => { return (element.sectionId !== "successful-transaction" && element.sectionId !== "pending-transaction" && element.sectionId !== "pending-transaction-basba") })
            }
           temp.pages[tempPageIndexToChange].sections = pageShowWithTransactionStatus
           // Make payment page remove for canaraPos 
           if (props?.resumeJourneyData?.journeyData?.journeyType?.toLowerCase() === "canarapos") {
            const pageIndex = temp.pages.findIndex(page => page.pageId === "makePayment");
            temp.pages[pageIndex].sections = temp.pages[pageIndex].sections.filter(
              section => section.sectionId === "eNach-physicalMandate"
            )          } else {
            // Remove SCR section for normal journey
            const pageIndex = temp.pages.findIndex(page => page.pageId === "uploadDocuments");
            temp.pages[pageIndex].sections = temp.pages[pageIndex].sections.filter(section => section.sectionId !== "salesConfidentialReport");
          }

            /*Helper Function  For RMJourney Freeze State*/
            const changeJourneySteps = (pageId, sectionId, componentGroup, componentFormControlKey, key, value) => {
              try {
                let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
                let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
                let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentGroup)
                let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === componentFormControlKey)
                console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "======>ImpTemp0")
                temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange][key] = value
              } catch (err) {
                console.log(err, "=====>ErrorInPage.js===Line-152")
              }
            }
            let fillProposalPageId
            let firstPageId
            if(journeyState.journeyIdFromStrapi === "iSelectJourney"){
                fillProposalPageId = "fillProposalForm"
                firstPageId = "calculatePremiumPage"
            }else if(journeyState.journeyIdFromStrapi === "ISelect360Journey"){
                fillProposalPageId = "pageISelect360FillProposalForm"
                firstPageId = "PageISelect360CalculatePremium"
            }else if(journeyState.journeyIdFromStrapi === "Promise2ProtectJourney"){
              fillProposalPageId = "pageISelect360FillProposalForm"
              firstPageId = "PageP2PCalculatePremium"
             } else {
              return
            }
            if (res.journeyData?.agentDetails?.rmLedJourneyInd === "01") {
              changeJourneySteps(firstPageId, "CPPersonalDetailsSection", "contactNo", "contactCountryCode", "disabled", true)
              
              if(journeyState.journeyIdFromStrapi === "iSelectJourney"){
              changeJourneySteps(firstPageId, "CPResidentAndOccupationDetailSection", "CPResidentAndOccupationDetail", "country", "disabled", true)
              changeJourneySteps(firstPageId, "CPResidentAndOccupationDetailSection", "CPResidentAndOccupationDetail", "state", "lookupKey", "state_RM")
              }else if(journeyState.journeyIdFromStrapi === "ISelect360Journey"){
                changeJourneySteps(firstPageId, "iSelect360CPResidentAndOccupationDetailSection", "iSelect360CPResidentAndOccupationDetail", "country", "disabled", true)
                changeJourneySteps(firstPageId, "iSelect360CPResidentAndOccupationDetailSection", "iSelect360CPResidentAndOccupationDetail", "state", "lookupKey", "state_RM")
              }else if(journeyState.journeyIdFromStrapi === "Promise2ProtectJourneyey"){
                changeJourneySteps(firstPageId, "P2PCPResidentAndOccupationDetailSection", "P2PPlanCPResidentAndOccupationDetail", "country", "disabled", true)
                changeJourneySteps(firstPageId, "P2PCPResidentAndOccupationDetailSection", "P2PPlanCPResidentAndOccupationDetail", "state", "lookupKey", "state_RM")
              }

              changeJourneySteps(fillProposalPageId, "personalDetailsSection", "alternateMobileNo", "AlternateMobCountryCode", "disabled", false)

              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentStatus", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialCountryOfBirth", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialCitizenship", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialNationality", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialTaxResidentialCountry", "disabled", true)

              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "permanentResidentialDetails", "PRCountry", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "permanentResidentialDetails", "PRState", "lookupKey", "state_RM")
            }
            setJourneyState(prev => {
              return ({
                ...prev,
                journeySteps: temp,
                journeyData: res.applicationData,
                journeyId: props.paymentData.payloadJson.journeyId,
                applicationNo: props.paymentData.payloadJson.applicationNumber,
                paymentDecryptData: props.paymentData.decryptData,
                paymentStep: res?.journeyData?.paymentStep,
                premium: res?.journeyData?.premium,
                channel: props.paymentData.payloadJson.source,
                showLaTeleMer:props.journeyData?.basicDetails?.showLaTeleMer,
                showSpTeleMer:props.journeyData?.basicDetails?.showSpTeleMer,
                dedupeResult: res?.journeyData?.lifeAssuredDetails?.matchTypeDedupe,
                premiumOption: res?.journeyData?.basicDetails?.premiumOption,
                lastPage: lastPage,
                lastSection: res?.journeyData?.lastSection,
                //patch keys here
                //corpDiscOpt: res?.journeyData?.corporateDiscountInd
              })
            })
            // DataLayerIntegration(res.journeyData, "", "successful-transaction", "landing", journeyState)
            props.setCurrentPageIndex(lastPage)
            setCurrentSectionIndex(0)
            setConditionState(prev => {
              return {
                ...prev,
                ...res?.conditionData
              }
            })
            // setFirstPassForFreezingDataSections({
            //   "personalDetailsSection": false,
            //   "residenceDetailsSection": false,
            //   "professionalDetailSection": false
            // })
          })
      })
    }
  }, [props.paymentData])

     //case of redirection from digilocker page
     useEffect(() => {
      //case of redirection from digilocker page
      if (props.digilockerdata && props.digilockerdata.digilockerPayloadJson && props.digilockerdata.digilockerDecryptData) {
          let payload = {
            _id: props.digilockerdata.digilockerPayloadJson.journeyId
          }
          fetchApplicationDetails(payload)
            .then(async res => {
              try {
                let data = await digilocker(props.digilockerdata.digilockerDecryptData)
              }catch(err){
                console.log(err)
              }finally{
                setJourneyState(prev => {
                  return ({
                    ...prev,
                    journeyData: res.applicationData,
                    journeyId: props?.digilockerdata?.digilockerPayloadJson?.journeyId,
                    applicationNo: props?.digilockerdata?.digilockerPayloadJson?.applicationNumber,
                    paymentStep: res?.journeyData?.paymentStep,
                    premium: res?.journeyData?.premium,
                    digiLockerOption: props?.digilockerdata?.digilockerDecryptData?.option,
                    channel: props?.digilockerdata?.digilockerPayloadJson?.source
                  })
                })
                props.setCurrentPageIndex(4)
                const temp = journeyState?.journeySteps
                const tempPageIndex = temp?.pages?.findIndex(page => page.pageId === "uploadDocuments")
                const tempSectionIndex = temp?.pages[tempPageIndex]?.sections?.findIndex(section => section.sectionId === "UploadDocuments")
                setCurrentSectionIndex(tempSectionIndex !== -1 ? tempSectionIndex : 1)
              }
            })

      }
    }, [props.digilockerdata])

  //Code for redirection from enach page
  useEffect(() => {
    //case of redirection from enach page
    let lastPage
    let status
    if (props.enachData && props.enachData.enachPayloadJson) {
      status = props.enachData.enachPayloadJson.status
      let payloadForSaveTransaction = {
        journeyId: props.enachData.enachPayloadJson.journeyId,
        ...props.enachData.enachDecryptData
      }
      console.log(payloadForSaveTransaction, "payloadForSaveTransaction-redirectCase")
      saveEnachTransactionDetails(payloadForSaveTransaction).then((res) => {
        console.log("save transaction details 'res'")
        let payload = {
          _id: props.enachData.enachPayloadJson.journeyId
        }
        fetchApplicationDetails(payload)
          .then(res => {
            lastPage = res.journeyData.lastPage
            let temp = journeyState.journeySteps
            let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "makePayment")
            let pageShowWithTransactionStatus = temp.pages[tempPageIndexToChange].sections.filter(element => {return (element.sectionId !== "unsuccessful-transaction" &&  element.sectionId !== "successful-transaction" &&  element.sectionId !== "pending-transaction" && element.sectionId !== "pending-transaction-basba")})
            props.setCurrentPageIndex(lastPage)
            setCurrentSectionIndex(1)
            temp.pages[tempPageIndexToChange].sections = pageShowWithTransactionStatus

            // Canara POS Logic Remove SCR section for normal journey
            if(res.journeyData?.journeyType?.toLowerCase() !== "canarapos") {
              const pageIndex = temp.pages.findIndex(page => page.pageId === "uploadDocuments");
              temp.pages[pageIndex].sections = temp.pages[pageIndex].sections.filter(section => section.sectionId !== "salesConfidentialReport");
            }

            /*Helper Function  For RMJourney Freeze State*/
            const changeJourneySteps = (pageId, sectionId, componentGroup, componentFormControlKey, key, value) => {
              try {
                let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
                let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
                let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentGroup)
                let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === componentFormControlKey)
                console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "======>ImpTemp0")
                temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange][key] = value
              } catch (err) {
                console.log(err, "=====>ErrorInPage.js===Line-152")
              }
            }
            let fillProposalPageId
            let firstPageId
            if(journeyState.journeyIdFromStrapi === "iSelectJourney"){
                fillProposalPageId = "fillProposalForm"
                firstPageId = "calculatePremiumPage"
            }else if(journeyState.journeyIdFromStrapi === "ISelect360Journey"){
                fillProposalPageId = "pageISelect360FillProposalForm"
                firstPageId = "PageISelect360CalculatePremium"
            }else if(journeyState.journeyIdFromStrapi === "Promise2ProtectJourney"){
              fillProposalPageId = "pageISelect360FillProposalForm"
              firstPageId = "PageP2PCalculatePremium"
            } else {
              return
            }
            if (res.journeyData?.agentDetails?.rmLedJourneyInd === "01") {
              changeJourneySteps(fillProposalPageId, "personalDetailsSection", "alternateMobileNo", "AlternateMobCountryCode", "disabled", false)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentStatus", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialCountryOfBirth", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialCitizenship", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialNationality", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialTaxResidentialCountry", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "permanentResidentialDetails", "PRCountry", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "permanentResidentialDetails", "PRState", "lookupKey", "state_RM")
            }
            setJourneyState(prev => {
              return ({
                ...prev,
                journeySteps: temp,
                journeyData: res.applicationData,
                journeyId: props.enachData.enachPayloadJson.journeyId,
                applicationNo: props.enachData.enachPayloadJson.applicationNumber,
                paymentDecryptData: props.enachData.enachDecryptData,
                paymentStep: res?.journeyData?.paymentStep,
                premium: res?.journeyData?.basicDetails?.premium,
                channel: props.enachData.enachPayloadJson.source,
                dedupeResult: res?.journeyData?.lifeAssuredDetails?.matchTypeDedupe,
                premiumOption: res?.journeyData?.basicDetails?.premiumOption,
                lastPage: lastPage,
                lastSection: res?.journeyData?.lastSection,
                isPhysicalMandateOpt: res?.journeyData?.isPhysicalMandateOpt,
                nachStatus: res?.journeyData?.nachStatus || props.enachData.enachPayloadJson?.status

              })
            })
            setConditionState(prev => {
              return {
                ...prev,
                ...res?.conditionData
              }
            })
          })
      })
    }
  }, [props.enachData])


    //Code for redirection from lien registeration page
  useEffect(() => {
    //case of redirection from enach page
    let lastPage
    let status
    if (props.lienData && props.lienData.lienPayloadJson) {
      status = props.lienData.lienPayloadJson.status?.toLowerCase()
      let payloadForSaveTransaction = {
        journeyId: props.lienData.lienPayloadJson.journeyId,
        ...props.lienData.lienDecryptData
      }
      saveBasbaTransactionLogs(payloadForSaveTransaction).then((res) => {
        console.log("save transaction details 'res'")
        let payload = {
          _id: props.lienData.lienPayloadJson.journeyId
        }
        fetchApplicationDetails(payload)
          .then(res => {
             const biJsonFirstYear = res?.journeyData?.productDetails?.BIJson
              ? JSON.parse(res.journeyData.productDetails.BIJson)[0]
              : {}

            const dataLayerObj = {
              annualPremiumEquivalent:
                res?.journeyData?.productDetails?.annulizedPremium ??
                biJsonFirstYear?.ANN_PREM_PAYABLE_BASE ??
                "",
              premium:
                res?.journeyData?.productDetails?.premWithOutTax != null
                  ? Math.floor(
                      res.journeyData.productDetails.premWithOutTax
                    ).toString()
                  : biJsonFirstYear?.MODAL_PREM ?? "",
              totalPremium:
                res?.journeyData?.productDetails?.paymentKey ??
                biJsonFirstYear?.MODAL_PREM_TAX ??
                "",
              proceedWith : res?.journeyData?.lifeAssuredDetails?.proceedWith || ""
            }
            // Save to sessionStorage
            sessionStorage.setItem("dataLayer", JSON.stringify(dataLayerObj))
            sessionStorage.setItem("isResidentDetailsSubmitted", true)
            sessionStorage.setItem("isNomineeDetailsSubmitted", true)
            sessionStorage.setItem("isCustomiseDetailsSubmitted",true)
            sessionStorage.setItem("isSpouseDetailsSubmitted",true)
            
            let temp = journeyState.journeySteps
            lastPage = res.journeyData.lastPage
              // remove scr from normal journey
              let pageIndex = temp.pages.findIndex(page => page.pageId === "uploadDocuments");
              if(pageIndex && pageIndex!==-1){
                temp.pages[pageIndex].sections = temp.pages[pageIndex].sections.filter(section => section.sectionId !== "salesConfidentialReport");
              }
            let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "makePayment")
            let pageShowWithTransactionStatus = temp.pages[tempPageIndexToChange].sections.filter(element => { return (element.sectionId !== "unsuccessful-transaction" && element.sectionId !== "successful-transaction" && element.sectionId !== "pending-transaction") }) || [];
            let tempSectionIndex=pageShowWithTransactionStatus.findIndex(section=>section.sectionId==="pending-transaction-basba")//pending-transaction-basba 
              temp.pages[tempPageIndexToChange].sections = pageShowWithTransactionStatus
            /*Helper Function  For RMJourney Freeze State*/
            const changeJourneySteps = (pageId, sectionId, componentGroup, componentFormControlKey, key, value) => {
              try {
                let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
                let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
                let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentGroup)
                let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === componentFormControlKey)
                console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "======>ImpTemp0")
                temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange][key] = value
              } catch (err) {
                console.log(err, "=====>ErrorInPage.js===Line-152")
              }
            }
            let fillProposalPageId
            let firstPageId
            if (journeyState.journeyIdFromStrapi === "iSelectJourney") {
              fillProposalPageId = "fillProposalForm"
              firstPageId = "calculatePremiumPage"
            } else if (journeyState.journeyIdFromStrapi === "ISelect360Journey") {
              fillProposalPageId = "pageISelect360FillProposalForm"
              firstPageId = "PageISelect360CalculatePremium"
            } else if (journeyState.journeyIdFromStrapi === "youngTermPlanJourney") {
              fillProposalPageId = "pageISelect360FillProposalForm"
              firstPageId = "PageYoungTermCalculatePremium"
            }else if (journeyState.journeyIdFromStrapi === "Promise2ProtectJourney") {
              fillProposalPageId = "pageISelect360FillProposalForm"
              firstPageId = "PageP2PCalculatePremium"
            } else {
              return
            }
            if (res.journeyData?.agentDetails?.rmLedJourneyInd === "01") {
              changeJourneySteps(fillProposalPageId, "personalDetailsSection", "alternateMobileNo", "AlternateMobCountryCode", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentStatus", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialCountryOfBirth", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialCitizenship", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialNationality", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialTaxResidentialCountry", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "permanentResidentialDetails", "PRCountry", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "permanentResidentialDetails", "PRState", "lookupKey", "state_RM")
            }
            setJourneyState(prev => {
              return ({
                ...prev,
                journeySteps: temp,
                journeyData: res.applicationData,
                journeyId: props.lienData.lienPayloadJson.journeyId,
                applicationNo: props.lienData.lienPayloadJson.applicationNumber,
                paymentDecryptData: props.lienData.enachDecryptData,
                paymentStep: res?.journeyData?.paymentStep,
                premium: res?.journeyData?.premium,
                channel: props.lienData.lienPayloadJson.source,
                dedupeResult: res?.journeyData?.lifeAssuredDetails?.matchTypeDedupe,
                premiumOption: res?.journeyData?.basicDetails?.premiumOption,
                lastPage: lastPage,
                lastSection: res?.journeyData?.lastSection,
                lienStatus: true
              })
            })
            setConditionState(prev => {
              return {
                ...prev,
                ...res?.conditionData
              }
            })
             props.setCurrentPageIndex(lastPage)
              if (tempSectionIndex !== null) {
                setCurrentSectionIndex(tempSectionIndex)
              }
          })
      })
    }
  }, [props.lienData])

  //Code for resume journey
 useEffect(() => {
  if (props.resumeJourneyData && (!journeyState.journeyId || props.resumeJourneyData?.sourceFromResumeJourney)) {
    // journey resumed
    try {
      const payload = {
        journeyId: journeyState.journeyId, 
        buttonClicked:  "Resume journey", 
      };
      updateUserTrackerDetails(payload)
        .then((response) => {
          if (response?.status) {
            console.log("UserTracker updated successfully:", response.message);
          } else {
            console.error("Error in updating UserTracker:", response?.message);
          }
        })
        .catch((error) => {
          console.error("Error in updateUserTrackerDetails API call:", error);
        })
    } catch (error) {
      console.error("Error in resumeJourney", error);
    }
    console.log(props.resumeJourneyData);
    let lastTransaction = props?.resumeJourneyData?.applicationData?.journeyData?.transactionDetails
    let srcTraceId = props?.resumeJourneyData?.applicationData?.journeyData?.transactionDetails?.srcTraceId ?? ''
    let paymentStatus = props?.resumeJourneyData?.applicationData?.journeyData?.transactionDetails?.paymentStatus ?? ''

    console.log("lastTransaction", lastTransaction)

    const resumeJourneyCall = (paymentStatus) => {
      const biJsonFirstYear = props.resumeJourneyData?.journeyData?.productDetails?.BIJson ? JSON.parse(props.resumeJourneyData?.journeyData?.productDetails?.BIJson)[0] : {}
      const dataLayerObj = {
        annualPremiumEquivalent:
          props.resumeJourneyData?.journeyData?.productDetails
            ?.annulizedPremium ?? biJsonFirstYear?.ANN_PREM_PAYABLE_BASE ?? "",
        premium:
          props.resumeJourneyData?.journeyData?.productDetails
            ?.premWithOutTax != null
            ? Math.floor(
                props.resumeJourneyData.journeyData.productDetails
                  .premWithOutTax
              ).toString()
            : biJsonFirstYear?.MODAL_PREM ?? "",
        totalPremium:
          props.resumeJourneyData?.journeyData?.productDetails?.paymentKey ?? biJsonFirstYear?.MODAL_PREM_TAX ??
          "",
        proceedWith : props.resumeJourneyData?.journeyData?.lifeAssuredDetails?.proceedWith || ""
      }

      // Save to sessionStorage
      sessionStorage.setItem("dataLayer", JSON.stringify(dataLayerObj))
      const lastPage = props?.resumeJourneyData?.journeyData?.lastPage
      const lastSection = props?.resumeJourneyData?.journeyData?.lastSection
      console.info(props.resumeJourneyData)
      if ((lastPage >= 0 && lastSection > 2) || (lastPage > 0 && lastSection >= 0)){
        sessionStorage.setItem("isResidentDetailsSubmitted", true)
      }
      if ((lastPage >= 2 && lastSection > 6) || (lastPage > 2 && lastSection >= 0)){
        sessionStorage.setItem("isNomineeDetailsSubmitted", true)
      }
      if ((lastPage >=0 && lastSection > 3) || (lastPage > 0 && lastSection >= 0)){
        sessionStorage.setItem("isCustomiseDetailsSubmitted",true)
      }
      if (lastPage > 0){
        sessionStorage.setItem("isSpouseDetailsSubmitted",true)
      } 

      if (props.resumeJourneyData?.journeyData?.paymentStatus?.toLowerCase()  === "success"){
         const transactions = props.resumeJourneyData?.transactionDetails?.transactions
         if (transactions?.length){
           const lastTransaction = transactions[transactions.length - 1]
           const isActive = lastTransaction?.mandate?.status === "active";
           const paymentDatalayerDetails = {
              order_id :lastTransaction?.receiptNo || lastTransaction?.mandateId || lastTransaction?.mandateTokenId || "",
              nachStatus: isActive ? "Success" : "",
              nachType: isActive ? "E-Mandate" : ""
            }
            sessionStorage.setItem("paymentDataLayer", JSON.stringify(paymentDatalayerDetails))
         }
      }

      if (
        props.resumeJourneyData.journeyData.lastPage !== props.currentPageIndex
      ) {
        props.setCurrentPageIndex(props.resumeJourneyData.journeyData.lastPage)
      }
      setErrorState({})
      setCurrentSectionIndex(props.resumeJourneyData.journeyData.lastSection)

      if (journeyState.journeyId !== props.resumeJourneyData.journeyData._id) {
      let temp = journeyState.journeySteps
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "makePayment")
      let pageShowWithTransactionStatus
      // handling-pending-payment
       if(props.resumeJourneyData.journeyData?.isBasbaAttempted==="Y"){
            pageShowWithTransactionStatus=temp.pages[tempPageIndexToChange].sections.filter(element => { return (element.sectionId !== "unsuccessful-transaction" && element.sectionId !== "pending-transaction" && element.sectionId !== "successful-transaction") })
            temp.pages[tempPageIndexToChange].sections = pageShowWithTransactionStatus
        }
        else{

          if(paymentStatus === "Success"){
            pageShowWithTransactionStatus = temp.pages[tempPageIndexToChange].sections.filter(element => {return (element.sectionId !== "unsuccessful-transaction" &&  element.sectionId !== "pending-transaction")})
            temp.pages[tempPageIndexToChange].sections = pageShowWithTransactionStatus
          } else if(paymentStatus === "Pending"){
            pageShowWithTransactionStatus = temp.pages[tempPageIndexToChange].sections.filter(element => {return (element.sectionId !== "unsuccessful-transaction" &&  element.sectionId !== "successful-transaction")})
            temp.pages[tempPageIndexToChange].sections = pageShowWithTransactionStatus
          } else if(paymentStatus === "Failed"){
            pageShowWithTransactionStatus = temp.pages[tempPageIndexToChange].sections.filter(element => {return (element.sectionId !== "successful-transaction" && element.sectionId !== "pending-transaction")})
            temp.pages[tempPageIndexToChange].sections = pageShowWithTransactionStatus
          } 
        }
          
      console.log("pageWithoutUnsuccessfulTransaction", pageShowWithTransactionStatus)

      // Make payment page remove for canaraPos 
      let sendCaseToCustomerFirstResume
      if(props?.resumeJourneyData?.journeyData?.journeyType?.toLowerCase() === "canarapos" && props?.resumeJourneyData?.journeyData?.canaraPosCaseType === "sendLinktosales"){
        if(props?.resumeJourneyData?.journeyData?.scrFirstPass){
          temp.pages = temp.pages.filter(page => page.pageId !== "makePayment")
          const pageIndex = temp.pages.findIndex(page => page.pageId === "uploadDocuments");
          temp.pages[pageIndex].sections = temp.pages[pageIndex].sections.filter(section => section.sectionId !== "salesConfidentialReport");
          if(props?.resumeJourneyData?.journeyData?.sendCaseToCustomerFirstResume === true){
            props.setCurrentPageIndex(2)
            setCurrentSectionIndex(0)
            sendCaseToCustomerFirstResume = false
          }
        }else{
          temp.pages = temp.pages.filter(page => page.pageId !== "pageISelect360FillProposalForm" && page.pageId !== "makePayment" && page.pageId !== "uploadDocuments")
          temp.pages.push(...lookup.sendLinktosales)
          if(props?.resumeJourneyData?.journeyData?.productDetails?.premiumFrequency === "SG"){
            temp.pages = temp.pages.filter(page => page.pageId !== "makePayment")
          }
        }
      }else 
      if (props?.resumeJourneyData?.journeyData?.journeyType?.toLowerCase() === "canarapos" && props?.resumeJourneyData?.journeyData?.productDetails?.premiumFrequency === "SG") {
        temp.pages = temp.pages.filter(
          page => page.pageId !== "makePayment"
        )
      }else if (props?.resumeJourneyData?.journeyData?.journeyType?.toLowerCase() === "canarapos") {
      const pageIndex = temp.pages.findIndex(page => page.pageId === "makePayment");
      temp.pages[pageIndex].sections = temp.pages[pageIndex].sections.filter(
        section => section.sectionId === "eNach-physicalMandate"
      )          } else {
      // Remove SCR section for normal journey
      const pageIndex = temp.pages.findIndex(page => page.pageId === "uploadDocuments");
      temp.pages[pageIndex].sections = temp.pages[pageIndex].sections.filter(section => section.sectionId !== "salesConfidentialReport");
    }
    if(props?.resumeJourneyData?.applicationData?.journeyData?.skippaymentcase){
      const pageIndex = temp.pages.findIndex(page => page.pageId === "makePayment");
      let makePaymentPageSections = temp.pages[pageIndex].sections;
      makePaymentPageSections = makePaymentPageSections.filter(section => section.sectionId === "eNach-physicalMandate");
      temp.pages[pageIndex].sections = makePaymentPageSections;
    }
       /*Helper Function  For RMJourney Freeze State*/
       const changeJourneySteps = (pageId, sectionId, componentGroup, componentFormControlKey, key , value) => {
        try{
          let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
          let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
          let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentGroup)
          let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === componentFormControlKey)
          console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "======>ImpTemp0")
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange][key] = value
        }catch(err){
          console.log(err, "=====>ErrorInPage.js===Line-152")
        } 
      }
      let fillProposalPageId
      let firstPageId
      let firstPageSectionId = "CPPersonalDetailsSection"
      if(journeyState.journeyIdFromStrapi === "iSelectJourney"){
          fillProposalPageId = "fillProposalForm"
          firstPageId = "calculatePremiumPage"
      }else if(journeyState.journeyIdFromStrapi === "ISelect360Journey"){
          fillProposalPageId = "pageISelect360FillProposalForm"
          firstPageId = "PageISelect360CalculatePremium"
      }else if(journeyState.journeyIdFromStrapi === "Promise2ProtectJourney"){
        fillProposalPageId = "pageISelect360FillProposalForm"
        firstPageId = "PageP2PCalculatePremium"
        firstPageSectionId = "sectionP2PPersonalDetailsSection"
      } else {
        return
      }
      if(props?.resumeJourneyData?.applicationData?.journeyData?.agentDetails?.rmLedJourneyInd === "01"){
        changeJourneySteps(firstPageId, "CPPersonalDetailsSection", "contactNo", "contactCountryCode", "disabled", true)

        if(journeyState.journeyIdFromStrapi === "iSelectJourney"){
          changeJourneySteps(firstPageId, "CPResidentAndOccupationDetailSection", "CPResidentAndOccupationDetail", "country", "disabled", true)
          changeJourneySteps(firstPageId, "CPResidentAndOccupationDetailSection", "CPResidentAndOccupationDetail", "state", "lookupKey", "state_RM")       
        }else if(journeyState.journeyIdFromStrapi === "ISelect360Journey"){
          changeJourneySteps(firstPageId, "iSelect360CPResidentAndOccupationDetailSection", "iSelect360CPResidentAndOccupationDetail", "country", "disabled", true)
          changeJourneySteps(firstPageId, "iSelect360CPResidentAndOccupationDetailSection", "iSelect360CPResidentAndOccupationDetail", "state", "lookupKey", "state_RM")
          changeJourneySteps(firstPageId, "iSelect360CPResidentAndOccupationDetailSection", "iSelect360CPResidentAndOccupationDetail", "residentStatus", "disabled", true)
          // For Spouse
          changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "spouseMobile-No-order-5", "countryCode", "disabled", true)
          changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "residenceCountry-order-17", "reisdentialCountry", "disabled", true)
          changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "residentStatus-order-18", "residentStatus", "disabled", true)
          changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "nationality-order-19", "residentialNationality", "disabled", true)
          changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "countryOfBirth-order-20", "residentialCountryOfBirth", "disabled", true)
        } else if(journeyState.journeyIdFromStrapi === "Promise2ProtectJourney"){
          changeJourneySteps(firstPageId, "P2PCPResidentAndOccupationDetailSection", "P2PPlanCPResidentAndOccupationDetail", "country", "disabled", true)
          changeJourneySteps(firstPageId, "P2PCPResidentAndOccupationDetailSectionungtermPlanCPResidentAndOccupationDetail", "state", "lookupKey", "state_RM")
          changeJourneySteps(firstPageId, "P2PCPResidentAndOccupationDetailSection", "P2PPlanCPResidentAndOccupationDetail", "residentStatus", "disabled", true)
          // For Spouse
          changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "spouseMobile-No-order-5", "countryCode", "disabled", true)
          changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "residenceCountry-order-17", "reisdentialCountry", "disabled", true)
          changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "residentStatus-order-18", "residentStatus", "disabled", true)
          changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "nationality-order-19", "residentialNationality", "disabled", true)
          changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "countryOfBirth-order-20", "residentialCountryOfBirth", "disabled", true)
        }

        changeJourneySteps(fillProposalPageId, "personalDetailsSection", "alternateMobileNo", "AlternateMobCountryCode", "disabled", false)

        changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentStatus", "disabled", true)
        changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialCountryOfBirth", "disabled", true)
        changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialCitizenship", "disabled", true)
        changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialNationality", "disabled", true)
        changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialTaxResidentialCountry", "disabled", true)

        changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "permanentResidentialDetails", "PRCountry", "disabled", true)
        changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "permanentResidentialDetails", "PRState", "lookupKey", "state_RM")
      }
      if(props?.resumeJourneyData?.journeyData?.lastSection === 0 && props?.resumeJourneyData?.journeyData?.lastPage === 0 && props?.resumeJourneyData?.journeyData?.lastPage === 0 && props?.resumeJourneyData?.journeyData?.basicDetails?.applicationNumber){
        changeJourneySteps(firstPageId, firstPageSectionId, "privacypolicy-MD-12-order-25", "privacyPolicy", "display", true)
      }else{
        changeJourneySteps(firstPageId, firstPageSectionId, "privacypolicy-MD-12-order-25", "privacyPolicy", "display", false)
      }

      if (props?.resumeJourneyData?.sourceFromResumeJourney) {
        let foundPageState = props.resumeJourneyData.applicationData.applicationData.filter(
            element =>
            element.pageId ===
            props.pages[props.resumeJourneyData.journeyData.lastPage].pageId
        )

        if (journeyState.journeyIdFromStrapi === "Promise2ProtectJourney"){
            const residentPageData = foundPageState[0]?.pageData?.find(page => page.sectionId === "P2PCPResidentAndOccupationDetailSection")
            let freezeCountryField = false
            let freezeAgeProofField = false
            if (residentPageData){
              freezeCountryField = residentPageData?.sectionData?.["country"] === "IN"
              freezeAgeProofField = false
            }

           Object.entries(lookup.fieldsTobeMadeUneditable["Promise2ProtectJourney"]).forEach(([pageId, sections]) => {
            Object.entries(sections).forEach(([section, fields]) => {
              fields.forEach(({ id, key, property, value }) => {
                const shouldFreeze =
                  (key === "prrofIdAge" && freezeAgeProofField) ||
                  (key === "country" && freezeCountryField) ||
                  (key !== "prrofIdAge" && key !== "country");

                if (shouldFreeze) {
                  changeJourneySteps(pageId, section, id, key, property, value);
                }
              });
            });
          });
        }
      }

      let paymentDecryptData = {
        ...props?.resumeJourneyData?.applicationData?.journeyData?.transactionDetails?.transactions[props?.resumeJourneyData?.applicationData?.journeyData?.transactionDetails?.transactions?.length -1]
      }

      console.log(paymentDecryptData, "fdgijgigfggh")
      setJourneyState(prev => {
        // console.log("journey state")
        return {
          ...prev,
          journeyId: props?.resumeJourneyData?.journeyData?._id,
          //corpDiscOpt: props?.resumeJourneyData?.journeyData?.corporateDiscountInd || "N",
          applicationNo:
            props?.resumeJourneyData?.journeyData?.basicDetails
              ?.applicationNumber,
          illustrationNumber:
            props?.resumeJourneyData?.journeyData?.basicDetails
              ?.illustrationNumber,
          proposalEntryId:
            props?.resumeJourneyData?.journeyData?.basicDetails?.proposalEntryId,
          journeyData:
            props?.resumeJourneyData?.applicationData?.applicationData,
          premium: props?.resumeJourneyData?.applicationData?.journeyData?.premium,
          paymentDecryptData: paymentDecryptData,
          proposalFormLink: props?.resumeJourneyData?.applicationData?.journeyData?.proposalFormLink,
          paymentStep: props?.resumeJourneyData?.applicationData?.journeyData?.paymentStep,
          journeySteps: temp,
          residenceDetailEmailTrigger: props?.resumeJourneyData?.applicationData?.journeyData?.residenceDetailEmailTrigger  === "true" ? true : false,
          channel: props?.resumeJourneyData?.applicationData?.journeyData?.basicDetails?.channel,
          paymentFrequency: props?.resumeJourneyData?.journeyData?.paymentFrequency ? props?.resumeJourneyData?.journeyData?.paymentFrequency : journeyState?.paymentFrequency,
          gstWaiverInd: props?.resumeJourneyData?.applicationData?.journeyData?.productDetails?.gstWaiverInd ?? "N",
          // channel: getKeyFromValueLookup("reverseChannelType", props?.resumeJourneyData?.applicationData?.journeyData?.basicDetails?.channel)?.toLowerCase()
          showLaTeleMer:props.journeyData?.basicDetails?.showLaTeleMer,
          showSpTeleMer:props.journeyData?.basicDetails?.showSpTeleMer,
          dedupeResult: props?.resumeJourneyData?.journeyData?.lifeAssuredDetails?.matchTypeDedupe,
          premiumOption: props?.resumeJourneyData?.journeyData?.basicDetails?.premiumOption,
          lastPage: props?.resumeJourneyData?.journeyData?.lastPage,
          lastSection: props?.resumeJourneyData?.journeyData?.lastSection,
          isPhysicalMandateOpt: props?.resumeJourneyData?.journeyData?.isPhysicalMandateOpt,
          nachStatus: props?.resumeJourneyData?.journeyData?.nachStatus || props?.resumeJourneyData?.journeyData?.enachTransactions?.enachStatus,
          sendCaseToCustomerFirstResume: sendCaseToCustomerFirstResume
        }
      })
      if(!(props.resumeJourneyData.journeyData.lastPage === 0 && props.resumeJourneyData.journeyData.lastSection === 0)){
        if(callBi === false){
          setCallBi(true)
        }
      }
      
      console.log(props.resumeJourneyData, "fffdf")
      setConditionState({
        ...props?.resumeJourneyData?.applicationData?.conditionData
      })
    }
    let foundPageState = props.resumeJourneyData.applicationData.applicationData.filter(
      element =>
        element.pageId ===
        props.pages[props.resumeJourneyData.journeyData.lastPage].pageId
    )
    // console.log(foundPageState, "found page")
    // console.log(foundPageState[0].pageId, pageState, "page check")
    if (foundPageState[0] && foundPageState[0].pageId !== pageState.pageId) {
      setPageState(prev => {
        // console.log("page state")
        return {
          ...prev,
          pageId: foundPageState[0].pageId,
          pageData: foundPageState[0].pageData,
        }
      })
    }
    // setSectionState({
    //   sectionId: null,
    //   sectionData: {},
    // })
    let eligibleSections = props.pages[props.resumeJourneyData.journeyData.lastPage].sections?.filter(element => {
      if (element.conditions.length === 1) {
        if (componentRenderCheck(element.conditions[0],props?.resumeJourneyData?.applicationData?.conditionData[element.conditions[0].watchKey], journeyState)){
          return element
        }
      } else if(element.conditions.length > 1){
        if(multiConditionComponentRenderCheck(element.conditions,props?.resumeJourneyData?.applicationData?.conditionData, journeyState)){
          return element
        }
      }else {
        return element
      }
    })
    console.log("dsjhfhfd=========>", eligibleSections[
      props.resumeJourneyData.journeyData.lastSection
    ]?.sectionId)
    let foundSectionState = foundPageState[0]?.pageData.filter(element => {
      if (
        element.sectionId === eligibleSections[props.resumeJourneyData.journeyData.lastSection]?.sectionId
      ) {
        return element
      }
    })
    // console.log(foundSectionState, "found section")

    if (
      foundSectionState && foundPageState[0] &&
      foundSectionState[0]?.sectionId !== sectionState.sectionId
    ) {
      setSectionState(prev => {
        // console.log("section state")
        return {
          ...prev,
          sectionId: foundSectionState[0]?.sectionId,
          sectionFirstPass: true,
          sectionData: foundSectionState[0]?.sectionData,
        }
      })
    }
    if(!(props.resumeJourneyData.journeyData.lastPage === 0 && props.resumeJourneyData.journeyData.lastSection === 0)){
      props.setShowFirstSectionFields(true)
    }
    setFirstPageAutoFillApiCall(true)
    }
    if (paymentStatus === 'Pending' || paymentStatus === 'Aborted') {
      checkPaymentStatus(srcTraceId).then((res_str) => {
        const payload = {
          "encryptedtext": res_str
        }
        try {
          if(paymentStatus === "Aborted" && !res_str){
            resumeJourneyCall(paymentStatus)
            return
          }
          paymentTextDecrypt(payload).then(res => {
            console.log(res, "paymentTextDecrypt")
            const newPaymentStatus = res.data.status || paymentStatus
            let newTransactionToBeSaved = lastTransaction.transactions[lastTransaction.transactions?.length -1]
            newTransactionToBeSaved.status = newPaymentStatus;
            let payloadForSaveTransaction = {
              journeyId: props.resumeJourneyData.journeyData._id,
              ...newTransactionToBeSaved
            }
            console.log(payloadForSaveTransaction, "payloadForSaveTransaction")
            saveTransactionDetails(payloadForSaveTransaction).then((res) => {
              console.log(res, "saveTransactionDetails")
              resumeJourneyCall(newPaymentStatus)
            })
          })
        }catch(err){
          console.log("error in fields", err)
          resumeJourneyCall(paymentStatus)
        }
        
      }).catch((err) => {
        console.log("abortedTransactionWith-NoPayment-RedirectToPaymentPage", props.resumeJourneyData.journeyData)
        resumeJourneyCall(paymentStatus);
      })
    } else {
      resumeJourneyCall(paymentStatus);
    }
  }
}, [props.resumeJourneyData])

  //code for redirection from canara pos to fna 
  useEffect(() => {
    let data = props?.canaraPosData?.canaraPosData[0]?.fnaData?.fnaDetails
    let pageId = journeyState?.journeySteps?.pages?.[0]?.pageId
    let sectionId = journeyState?.journeySteps?.pages?.[0]?.sections?.[0]?.sectionId
    if(!data){
      return
    }
    let fullname = fullNameConverter(data?.firstName, data?.middleName, data?.lastName)
    console.log(data);
    setJourneyState(prev => {
      return({
        ...prev,
        channel: "C", //By-default channel is C (CANARA) in future we have to make it dynamic,
        journeyType: "CanaraPos",
        fnaData : {
          PROPOSERFULLNAME: fullname,
          BIRTHDATE: (moment.unix(data?.birthDate).utcOffset("+05:30").format("YYYY-MM-DD")) ,
          PHONENUMBER: data?.phoneNumber ,
          EMAILID: data?.emailId ,
          ANNUALINCOME: data?.annualIncome ,
          ANNUALEXPENSES: data?.annualExpenses ,
          ANNUALDISPOSABLRINCOME: data?.annualDisposableIncome ,
          EXISTINGLIFECOVER: data?.existingLifecover ,
          LIFECOVERREQUIRED: data?.lifeCoverRequired ,
          GOALTOACHIEVE: data?.goalToAchieve ,
          TIMEHORIZON: data?.timeHorizon ,
          CAPITALPROTECTION: data?.capitalProtection ,
          PREFERREDPLAN: data?.preferredPlan
        }
      })
    })
    // setErrorState({})
    console.log(props);
    let temp = journeyState.journeySteps
    if(data?.buyingFor === "self") {
      if(journeyState.journeyIdFromStrapi === "ISelect360Journey"){
        setSectionState(prev => {
          return {
            ...prev,
            sectionFirstPass: true,
            sectionData: {
              ...prev.sectionData,
              "CPPersonalDetailName": fullname,
              "email": data?.emailId,
              "contactNumber": data?.phoneNumber,
              "contactCountryCode": data?.countryCode,
              "AnnualIncome": data?.annualIncome,
              "dob": data?.birthDate,
              "gender": lookup?.fnaGender?.[0][data.title]
            }
          }
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${pageId}.${sectionId}.CPPersonalDetailName`]: fullname,
            [`${pageId}.${sectionId}.email`]: data?.emailId,
            [`${pageId}.${sectionId}.contactNumber`]: data?.phoneNumber,
            [`${pageId}.${sectionId}.contactCountryCode`]: data?.countryCode,
            [`${pageId}.${sectionId}.AnnualIncome`]: data?.annualIncome,
            [`${pageId}.${sectionId}.dob`]: data?.birthDate,
            [`${pageId}.${sectionId}.gender`]: lookup?.fnaGender?.[0][data.title]
          }
        })
        let componentNameFreeze = temp.pages[0].sections[0].component_groups.findIndex(element => element.componentId === "CPPersonalDetailName")
        let componentEmailFreeze = temp.pages[0].sections[0].component_groups.findIndex(element => element.componentId === "email")
        let componentNumberFreeze = temp.pages[0].sections[0].component_groups.findIndex(element => element.componentId === "contactNo")
        temp.pages[0].sections[0].component_groups[componentNameFreeze].components[0]["disabled"] = true
        temp.pages[0].sections[0].component_groups[componentEmailFreeze].components[0]["disabled"] = true
        temp.pages[0].sections[0].component_groups[componentNumberFreeze].components[1]["disabled"] = true
      }
    }
    // else {
    //   if(journeyState.journeyIdFromStrapi === "ISelect360Journey"){
    //     setSectionState(prev => {
    //       return {
    //         ...prev,
    //         sectionData: {
    //           ...prev.sectionData,
    //           "GOPAslifetobeAssuredandProposer": "N",
    //           "GOPAProposername": fullname,
    //           "GOPAproposerEmail": data?.emailId,
    //           "GOPAnumber": data?.phoneNumber,
    //           "GOPAproposerCode": data?.countryCode,
    //           "GOPAproposerAnnualIncome": data?.annualIncome,
    //           "GOPAproposerDateOfBirth": data?.birthDate,
    //         }
    //       }
    //     })
    //     setConditionState(prev => {
    //       return {
    //         ...prev,
    //         [`${pageId}.${sectionId}.islifetobeAssuredandProposer`]: "N",
    //         [`${pageId}.${sectionId}.CPProposalDetailName`]: fullname,
    //         [`${pageId}.${sectionId}.proposerEmail`]: data?.emailId,
    //         [`${pageId}.${sectionId}.contactNoproposer`]: data?.phoneNumber,
    //         [`${pageId}.${sectionId}.proposerNumber`]: data?.countryCode,
    //         [`${pageId}.${sectionId}.proposerannualIncome`]: data?.annualIncome,
    //         [`${pageId}.${sectionId}.propserdateOfBirth`]: data?.birthDate,
    //       }
    //     })
    //     let componentToBeChange = temp.pages[0].sections[0].component_groups.findIndex(element => element.componentId === "GOPAproposerDetails")
    //     let componentNameFreeze = temp.pages[0].sections[0].component_groups[componentToBeChange].components.findIndex(element => element.formControlKey === "CPProposalDetailName")
    //     let componentEmailFreeze = temp.pages[0].sections[0].component_groups[componentToBeChange].components.findIndex(element => element.formControlKey === "proposerEmail")
    //     let componentNumberFreeze = temp.pages[0].sections[0].component_groups[componentToBeChange].components.findIndex(element => element.formControlKey === "contactNoproposer")
    //     temp.pages[0].sections[0].component_groups[componentToBeChange].components[componentNameFreeze]["disabled"] = true
    //     temp.pages[0].sections[0].component_groups[componentToBeChange].components[componentEmailFreeze]["disabled"] = true
    //     temp.pages[0].sections[0].component_groups[componentToBeChange].components[componentNumberFreeze]["disabled"] = true
    //   }
    // }
    console.log("HIIIII");
  },[props.canaraPosData])

  //hsbc NON-REM/NON-DIY Journey
  useEffect(() => {
    if(props?.hsbcBankData && props.hsbcBankData?.hsbcId){
      let data = props?.hsbcBankData
      let pageId = journeyState?.journeySteps?.pages?.[0]?.pageId
      let sectionId = journeyState?.journeySteps?.pages?.[0]?.sections?.[0]?.sectionId
      let thirdPageId = journeyState?.journeySteps?.pages?.[2]?.pageId
      let thirdSectionId = journeyState?.journeySteps?.pages?.[2]?.sections?.[0]?.sectionId
      if(!data){
        return
      }
      let fullname = fullNameConverter(data?.firstName, data?.middleName, data?.lastName)
      console.log(data);
      setJourneyState(prev => {
        return({
          ...prev,
          channel: "A",
          journeyType: "HSBC", 
          hsbcJourneyID: props.hsbcBankData?.hsbcId,
          hsbcCustomerNumber: props.hsbcBankData?.hsbcCustomerNumber,
        })
      })
      // setErrorState({})
      console.log(props);
      let temp = journeyState.journeySteps
        if(journeyState.journeyIdFromStrapi === "ISelect360Journey" || journeyState.journeyIdFromStrapi === "Promise2ProtectJourney"){
          setSectionState(prev => {
            return {
              ...prev,
              sectionData: {
                ...prev.sectionData,
                "CPPersonalDetailName": fullname,
                "email": data?.email,
                "contactNumber": data?.phone,
                "contactCountryCode": data?.countryCode,
                "dob": data?.dateOfBirth,
                "gender": data.gender,
                "laTitle": data?.title,
                "taxResidenceCountry1": data?.taxResidenceCountry1,
                "taxResidenceCountry2": data?.taxResidenceCountry2,
                "taxResidenceCountry3": data?.taxResidenceCountry3,
                "pan": data?.pan,
                "contactCountryCode": data?.phoneCountryCode
              }
            }
          })
          setConditionState(prev => {
            return {
              ...prev,
              [`${pageId}.${sectionId}.CPPersonalDetailName`]: fullname,
              [`${pageId}.${sectionId}.email`]: data?.email,
              [`${pageId}.${sectionId}.contactNumber`]: data?.phone,
              [`${pageId}.${sectionId}.contactCountryCode`]: data?.phoneCountryCode,
              // [`${pageId}.${sectionId}.contactCountryCode`]: data?.countryCode,
              [`${pageId}.${sectionId}.dob`]: data?.dateOfBirth,
              [`${pageId}.${sectionId}.gender`]: data.gender,
              [`${pageId}.${sectionId}.laTitle`]: data?.title,
              [`${thirdPageId}.${thirdSectionId}.taxResidenceCountry1`]: data?.taxResidenceCountry1,
              [`${thirdPageId}.${thirdSectionId}.taxResidenceCountry2`]: data?.taxResidenceCountry2,
              [`${thirdPageId}.${thirdSectionId}.taxResidenceCountry3`]: data?.taxResidenceCountry3,
              [`${thirdPageId}.${thirdSectionId}.pan`]: data?.pan
            }
          })
          let componentNameFreeze = temp.pages[0].sections[0].component_groups.findIndex(element => element.componentId === "CPPersonalDetailName")
          let componentEmailFreeze = temp.pages[0].sections[0].component_groups.findIndex(element => element.componentId === "email")
          let componentNumberFreeze = temp.pages[0].sections[0].component_groups.findIndex(element => element.componentId === "contactNo")
          temp.pages[0].sections[0].component_groups[componentNameFreeze].components[0]["disabled"] = true
          temp.pages[0].sections[0].component_groups[componentEmailFreeze].components[0]["disabled"] = true
          temp.pages[0].sections[0].component_groups[componentNumberFreeze].components[1]["disabled"] = true
        }
      let tempName = journeyState.journeySteps
      let componentNameFreezetempName = tempName.pages[0].sections[0].component_groups.findIndex(element => element.componentId === "CPPersonalDetailName")
      let nameComponent = tempName.pages[0].sections[0].component_groups[componentNameFreezetempName].components.findIndex(el => el.formControlKey === "CPPersonalDetailName")
      tempName.pages[0].sections[0].component_groups[componentNameFreezetempName].components[nameComponent]["regex"] = "/^[a-zA-Z .']*$/"
      setJourneyState(prev => {
        return ({
          ...prev,
          journeySteps: tempName
        })
      })
    }
  },[props.hsbcBankData])

  useEffect(() => {
    if (!nvestFilterResult && journeyState.channel) {
      getIpAddress()
        .then(res => {
          let payload = {
            ip: res.IPv4
          }
          if(refreshToken){
            let payload = {
              ProductId: journeyState.productId,
              Bank: getValueFromLookup("reverseChannelToNumber", journeyState.channel),
              journeyIdFromStrapi: journeyState.journeyIdFromStrapi
            }
            getAllInputQuotations(payload)
              .then(res => {
                if (res.status) {
                  let temp = res.data
                  let formInputsWithUnifiedKey = res.data.formInputs.filter(element => element.unified_keywordName)
                  temp.formInputs = formInputsWithUnifiedKey
                  console.log( "inside all input quotations")
                  setNvestFilterResult(temp)
                  if(res.data.optionIds){
                    setJourneyState(prev => {
                      return ({
                        ...prev,
                        optionValues: res.data.optionIds
                      })
                    })
                  }
                }
              })
              .catch(err => {
                console.log(err)
              })
          }else{
            getJWTTokenForIp(payload)
            .then(res => {
              let payload = {
                ProductId: journeyState.productId,
                Bank: getValueFromLookup("reverseChannelToNumber", journeyState.channel),
                journeyIdFromStrapi: journeyState.journeyIdFromStrapi
              }
              getAllInputQuotations(payload)
                .then(res => {
                  if (res.status) {
                    let temp = res.data
                    let formInputsWithUnifiedKey = res.data.formInputs.filter(element => element.unified_keywordName)
                    temp.formInputs = formInputsWithUnifiedKey
                    console.log( "inside all input quotations")
                    setNvestFilterResult(temp)
                    if(res.data.optionIds){
                      setJourneyState(prev => {
                        return ({
                          ...prev,
                          optionValues: res.data.optionIds
                        })
                      })
                    }
                  }
                })
                .catch(err => {
                  console.log(err)
                })
            })
          }
        })
    }
  }, [journeyState.channel])

  useEffect(() => {
    let temp = journeyState.journeySteps
    let tempPageIndex
    let tempSectionIndex
    let tempComponentGroupIndex
    let tempComponentIndex
    if(journeyState.journeyIdFromStrapi === "iSelectJourney"){
      tempPageIndex = temp.pages.findIndex(element => element.pageId === "calculatePremiumPage")
      tempSectionIndex = temp.pages[tempPageIndex].sections.findIndex(element => element.sectionId === "CPCustomizePlanSection")
      tempComponentGroupIndex = temp.pages[tempPageIndex].sections[tempSectionIndex].component_groups.findIndex(element => element.componentId === "CPCustomizePlan")
      tempComponentIndex = temp.pages[tempPageIndex].sections[tempSectionIndex].component_groups[tempComponentGroupIndex].components.findIndex(element => element.formControlKey === "CPCustomizePlanPaymentFrequency")
      if(journeyState.channel && journeyState.channel === "A"){
        temp.pages[tempPageIndex].sections[tempSectionIndex].component_groups[tempComponentGroupIndex].components[tempComponentIndex]["lookupKey"] = "premiumFrequency_withoutSinglePremium"
      }else{
        temp.pages[tempPageIndex].sections[tempSectionIndex].component_groups[tempComponentGroupIndex].components[tempComponentIndex]["lookupKey"] = "premiumFrequency"
      }
    }else if(journeyState.journeyIdFromStrapi === "ISelect360Journey"){
      tempPageIndex = temp.pages.findIndex(element => element.pageId === "PageISelect360CalculatePremium")
      tempSectionIndex = temp.pages[tempPageIndex].sections.findIndex(element => element.sectionId === "iSelect360CPCustomizePlanSection")
      tempComponentGroupIndex = temp.pages[tempPageIndex].sections[tempSectionIndex].component_groups.findIndex(element => element.componentId === "iSelect360CPCustomizePlan")
      tempComponentIndex = temp.pages[tempPageIndex].sections[tempSectionIndex].component_groups[tempComponentGroupIndex].components.findIndex(element => element.formControlKey === "iSelect360CPCustomizePlanPaymentFrequency")
      if(journeyState.channel && journeyState.channel === "A"){
        temp.pages[tempPageIndex].sections[tempSectionIndex].component_groups[tempComponentGroupIndex].components[tempComponentIndex]["lookupKey"] = "premiumFrequency_withoutSinglePremium"
      }else{
        temp.pages[tempPageIndex].sections[tempSectionIndex].component_groups[tempComponentGroupIndex].components[tempComponentIndex]["lookupKey"] = "premiumFrequency"
      }
    }else if(journeyState.journeyIdFromStrapi === "Promise2ProtectJourney"){
      tempPageIndex = temp.pages.findIndex(element => element.pageId === "PageP2PCalculatePremium")
      tempSectionIndex = temp.pages[tempPageIndex].sections.findIndex(element => element.sectionId === "P2PCPCustomizePlanSection")
      tempComponentGroupIndex = temp.pages[tempPageIndex].sections[tempSectionIndex].component_groups.findIndex(element => element.componentId === "P2PCPCustomizePlan")
      tempComponentIndex = temp.pages[tempPageIndex].sections[tempSectionIndex].component_groups[tempComponentGroupIndex].components.findIndex(element => element.formControlKey === "iSelect360CPCustomizePlanPaymentFrequency")
      if(journeyState.channel && journeyState.channel === "A"){
        temp.pages[tempPageIndex].sections[tempSectionIndex].component_groups[tempComponentGroupIndex].components[tempComponentIndex]["lookupKey"] = "premiumFrequency_withoutSinglePremium"
      }else{
        temp.pages[tempPageIndex].sections[tempSectionIndex].component_groups[tempComponentGroupIndex].components[tempComponentIndex]["lookupKey"] = "premiumFrequency"
      }
    }
   
  }, [journeyState.channel])


  //useEffect to auto Fill data for sections of fill proposal form
  useEffect(() => {
    if (props.pageId === "PageFlexiEdgeFillProposalForm"){
      if (!isFirstProposalPageCovered2.current){
        if (currentSectionIndex !== 0){
          return;
        }else{
          isFirstProposalPageCovered2.current = true
        }
      }
    }
    if(props.pageId === "calculatePremiumPage" && sections[currentSectionIndex]?.sectionId === "CPPersonalDetailsSection"){
      if(journeyState.journeyId && firstPageAutoFillApiCall){
        autoFillData("calculatePremiumPage", "CPPersonalDetailsSection")
      }
    }else if(props.pageId === "calculatePremiumPage" && sections[currentSectionIndex]?.sectionId === "CPResidentAndOccupationDetailSection"){
      autoFillData("calculatePremiumPage", "CPResidentAndOccupationDetailSection")
    }else if(props.pageId === "PageISelect360CalculatePremium" && sections[currentSectionIndex]?.sectionId === "iSelect360CPResidentAndOccupationDetailSection"){
      autoFillData("PageISelect360CalculatePremium", "iSelect360CPResidentAndOccupationDetailSection")
    }else if(props.pageId === "calculatePremiumPage" && sections[currentSectionIndex]?.sectionId === "CPCustomizePlanSection"){
      autoFillData("calculatePremiumPage", "CPCustomizePlanSection")
      if(!nvestFilterResult){
        let payload = {
          ProductId: journeyState.productId,
          Bank: getValueFromLookup("reverseChannelToNumber", journeyState.channel),
          journeyIdFromStrapi: journeyState.journeyIdFromStrapi
        }
        getAllInputQuotations(payload)
        .then(res => {
          if(res.status){
            let temp = res.data
            let formInputsWithUnifiedKey = res.data.formInputs.filter(element => element.unified_keywordName)
            temp.formInputs = formInputsWithUnifiedKey
            console.log( "inside all input quotations")
            setNvestFilterResult(temp)
            if(res.data.optionIds){
              setJourneyState(prev => {
                return ({
                  ...prev,
                  optionValues: res.data.optionIds
                })
              })
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
      }
    }else if(props.pageId === "calculatePremiumPage" && sections[currentSectionIndex]?.sectionId === "CPOptionInBuiltCoversSection"){
      autoFillData("calculatePremiumPage", "CPOptionInBuiltCoversSection")
      if(!nvestFilterResult){
        let payload = {
          ProductId: journeyState.productId,
          Bank: getValueFromLookup("reverseChannelToNumber", journeyState.channel),
          journeyIdFromStrapi: journeyState.journeyIdFromStrapi
        }
        getAllInputQuotations(payload)
        .then(res => {
          if(res.status){
            let temp = res.data
            let formInputsWithUnifiedKey = res.data.formInputs.filter(element => element.unified_keywordName)
            temp.formInputs = formInputsWithUnifiedKey
            console.log("inside all input quotations")
            setNvestFilterResult(temp)
            if(res.data.optionIds){
              setJourneyState(prev => {
                return ({
                  ...prev,
                  optionValues: res.data.optionIds
                })
              })
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
      }
    }else if(props.pageId === "calculatePremiumPage" && sections[currentSectionIndex]?.sectionId === "CPSpouseCoverDetails"){
      autoFillData("calculatePremiumPage", "CPSpouseCoverDetails")
      if(!nvestFilterResult){
        let payload = {
          ProductId: journeyState.productId,
          Bank: getValueFromLookup("reverseChannelToNumber", journeyState.channel),
          journeyIdFromStrapi: journeyState.journeyIdFromStrapi
        }
        getAllInputQuotations(payload)
        .then(res => {
          if(res.status){
            let temp = res.data
            let formInputsWithUnifiedKey = res.data.formInputs.filter(element => element.unified_keywordName)
            temp.formInputs = formInputsWithUnifiedKey
            console.log( "inside all input quotations")
            setNvestFilterResult(temp)
            if(res.data.optionIds){
              setJourneyState(prev => {
                return ({
                  ...prev,
                  optionValues: res.data.optionIds
                })
              })
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
      }
    }
    else if(props.pageId === "PageISelect360CalculatePremium" && sections[currentSectionIndex]?.sectionId === "CPPersonalDetailsSection"){
      if(journeyState.journeyId){
        autoFillData("PageISelect360CalculatePremium", "CPPersonalDetailsSection")
      }
    }
    else if(props.pageId === "PageISelect360CalculatePremium" && sections[currentSectionIndex]?.sectionId === "iSelect360CPCustomizePlanSection"){
      autoFillData("PageISelect360CalculatePremium", "iSelect360CPCustomizePlanSection")
      if(!nvestFilterResult){
        let payload = {
          ProductId: journeyState.productId,
          Bank: getValueFromLookup("reverseChannelToNumber", journeyState.channel),
          journeyIdFromStrapi: journeyState.journeyIdFromStrapi
        }
        getAllInputQuotations(payload)
        .then(res => {
          if(res.status){
            let temp = res.data
            let formInputsWithUnifiedKey = res.data.formInputs.filter(element => element.unified_keywordName)
            temp.formInputs = formInputsWithUnifiedKey
            console.log( "inside all input quotations")
            setNvestFilterResult(temp)
            if(res.data.optionIds){
              setJourneyState(prev => {
                return ({
                  ...prev,
                  optionValues: res.data.optionIds
                })
              })
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
      }
    }else if(props.pageId === "PageISelect360CalculatePremium" && sections[currentSectionIndex]?.sectionId === "iSelect360CPOptionalInBuilt"){
      autoFillData("PageISelect360CalculatePremium", "iSelect360CPOptionalInBuilt")
      if(!nvestFilterResult){
        let payload = {
          ProductId: journeyState.productId,
          Bank: getValueFromLookup("reverseChannelToNumber", journeyState.channel),
          journeyIdFromStrapi: journeyState.journeyIdFromStrapi
        }
        getAllInputQuotations(payload)
        .then(res => {
          if(res.status){
            let temp = res.data
            let formInputsWithUnifiedKey = res.data.formInputs.filter(element => element.unified_keywordName)
            temp.formInputs = formInputsWithUnifiedKey
            console.log( "inside all input quotations")
            setNvestFilterResult(temp)
            if(res.data.optionIds){
              setJourneyState(prev => {
                return ({
                  ...prev,
                  optionValues: res.data.optionIds
                })
              })
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
      }
    }else if(props.pageId === "PageISelect360CalculatePremium" && sections[currentSectionIndex]?.sectionId === "iSelect360CPSpouseCoverDetails"){
      autoFillData("PageISelect360CalculatePremium", "iSelect360CPSpouseCoverDetails")
      if(!nvestFilterResult){
        let payload = {
          ProductId: journeyState.productId,
          Bank: getValueFromLookup("reverseChannelToNumber", journeyState.channel),
          journeyIdFromStrapi: journeyState.journeyIdFromStrapi
        }
        getAllInputQuotations(payload)
        .then(res => {
          if(res.status){
            let temp = res.data
            let formInputsWithUnifiedKey = res.data.formInputs.filter(element => element.unified_keywordName)
            temp.formInputs = formInputsWithUnifiedKey
            console.log( "inside all input quotations")
            setNvestFilterResult(temp)
            if(res.data.optionIds){
              setJourneyState(prev => {
                return ({
                  ...prev,
                  optionValues: res.data.optionIds
                })
              })
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
      }
    }

    //young Term
    else if(props.pageId === "PageP2PCalculatePremium" && sections[currentSectionIndex]?.sectionId === "sectionP2PPersonalDetailsSection"){
      if(journeyState.journeyId){
        autoFillData("PageP2PCalculatePremium", "sectionP2PPersonalDetailsSection")
      }
    }else if(props.pageId === "PageP2PCalculatePremium" && sections[currentSectionIndex]?.sectionId === "P2PCPResidentAndOccupationDetailSection"){
      autoFillData("PageP2PCalculatePremium", "P2PCPResidentAndOccupationDetailSection")
    }
    else if(props.pageId === "PageP2PCalculatePremium" && sections[currentSectionIndex]?.sectionId === "P2PCPCustomizePlanSection"){
      autoFillData("PageP2PCalculatePremium", "P2PCPCustomizePlanSection")
      if(!nvestFilterResult){
        let payload = {
          ProductId: journeyState.productId,
          Bank: getValueFromLookup("reverseChannelToNumber", journeyState.channel),
          journeyIdFromStrapi: journeyState.journeyIdFromStrapi
        }
        getAllInputQuotations(payload)
        .then(res => {
          if(res.status){
            let temp = res.data
            let formInputsWithUnifiedKey = res.data.formInputs.filter(element => element.unified_keywordName)
            temp.formInputs = formInputsWithUnifiedKey
            console.log( "inside all input quotations")
            setNvestFilterResult(temp)
            if(res.data.optionIds){
              setJourneyState(prev => {
                return ({
                  ...prev,
                  optionValues: res.data.optionIds
                })
              })
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
      }
    }else if(props.pageId === "PageP2PCalculatePremium" && sections[currentSectionIndex]?.sectionId === "P2PCPOptionalInBuilt"){
      autoFillData("PageP2PCalculatePremium", "P2PCPOptionalInBuilt")
      if(!nvestFilterResult){
        let payload = {
          ProductId: journeyState.productId,
          Bank: getValueFromLookup("reverseChannelToNumber", journeyState.channel),
          journeyIdFromStrapi: journeyState.journeyIdFromStrapi
        }
        getAllInputQuotations(payload)
        .then(res => {
          if(res.status){
            let temp = res.data
            let formInputsWithUnifiedKey = res.data.formInputs.filter(element => element.unified_keywordName)
            temp.formInputs = formInputsWithUnifiedKey
            console.log( "inside all input quotations")
            setNvestFilterResult(temp)
            if(res.data.optionIds){
              setJourneyState(prev => {
                return ({
                  ...prev,
                  optionValues: res.data.optionIds
                })
              })
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
      }
    }else if(props.pageId === "PageP2PCalculatePremium" && sections[currentSectionIndex]?.sectionId === "P2PCPSpouseCoverDetails"){
      autoFillData("PageP2PCalculatePremium", "P2PCPSpouseCoverDetails")
      if(!nvestFilterResult){
        let payload = {
          ProductId: journeyState.productId,
          Bank: getValueFromLookup("reverseChannelToNumber", journeyState.channel),
          journeyIdFromStrapi: journeyState.journeyIdFromStrapi
        }
        getAllInputQuotations(payload)
        .then(res => {
          if(res.status){
            let temp = res.data
            let formInputsWithUnifiedKey = res.data.formInputs.filter(element => element.unified_keywordName)
            temp.formInputs = formInputsWithUnifiedKey
            console.log( "inside all input quotations")
            setNvestFilterResult(temp)
            if(res.data.optionIds){
              setJourneyState(prev => {
                return ({
                  ...prev,
                  optionValues: res.data.optionIds
                })
              })
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
      }
    }

    // For ISelectStar
    else if(props.pageId === "fillProposalForm" && sections[currentSectionIndex]?.sectionId === "personalDetailsSection"){
      autoFillDataAndFreeze("fillProposalForm", "personalDetailsSection")
    }
    else if(props.pageId === "fillProposalForm" && sections[currentSectionIndex]?.sectionId === "residenceDetailsSection"){
      autoFillDataAndFreeze("fillProposalForm", "residenceDetailsSection")

    }else if(props.pageId === "fillProposalForm" && sections[currentSectionIndex]?.sectionId === "professionalDetailSection"){
      autoFillDataAndFreeze("fillProposalForm", "professionalDetailSection")
    }
    else if(props.pageId === "fillProposalForm" && sections[currentSectionIndex]?.sectionId === "healthAndLifeStyleDetailSection"){
      autoFillDataAndFreeze("fillProposalForm", "healthAndLifeStyleDetailSection")
    }
    // For ISelect360
    else if(props.pageId === "pageISelect360FillProposalForm" && sections[currentSectionIndex]?.sectionId === "personalDetailsSection"){
      if (journeyState?.journeyType === "CanaraPos" || props?.resumeJourneyData?.journeyData?.journeyType === "CanaraPos"){
        autoFillData("pageISelect360FillProposalForm", "personalDetailsSection")
      }else{
        autoFillDataAndFreeze("pageISelect360FillProposalForm", "personalDetailsSection")
      }
    }
    else if(props.pageId === "pageISelect360FillProposalForm" && sections[currentSectionIndex]?.sectionId === "residenceDetailsSection"){
      if (journeyState?.journeyType === "CanaraPos" || props?.resumeJourneyData?.journeyData?.journeyType === "CanaraPos"){
        autoFillData("pageISelect360FillProposalForm", "residenceDetailsSection")
      }else{
        autoFillDataAndFreeze("pageISelect360FillProposalForm", "residenceDetailsSection")
      }

    }else if(props.pageId === "pageISelect360FillProposalForm" && sections[currentSectionIndex]?.sectionId === "sectionISelect360ProfessionalDetail"){
      if (journeyState?.journeyType === "CanaraPos" || props?.resumeJourneyData?.journeyData?.journeyType === "CanaraPos"){
        autoFillData("pageISelect360FillProposalForm", "sectionISelect360ProfessionalDetail")
      }else{
        autoFillDataAndFreeze("pageISelect360FillProposalForm", "sectionISelect360ProfessionalDetail")
      }
    }
    else if(props.pageId === "pageISelect360FillProposalForm" && sections[currentSectionIndex]?.sectionId === "healthAndLifeStyleDetailSection"){
      if (journeyState?.journeyType === "CanaraPos" || props?.resumeJourneyData?.journeyData?.journeyType === "CanaraPos"){
        autoFillData("pageISelect360FillProposalForm", "healthAndLifeStyleDetailSection")
      }else{
        autoFillDataAndFreeze("pageISelect360FillProposalForm", "healthAndLifeStyleDetailSection")
      }
    }
    else if(props.pageId === "pageISelect360FillProposalForm" && sections[currentSectionIndex]?.sectionId === "spouseQuestionnaire"){
      if (journeyState?.journeyType === "CanaraPos" || props?.resumeJourneyData?.journeyData?.journeyType === "CanaraPos"){
        autoFillData("pageISelect360FillProposalForm", "spouseQuestionnaire")
      }else{
        autoFillDataAndFreeze("pageISelect360FillProposalForm", "spouseQuestionnaire")
      }
    }

    else if(props.pageId === "pageISelect360FillProposalForm" && sections[currentSectionIndex]?.sectionId === "spouseMedicalQuestionnaire"){
      if (journeyState?.journeyType === "CanaraPos" || props?.resumeJourneyData?.journeyData?.journeyType === "CanaraPos"){
        autoFillData("pageISelect360FillProposalForm", "spouseMedicalQuestionnaire")
      }else{
        autoFillDataAndFreeze("pageISelect360FillProposalForm", "spouseMedicalQuestionnaire")
      }
    }
    else if(props.pageId === "pageISelect360FillProposalForm" && sections[currentSectionIndex]?.sectionId === "riskDetailSection"){
      if (journeyState?.journeyType === "CanaraPos" || props?.resumeJourneyData?.journeyData?.journeyType === "CanaraPos"){
        autoFillData("pageISelect360FillProposalForm", "riskDetailSection")
      }else{
        autoFillDataAndFreeze("pageISelect360FillProposalForm", "riskDetailSection")
      }
    }
    else if(props.pageId === "pageISelect360FillProposalForm" && sections[currentSectionIndex]?.sectionId === "nomineeDetailsSection"){
      if (journeyState?.journeyType === "CanaraPos" || props?.resumeJourneyData?.journeyData?.journeyType === "CanaraPos"){
        autoFillData("pageISelect360FillProposalForm", "nomineeDetailsSection")
      }else{
        autoFillDataAndFreeze("pageISelect360FillProposalForm", "nomineeDetailsSection")
      }
    }
    else if (props.pageId === "pageISelect360FillProposalForm" && sections[currentSectionIndex]?.sectionId === "iSelect360CPResidentAndOccupationDetailSection") {
      if (journeyState?.journeyType === "CanaraPos" || props?.resumeJourneyData?.journeyData?.journeyType === "CanaraPos"){
        autoFillData("pageISelect360FillProposalForm", "iSelect360CPResidentAndOccupationDetailSection")
      }else{
        autoFillDataAndFreeze("pageISelect360FillProposalForm", "iSelect360CPResidentAndOccupationDetailSection")
      }
    }

    // GuaranteedSavingJourney 
    else if(props.pageId === "PagePOSFillProposalForm" && sections[currentSectionIndex]?.sectionId === "SectionPOSFPSPersonalDetails"){
      autoFillDataAndFreeze("PagePOSFillProposalForm", "SectionPOSFPSPersonalDetails")
    }
    else if(props.pageId === "PagePOSFillProposalForm" && sections[currentSectionIndex]?.sectionId === "SectionPOSCommunicationAddress"){
      autoFillDataAndFreeze("PagePOSFillProposalForm", "SectionPOSCommunicationAddress")

    }else if(props.pageId === "PagePOSFillProposalForm" && sections[currentSectionIndex]?.sectionId === "SectionPOSOccupationDetails"){
      autoFillDataAndFreeze("PagePOSFillProposalForm", "SectionPOSOccupationDetails")
    }
    else if(props.pageId === "PagePOSFillProposalForm" && sections[currentSectionIndex]?.sectionId === "SectionPOSProposerDetails"){
      if(conditionState["PageGuaranteedSavingCalculatePremium.SectionGuaranteedSavingPersonaldetails.personalDetailLifeInsuredQuestion"] === "N"){
        autoFillDataAndFreeze("PagePOSFillProposalForm", "SectionPOSProposerDetails")
      }
    }


  }, [props.currentPageIndex, currentSectionIndex, journeyState.journeyId])

  useEffect(() => {
    let conditionStatePlanOptionKey
    if(journeyState.journeyIdFromStrapi === "iSelectJourney"){
      conditionStatePlanOptionKey = "calculatePremiumPage.CPCustomizePlanSection.CPCustomizePlanQuestionOne"
    }else if(journeyState.journeyIdFromStrapi === "ISelect360Journey"){
      conditionStatePlanOptionKey = "PageISelect360CalculatePremium.iSelect360CPCustomizePlanSection.iSelect360CPCustomizePlanQuestionOne"
    }else if(journeyState.journeyIdFromStrapi === "Promise2ProtectJourney"){
      conditionStatePlanOptionKey = "PageP2PCalculatePremium.P2PCPCustomizePlanSection.iSelect360CPCustomizePlanQuestionOne"
    }
    // else if(journeyState.journeyIdFromStrapi === "GuaranteedSavingJourney"){
    //   conditionStatePlanOptionKey = "PageGuaranteedSavingCalculatePremium.SectionGuaranteedSavingInvestmentDetails.planOption"
    // }
    else{
      return 
    }
    if(conditionState[conditionStatePlanOptionKey]){
      if(journeyState.optionValues[conditionState[conditionStatePlanOptionKey]]){
        let ptValues = journeyState.optionValues[conditionState[conditionStatePlanOptionKey]].ptValues
        if(Object.keys(ptValues).length){
          console.log("ptValues length exists")
          let lookupForPolicyTermUpto35 = JSON.parse(JSON.stringify(ptValues))
          delete lookupForPolicyTermUpto35["5"]
          delete lookupForPolicyTermUpto35["6"]
          delete lookupForPolicyTermUpto35["7"]
          delete lookupForPolicyTermUpto35["8"]
          delete lookupForPolicyTermUpto35["9"]
          // console.log(lookupForPolicyTermUpto35, "lookupForPolicyTermUpto35")
          // console.log(ptValues, "lookupForPolicyTerm")
          setJourneyState(prev => {
            return ({
              ...prev,
              policyTermLookup: ptValues,
              policyTermLookupUpto35: lookupForPolicyTermUpto35
            })
          })
        }
      }
    }else if(journeyState.planOption){
      if(journeyState.optionValues[journeyState.planOption]){
        let ptValues = journeyState.optionValues[journeyState.planOption].ptValues
        if(Object.keys(ptValues).length){
          console.log("ptValues length exists")
          let lookupForPolicyTermUpto35 = JSON.parse(JSON.stringify(ptValues))
          delete lookupForPolicyTermUpto35["5"]
          delete lookupForPolicyTermUpto35["6"]
          delete lookupForPolicyTermUpto35["7"]
          delete lookupForPolicyTermUpto35["8"]
          delete lookupForPolicyTermUpto35["9"]
         
          setJourneyState(prev => {
            return ({
              ...prev,
              policyTermLookup: ptValues,
              policyTermLookupUpto35: lookupForPolicyTermUpto35
            })
          })
        }
      }
    }
  }, [journeyState.optionValues])

  useEffect(() => {
    if (sectionState.sectionId == "iSelect360CPResidentAndOccupationDetailSection" && sectionState?.sectionData?.CPResidentAndOccupationNatureIndustries) {
      let payload = {
        "ProductId": journeyState.productId,
        "Occupation": sectionState?.sectionData?.CPResidentAndOccupationNatureIndustries,
        "journeyIdFromStrapi": journeyState.journeyIdFromStrapi
      }
      getAllInputQuotations(payload)
      .then(res => {
        console.log(res)
        if (res.status) {
          let temp = res.data
          let formInputsWithUnifiedKey = res.data.formInputs.filter(element => element.unified_keywordName)
          temp.formInputs = formInputsWithUnifiedKey
          setNvestFilterResult(temp)
          if (res.data.planOptionList) {
            setJourneyState(prev => {
              return ({
                ...prev,
                planOptionList: res.data.planOptionList,
                optionValues: res.data.optionIds
              })
            })
          }
        }
      })
      .catch(err => {
        console.log(err)
      })
    }
  }, [sectionState?.sectionData?.CPResidentAndOccupationNatureIndustries])

  function skipTPAPage(option = "LA"){
    console.log(`setting skipPage for ${option} tpa...`)
    if (option === "LA"){
      setTpaState(prev => {
        return {
          ...prev,
          skipPage: true,
        }
      })
    }else if (option === "SA"){
      setTpaStateSA(prev => {
        return {
          ...prev,
          skipPage: true,
        }
      })
    }
  }

  function handleTPA(res,option){
    const matchType = res?.data?.response?.matchType
    let tpa = res?.data?.response?.response
    if((!tpa) || (tpa && Array.isArray(tpa) && tpa.length===0)){
      skipTPAPage(option)
      return;
    }
    if (matchType === "PARTIAL" || tpa.length > 1){ // multiple tpas and partial match is out of scope for isnp system
      skipTPAPage(option)
      return;
    }else if ((matchType === "EXACT" || matchType === "NEW") && tpa.length === 1) {
      tpa = tpa[0]

      if (!["Health India","Health Assure","Gowelnext"].includes(tpa.tpaName)){
        skipTPAPage(option)
        return;
      }

      const medicalPFRS = tpa.medicalPFRS || []
      if (medicalPFRS.length > 0) {
        const tpaName = tpa.tpaName
        const medicalType = medicalPFRS[0]?.pfrGroup
        const medicalTests = medicalPFRS?.map(pfr => pfr?.pfrDesc || "")
        if (option === "LA"){
          setTpaState(prev => {
            return {
              ...prev,
              medicalTests: [...medicalTests],
              tpaName: tpaName,
              medicalType: medicalType,
              matchType: matchType,
              skipPage: false,
            }
          })
        }else if(option === "SA"){
          setTpaStateSA(prev => {
            return {
              ...prev,
              medicalTests: [...medicalTests],
              tpaName: tpaName,
              medicalType: medicalType,
              matchType: matchType,
              skipPage: false,
            }
          })
        }
      }else{
        skipTPAPage(option)
      }
    }else{
      skipTPAPage(option)
      return;
    }
  }

  const handleSATPAPage = (wishToSecure) => {
    if (!wishToSecure || wishToSecure !== "02"){
      if (tpaStateSA.isSA === null){
        let temp = journeyState.journeySteps;
        const tempPageIndexToChange = temp.pages.findIndex(page => page.pageId === "pageISelect360FillProposalForm")
        if (tempPageIndexToChange !== -1){
          const tempSectionIndexToChange = temp.pages[tempPageIndexToChange]?.sections?.findIndex(section => section.sectionId === "sectionBookSlotSA")
          if (tempSectionIndexToChange !== -1){
            setTpaStateSA(prev => {
              return {
                ...prev,
                isSA : false,
              }
            })
            console.info("Removing sa page....")
            temp.pages[tempPageIndexToChange].sections?.splice(tempSectionIndexToChange,1)
            setJourneyState(prev => { // no need to set state explicitly, direct change in state, deep copy aproach not working but following the isnp way
              return {
                ...prev,
                journeySteps : temp
              }
            })
          }
        }
      }
    }
  }

  useEffect(() => {
    if (props.pageId === "pageISelect360FillProposalForm" && sectionState?.sectionId === "nomineeDetailsSection" && !['A'].includes(journeyState.channel)){
      const payloadLA = {
        journeyId : journeyState.journeyId,
        option : "LA"
      }
      // using promise.all() or either promise.allSettled() isn't an appropriate choice here
      checkTPA(payloadLA)
      .then(res => {
        handleTPA(res,"LA")
      })
      .catch(err => {
        skipTPAPage("LA")
        console.log("err",err)
      })

      if (tpaStateSA.isSA !== false){
        setTimeout(() => {
          const payloadSA = {
            journeyId : journeyState.journeyId,
            option : "SA"
          }
          checkTPA(payloadSA)
          .then(res => {
            handleTPA(res,"SA")
          })
          .catch(err => {
            skipTPAPage("SA")
            console.log("err",err)
          })
        },2500)
        
      }
    }
  },[sectionState?.sectionId])

  // function getAge(birthDate) {
  //   var now = new Date();
  //   function isLeap(year) {
  //     return year % 4 == 0 && (year % 100 != 0 || year % 400 == 0);
  //   }
  //   // days since the birthdate    
  //   var days = Math.floor((now.getTime() - birthDate.getTime())/1000/60/60/24);
  //   var age = 0;
  //   // iterate the years
  //   for (var y = birthDate.getFullYear(); y <= now.getFullYear(); y++){
  //     var daysInYear = isLeap(y) ? 366 : 365;
  //     if (days >= daysInYear){
  //       days -= daysInYear;
  //       age++;
  //       // increment the age only if there are available enough days for the year.
  //     }
  //   }
  //   return age;
  // }

  // This UseEffect Critical Illness PP & PPP FOR LA
  useEffect(() => {
  //Built in cover options 
  if(journeyState.journeyIdFromStrapi == "ISelect360Journey" && (sectionState.sectionId == "iSelect360CPOptionalInBuilt"))
  {
    let temp = journeyState.journeySteps
    let componentIdKey 
    let policyTermKey   
    let premiumPaymentTermKey 
    if (sectionState.sectionData["iSelect360CPOptionInBuiltCI"] == "ICATC1") {
      // FOR critical illness PP
      componentIdKey = "iS360DetailsCI1"
      policyTermKey = "iS360CPCustomizePlanPolicyTermCI1"
      premiumPaymentTermKey = "iS360CPCustomizePlanPremiumPaymentTermCI1"

    } else {
       // FOR critical illness PPP
       componentIdKey = "iS360DetailsCI2"
       policyTermKey = "iS360CPCustomizePlanPolicyTermCI2"
       premiumPaymentTermKey = "iS360CPCustomizePlanPremiumPaymentTermCI2"
    }
    let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageISelect360CalculatePremium")
    let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "iSelect360CPOptionalInBuilt")
    let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentIdKey)
    let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === policyTermKey)
    let tempComponentIndexToChangePPT = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === premiumPaymentTermKey)

    temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
  
    let last_policyTerm = conditionState["PageISelect360CalculatePremium.iSelect360CPCustomizePlanSection.iSelect360CPCustomizePlanPolicyTerm"]
    let last_ppt = conditionState["PageISelect360CalculatePremium.iSelect360CPCustomizePlanSection.iSelect360CPCustomizePlanPremiumPaymentTerm"]
    let la_age = getAge(conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.dob"])
    let plan_code = conditionState["PageISelect360CalculatePremium.iSelect360CPCustomizePlanSection.iSelect360CPCustomizePlanQuestionOne"]

    if(plan_code == "ICTML" || plan_code == "ICTML1")
    {
      let ageparam= 70 - la_age
      let newpolicyTerm = ageparam >= last_policyTerm ? last_policyTerm : ageparam
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePPT]["disabled"] = false
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            [policyTermKey]: newpolicyTerm,
          },
        }
      })
   } else {
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            [policyTermKey]: last_policyTerm,
            [premiumPaymentTermKey]: last_ppt,
          },
        }
      })
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePPT]["disabled"] = true
   }
    setJourneyState(prev => {
      return ({
        ...prev,
        journeySteps: temp
      })
    })
  }
  if(journeyState.journeyIdFromStrapi == "Promise2ProtectJourney" && (sectionState.sectionId == "P2PCPOptionalInBuilt"))
  {
    let temp = journeyState.journeySteps
    let componentIdKey 
    let policyTermKey   
    let premiumPaymentTermKey 
    if (sectionState.sectionData["iSelect360CPOptionInBuiltCI"] == "IXATC1") {
      // FOR critical illness PP
      componentIdKey = "youngtermDetailsCI1"
      policyTermKey = "iS360CPCustomizePlanPolicyTermCI1"
      premiumPaymentTermKey = "iS360CPCustomizePlanPremiumPaymentTermCI1"

    } else {
       // FOR critical illness PPP
       componentIdKey = "youngTermDetailsCI2"
       policyTermKey = "iS360CPCustomizePlanPolicyTermCI2"
       premiumPaymentTermKey = "iS360CPCustomizePlanPremiumPaymentTermCI2"
    }
    let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageP2PCalculatePremium")
    let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "P2PCPOptionalInBuilt")
    let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentIdKey)
    let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === policyTermKey)
    let tempComponentIndexToChangePPT = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === premiumPaymentTermKey)

    temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
  
    let last_policyTerm = conditionState["PageP2PCalculatePremium.P2PCPCustomizePlanSection.iSelect360CPCustomizePlanPolicyTerm"]
    let last_ppt = conditionState["PageP2PCalculatePremium.P2PCPCustomizePlanSection.iSelect360CPCustomizePlanPremiumPaymentTerm"]
    let la_age = getAge(conditionState["PageP2PCalculatePremium.sectionP2PPersonalDetailsSection.dob"])
    let plan_code = conditionState["PageP2PCalculatePremium.P2PCPCustomizePlanSection.iSelect360CPCustomizePlanQuestionOne"]

    if(plan_code == "IP2PL")
    {
      let ageparam= 70 - la_age
      let newpolicyTerm = ageparam >= last_policyTerm ? last_policyTerm : ageparam
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePPT]["disabled"] = false
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            [policyTermKey]: newpolicyTerm,
          },
        }
      })
   } else {
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            [policyTermKey]: last_policyTerm,
            [premiumPaymentTermKey]: last_ppt,
          },
        }
      })
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePPT]["disabled"] = true
   }
    setJourneyState(prev => {
      return ({
        ...prev,
        journeySteps: temp
      })
    })
  }
  },[sectionState.sectionData && sectionState.sectionData["iSelect360CPOptionInBuiltCI"]])

   // This UseEffect Critical Illness PP & PPP FOR SPOUSE.
   useEffect(() => {
    //Built in cover options 
    if(journeyState.journeyIdFromStrapi == "ISelect360Journey" && (sectionState.sectionId == "iSelect360CPSpouseCoverDetails"))
    {
      let temp = journeyState.journeySteps
      let componentIdKey 
      let policyTermKey   
      let premiumPaymentTermKey 
      if(!sectionState.sectionData["iSelect360CPSpouseOptionInBuiltCI"]){
        return
      }
      if (sectionState.sectionData["iSelect360CPSpouseOptionInBuiltCI"] == "ICCSB1") {
        // FOR critical illness PP
        componentIdKey = "iS360SpouseDetailsCI1"
        policyTermKey = "iS360CPSpouseCustomizePlanPolicyTermCI1"
        premiumPaymentTermKey = "iS360CPSpouseCustomizePlanPremiumPaymentTermCI1"
  
      } else {
         // FOR critical illness PPP
         componentIdKey = "iS360SpouseDetailsCI2"
         policyTermKey = "iS360CPSpouseCustomizePlanPolicyTermCI2"
         premiumPaymentTermKey = "iS360CPSpouseCustomizePlanPremiumPaymentTermCI2"
      }
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageISelect360CalculatePremium")
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "iSelect360CPSpouseCoverDetails")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentIdKey)
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === policyTermKey)
      let tempComponentIndexToChangePPT = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === premiumPaymentTermKey)
  
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
    
      let last_policyTerm = conditionState["PageISelect360CalculatePremium.iSelect360CPCustomizePlanSection.iSelect360CPCustomizePlanPolicyTerm"]
      let last_ppt = conditionState["PageISelect360CalculatePremium.iSelect360CPCustomizePlanSection.iSelect360CPCustomizePlanPremiumPaymentTerm"]
      let spouse_age = getAge(conditionState["PageISelect360CalculatePremium.iSelect360CPSpouseCoverDetails.dob"])
      let plan_code = conditionState["PageISelect360CalculatePremium.iSelect360CPCustomizePlanSection.iSelect360CPCustomizePlanQuestionOne"]
  
      if(plan_code == "ICTML" || plan_code == "ICTML1")
      {
        if(!spouse_age){
          errorToastr("Please enter Spouse Date of Birth")
          setSectionState(prev => {
            return {
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["iSelect360CPSpouseOptionInBuiltCI"]: "",
              },
            }
          })
        }
        let ageparam= 70 - spouse_age
        let newpolicyTerm = ageparam >= last_policyTerm ? last_policyTerm : ageparam
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePPT]["disabled"] = false
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [policyTermKey]: newpolicyTerm,
            },
          }
        })
     } else {
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [policyTermKey]: last_policyTerm,
              [premiumPaymentTermKey]: last_ppt,
            },
          }
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePPT]["disabled"] = true
     }
      setJourneyState(prev => {
        return ({
          ...prev,
          journeySteps: temp
        })
      })
    } else if(journeyState.journeyIdFromStrapi == "Promise2ProtectJourney" && (sectionState.sectionId == "P2PCPSpouseCoverDetails"))
    {
      let temp = journeyState.journeySteps
      let componentIdKey 
      let policyTermKey   
      let premiumPaymentTermKey 
      if(!sectionState.sectionData["iSelect360CPSpouseOptionInBuiltCI"]){
        return
      }
      if (sectionState.sectionData["iSelect360CPSpouseOptionInBuiltCI"] == "IXCSB1") {
        // FOR critical illness PP
        componentIdKey = "youngtermSpouseDetailsCI1"
        policyTermKey = "iS360CPSpouseCustomizePlanPolicyTermCI1"
        premiumPaymentTermKey = "iS360CPSpouseCustomizePlanPremiumPaymentTermCI1"
  
      } else {
         // FOR critical illness PPP
         componentIdKey = "youngtermSpouseDetailsCI2"
         policyTermKey = "iS360CPSpouseCustomizePlanPolicyTermCI2"
         premiumPaymentTermKey = "iS360CPSpouseCustomizePlanPremiumPaymentTermCI2"
      }
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageP2PCalculatePremium")
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "P2PCPSpouseCoverDetails")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentIdKey)
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === policyTermKey)
      let tempComponentIndexToChangePPT = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === premiumPaymentTermKey)
  
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
    
      let last_policyTerm = conditionState["PageP2PCalculatePremium.P2PCPCustomizePlanSection.iSelect360CPCustomizePlanPolicyTerm"]
      let last_ppt = conditionState["PageP2PCalculatePremium.P2PCPCustomizePlanSection.iSelect360CPCustomizePlanPremiumPaymentTerm"]
      let spouse_age = getAge(conditionState["PageP2PCalculatePremium.P2PCPSpouseCoverDetails.dob"])
      let plan_code = conditionState["PageP2PCalculatePremium.P2PCPCustomizePlanSection.iSelect360CPCustomizePlanQuestionOne"]
  
      if(plan_code == "IP2PL")
      {
        if(!spouse_age){
          errorToastr("Please enter Spouse Date of Birth")
          setSectionState(prev => {
            return {
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["iSelect360CPSpouseOptionInBuiltCI"]: "",
              },
            }
          })
        }
        let ageparam= 70 - spouse_age
        let newpolicyTerm = ageparam >= last_policyTerm ? last_policyTerm : ageparam
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePPT]["disabled"] = false
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [policyTermKey]: newpolicyTerm,
            },
          }
        })
     } else {
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [policyTermKey]: last_policyTerm,
              [premiumPaymentTermKey]: last_ppt,
            },
          }
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePPT]["disabled"] = true
     }
      setJourneyState(prev => {
        return ({
          ...prev,
          journeySteps: temp
        })
      })
    }
  
    },[sectionState.sectionData && sectionState.sectionData["iSelect360CPSpouseOptionInBuiltCI"]])

  // SPOUSE Built in CCB cover options 
  useEffect(() => {
    console.log("SPOUSE Built in CCB cover options")
    // SPOUSE Built in CCB cover options 
    if(journeyState.journeyIdFromStrapi == "ISelect360Journey" && (sectionState.sectionId == "iSelect360CPSpouseCoverDetails"))
    {
      let temp = journeyState.journeySteps
  
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageISelect360CalculatePremium")
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "iSelect360CPSpouseCoverDetails")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "iSelect360CPSpouseOptionInBuiltCoversCCB")
      let tempComponentIndexToChangeDOB = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "iS360spousedobCCB")
      let tempComponentIndexToChangeGENDER = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "iS360spouseGenderCCB")
      let tempComponentIndexToChangePT = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "iS360CPSpouseCustomizePlanPolicyTermCCB")
      let tempComponentIndexToChangePPT = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "iS360CPSpouseCustomizePlanPremiumPaymentTermCCB")
       
      let isLaCCB = conditionState["PageISelect360CalculatePremium.iSelect360CPOptionalInBuilt.iSelect360CPOptionInBuiltCCB"]
      let isSPCCB = sectionState.sectionData["iSelect360CPSpouseOptionInBuiltCCB"]
     
      if(isLaCCB && (isLaCCB == "ICCSB"))
      {
        let la_dob_ccb = conditionState["PageISelect360CalculatePremium.iSelect360CPOptionalInBuilt.iS360dobCCB"]
        let la_gender_ccb = conditionState["PageISelect360CalculatePremium.iSelect360CPOptionalInBuilt.iS360GenderCCB"]
        let la_pt_ccb = conditionState["PageISelect360CalculatePremium.iSelect360CPOptionalInBuilt.iS360CPCustomizePlanPolicyTermCCB"]
        let la_ppt_ccb = conditionState["PageISelect360CalculatePremium.iSelect360CPOptionalInBuilt.iS360CPCustomizePlanPremiumPaymentTermCCB"]
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeDOB]["disabled"] = true
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeGENDER]["disabled"] = true
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePT]["disabled"] = true
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePPT]["disabled"] = true
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["iS360spousedobCCB"]: la_dob_ccb,
              ["iS360spouseGenderCCB"]: la_gender_ccb,
              ["iS360CPSpouseCustomizePlanPolicyTermCCB"]: la_pt_ccb,
              ["iS360CPSpouseCustomizePlanPremiumPaymentTermCCB"]: la_ppt_ccb,
            },
          }
        })
     } else if(isSPCCB) {
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeDOB]["disabled"] = false
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeGENDER]["disabled"] = false
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePT]["disabled"] = false
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePPT]["disabled"] = false
   }
      else {
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["iS360spousedobCCB"]: "",
              ["iS360spouseGenderCCB"]: "",
              ["iS360CPSpouseCustomizePlanPolicyTermCCB"]: "",
              ["iS360CPSpouseCustomizePlanPremiumPaymentTermCCB"]: "",
            },
          }
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeDOB]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeGENDER]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePT]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePPT]["disabled"] = false
     }
      setJourneyState(prev => {
        return ({
          ...prev,
          journeySteps: temp
        })
      })
    }
    if(journeyState.journeyIdFromStrapi == "Promise2ProtectJourney" && (sectionState.sectionId == "P2PCPSpouseCoverDetails"))
    {
      let temp = journeyState.journeySteps
  
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageP2PCalculatePremium")
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "P2PCPSpouseCoverDetails")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "P2PCPSpouseOptionInBuiltCoversCCB")
      let tempComponentIndexToChangeDOB = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "iS360spousedobCCB")
      let tempComponentIndexToChangeGENDER = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "iS360spouseGenderCCB")
      let tempComponentIndexToChangePT = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "iS360CPSpouseCustomizePlanPolicyTermCCB")
      let tempComponentIndexToChangePPT = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "iS360CPSpouseCustomizePlanPremiumPaymentTermCCB")
       
      let isLaCCB = conditionState["PageP2PCalculatePremium.P2PCPOptionalInBuilt.iSelect360CPOptionInBuiltCCB"]
      let isSPCCB = sectionState.sectionData["iSelect360CPSpouseOptionInBuiltCCB"]
     
      if(isLaCCB && (isLaCCB == "IXCSB"))
      {
        let la_dob_ccb = conditionState["PageP2PCalculatePremium.P2PCPOptionalInBuilt.iS360dobCCB"]
        let la_gender_ccb = conditionState["PageP2PCalculatePremium.P2PCPOptionalInBuilt.iS360GenderCCB"]
        let la_pt_ccb = conditionState["PageP2PCalculatePremium.P2PCPOptionalInBuilt.iS360CPCustomizePlanPolicyTermCCB"]
        let la_ppt_ccb = conditionState["PageP2PCalculatePremium.P2PCPOptionalInBuilt.iS360CPCustomizePlanPremiumPaymentTermCCB"]
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeDOB]["disabled"] = true
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeGENDER]["disabled"] = true
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePT]["disabled"] = true
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePPT]["disabled"] = true
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["iS360spousedobCCB"]: la_dob_ccb,
              ["iS360spouseGenderCCB"]: la_gender_ccb,
              ["iS360CPSpouseCustomizePlanPolicyTermCCB"]: la_pt_ccb,
              ["iS360CPSpouseCustomizePlanPremiumPaymentTermCCB"]: la_ppt_ccb,
            },
          }
        })
     } else if(isSPCCB) {
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeDOB]["disabled"] = false
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeGENDER]["disabled"] = false
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePT]["disabled"] = false
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePPT]["disabled"] = false
   }
      else {
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["iS360spousedobCCB"]: "",
              ["iS360spouseGenderCCB"]: "",
              ["iS360CPSpouseCustomizePlanPolicyTermCCB"]: "",
              ["iS360CPSpouseCustomizePlanPremiumPaymentTermCCB"]: "",
            },
          }
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeDOB]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeGENDER]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePT]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePPT]["disabled"] = false
     }
      setJourneyState(prev => {
        return ({
          ...prev,
          journeySteps: temp
        })
      })
    }
  
    },[sectionState.sectionData && sectionState.sectionData["iSelect360CPSpouseOptionInBuiltCCB"]])
      // Fetch P2P Business Rules Configuration from Database
  useEffect(() => {
    if (journeyState?.journeyIdFromStrapi === "Promise2ProtectJourney") {
      getConfigurationsByType({ type: "p2p-business-rules" })
        .then(res => {
          const config = res?.data?.[0]?.config || null
          setP2pBusinessRulesConfig(config)
        })
        .catch(err => {
          console.error("Failed to fetch P2P business rules config", err)
        })
    }
  }, [journeyState?.journeyIdFromStrapi])

  useEffect(() => {
    validateP2PBusinessRulesHandler()
  }, [sectionState.sectionData?.CPResidentAndOccupationType])

  // Simple effect: Reapply P2P conditions if they're missing (whenever journeySteps changes)
  useEffect(() => {
    if (journeyState?.journeyIdFromStrapi === "Promise2ProtectJourney" && 
        p2pBusinessRulesConfig?.channelCode && 
        journeyState?.journeySteps) {
      
      const component = journeyState.journeySteps.pages
        .find(page => page.pageId === "PageP2PCalculatePremium")
        ?.sections.find(section => section.sectionId === "sectionP2PPersonalDetailsSection")
        ?.component_groups.find(cg => cg.componentId === "CFAreYouNiftyOrGovEmployee")
      
      const hasConditions = component?.conditions?.some(
        cond => cond.watchKey === "channel" && cond.journeyContextCheck === true
      )
      
      // If conditions are missing, reapply them
      if (!hasConditions) {
        setJourneyState(prev => ({
          ...prev,
          journeySteps: patchP2PSteps(prev.journeySteps, p2pBusinessRulesConfig)
        }))
      }
    }
  }, [journeyState?.journeySteps, p2pBusinessRulesConfig, journeyState?.journeyIdFromStrapi])

  // Update section state on section change for P2P occupation freezing
  useEffect(() => {
    if (
      journeyState?.journeyIdFromStrapi === "Promise2ProtectJourney" &&
      p2pBusinessRulesConfig &&
      (sections[currentSectionIndex]?.sectionId === "P2PCPResidentAndOccupationDetailSection" ||
       sections[currentSectionIndex]?.sectionId === "sectionP2PPersonalDetailsSection")
    ) {
      const validationResult = validateP2PBusinessRules(
        conditionState,
        props.pageId,
        "sectionP2PPersonalDetailsSection",
        "P2PCPResidentAndOccupationDetailSection",
        journeyState?.channel,
        p2pBusinessRulesConfig
      )

      let temp = JSON.parse(JSON.stringify(journeyState.journeySteps))
      const changeJourneySteps = (pageId, sectionId, componentGroup, componentFormControlKey, key, value) => {
        try {
          let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
          if (tempPageIndexToChange === -1) return
          let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
          if (tempSectionIndexToChange === -1) return
          let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentGroup)
          if (tempComponentGroupIndexToChange === -1) return
          let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === componentFormControlKey)
          if (tempComponentIndexToChange !== -1) {
            temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange][key] = value
          }
        } catch (err) {
          console.log(err, "=====>ErrorInPage.js===P2POccupationFreezeUnfreeze")
        }
      }

      // Handle occupation field freezing (only if no validation errors)
      if (
        validationResult.shouldFreezeOccupation && 
        validationResult.frozenOccupationValue &&
        !validationResult.errors["CPResidentAndOccupationType"]
      ) {
        // Freeze occupation field
        changeJourneySteps(
          props.pageId,
          "P2PCPResidentAndOccupationDetailSection",
          "P2PPlanCPResidentAndOccupationDetail",
          "CPResidentAndOccupationType",
          "disabled",
          true
        )

        // Set occupation value to Salaried in section state if not already set
        // update:  set it everytime if frozen
          setSectionState(prev => ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              CPResidentAndOccupationType: validationResult.frozenOccupationValue
            }
          }))

          // Update condition state
          setConditionState(prev => ({
            ...prev,
            [`${props.pageId}.P2PCPResidentAndOccupationDetailSection.CPResidentAndOccupationType`]: validationResult.frozenOccupationValue
          }))

        // Update journey steps
        setJourneyState(prev => ({
          ...prev,
          journeySteps: temp
        }))
      } else {
        // Unfreeze occupation field and clear value
        changeJourneySteps(
          props.pageId,
          "P2PCPResidentAndOccupationDetailSection",
          "P2PPlanCPResidentAndOccupationDetail",
          "CPResidentAndOccupationType",
          "disabled",
          false
        )

        // Clear occupation value in section state if it was previously frozen
        if (sectionState.sectionData?.CPResidentAndOccupationType) {
          setSectionState(prev => ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              CPResidentAndOccupationType: ""
            }
          }))

          // Clear condition state
          setConditionState(prev => ({
            ...prev,
            [`${props.pageId}.P2PCPResidentAndOccupationDetailSection.CPResidentAndOccupationType`]: ""
          }))
        }

        // Update journey steps
        setJourneyState(prev => ({
          ...prev,
          journeySteps: temp
        }))
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sections[currentSectionIndex]?.sectionId, journeyState?.journeyIdFromStrapi, p2pBusinessRulesConfig])

    useEffect (()=>{
      let temp = journeyState.journeySteps
      let pageId = ""
      let sectionId = ""
      let contactNumberComponentId = ""
      let contactNumberFormControlKey = ""
      let countryCodeFormControlKey = ""

      if (journeyState.journeyIdFromStrapi === "ISelect360Journey"){
        pageId = "PageISelect360CalculatePremium"
        sectionId = "CPPersonalDetailsSection"
        contactNumberComponentId = "contactNo"
        contactNumberFormControlKey = "contactNumber"
        countryCodeFormControlKey = "contactCountryCode"
      }else if (journeyState.journeyIdFromStrapi === "youngTermPlanJourney"){
        pageId = "PageYoungTermCalculatePremium"
        sectionId = "sectionYoungTermPersonalDetailsSection"
        contactNumberComponentId = "contactNo"
        contactNumberFormControlKey = "contactNumber"
        countryCodeFormControlKey = "contactCountryCode"
      }else if (journeyState.journeyIdFromStrapi === "Promise2ProtectJourney"){
        pageId = "PageP2PCalculatePremium"
        sectionId = "sectionP2PPersonalDetailsSection"
        contactNumberComponentId = "contactNo"
        contactNumberFormControlKey = "contactNumber"
        countryCodeFormControlKey = "contactCountryCode"
      }
 
      if(sectionState?.sectionData?.[countryCodeFormControlKey] != '+91'){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === contactNumberComponentId)
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === contactNumberFormControlKey)
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 9
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 15
      }
      else if(sectionState?.sectionData?.[countryCodeFormControlKey]== '+91'){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === contactNumberComponentId)
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === contactNumberFormControlKey)
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 10
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 10
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = "/(?!9999999999|8888888888|7777777777|6666666666)(^[6-9][0-9]{9}$)/"
      }
  
      if(sectionState?.sectionData?.AlternateMobCountryCode != "+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "pageISelect360FillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "personalDetailsSection")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "alternateMobileNo")
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "AlternateMobNumber")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 9
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 15
      }
      else if(sectionState?.sectionData?.AlternateMobCountryCode == "+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "pageISelect360FillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "personalDetailsSection")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "alternateMobileNo")
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "AlternateMobNumber")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 10
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = "/(?!9999999999|8888888888|7777777777|6666666666)(^[6-9][0-9]{9}$)/"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 10
      }
  
      if(sectionState?.sectionData?.contactCountryCode != "+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "pageISelect360FillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "personalDetailsSection")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "contactNo")
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "contactNumber")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 9
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 15
      }
      else if(sectionState?.sectionData?.contactCountryCode == "+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "pageISelect360FillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "personalDetailsSection")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "contactNo")
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "contactNumber")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 10
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = "/(?!9999999999|8888888888|7777777777|6666666666)(^[6-9][0-9]{9}$)/"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = "E168"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 10
      }
  
  
      setJourneyState(prev => {
        return ({
          ...prev,
          journeySteps: temp
        })
      })
 
  },[sectionState?.sectionData?.["contactCountryCode"], sectionState?.sectionData?.["AlternateMobCountryCode"]])




  
  


  /*Helper Functions Start*/
  function removeEmptyValues(obj){
    return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v.length !== 0));
   }
  //Code to fill data on API call
  const autoFillData = async (pageId, sectionId) => {
    let payload = {
      _id: journeyState.journeyId,
    }
    fetchApplicationDetails(payload)
    .then( async res => {
      let fetchedPageIndex = res.applicationData.findIndex(element => element.pageId === pageId)
      if(fetchedPageIndex !== -1){
      let fetchedSectionIndex = res.applicationData[fetchedPageIndex].pageData.findIndex(element => element.sectionId === sectionId)
      if(fetchedSectionIndex !== -1){
        let valueObject = {}
        let conditionObject = {}
        let requiredSectionData = res.applicationData[fetchedPageIndex].pageData[fetchedSectionIndex].sectionData
        Object.keys(requiredSectionData).forEach(element => {
          if(requiredSectionData[element]){
            valueObject[element] = requiredSectionData[element]
            conditionObject[`${pageId}.${sectionId}.${element}`] = requiredSectionData[element]
          }
        })
        valueObject = removeEmptyValues(valueObject)
        console.log(valueObject, "value object")
        console.log(conditionObject, "condition object")
        setConditionState(prev => {
          return {
            ...prev,
            ...conditionObject
          }
        })
        if (sectionId === "nomineeDetailsSection") {
          let tempNomineeTitle = []
          if (valueObject["nomineeFullNameTitle"] === undefined || valueObject["nomineeFullNameTitle"].length === 0){
            // tempNomineeTitle[0] = "MR"
            valueObject["nomineeFullNameTitle"] = tempNomineeTitle
          }
          
          let tempNomineeCountryCode = []
          tempNomineeCountryCode[0] = "+91"
          
          // valueObject["nomineeCountryCode"] = tempNomineeCountryCode
          let tempNomineeGender = []
          tempNomineeGender[0] = "M"
          valueObject["gender"] = tempNomineeGender
        }
        if(sectionId === "iSelect360CPOptionalInBuilt" || sectionId === "iSelect360CPSpouseCoverDetails" || sectionId === "P2PCPOptionalInBuilt" || sectionId === "P2PCPSpouseCoverDetails"){
          setSectionState(prev => {
            return {
              ...prev,
              sectionId: sectionId,
              sectionData: {
                ...valueObject
              }
            }
          })
        }else{
          setSectionState(prev => {
            return {
              ...prev,
              sectionId: sectionId,
              sectionFirstPass: true,
              sectionData: {
                ...prev.sectionData,
                ...valueObject
              }
            }
          })
        }
       
        let lookupKeyForTitle = "title"
        if(valueObject["gender"] === "M"){
          valueObject["fullNameTitle"] = "MR"
          conditionObject[`${pageId}.${sectionId}.fullNameTitle`] = "MR"
        }else if(valueObject["gender"] === "F"){
            valueObject["fullNameTitle"] =  valueObject["fullNameTitle"]? valueObject["fullNameTitle"] :""
            lookupKeyForTitle = "title-female"
        }

        if(sectionId === "CPResidentAndOccupationDetailSection" || sectionId === "iSelect360CPResidentAndOccupationDetailSection" || sectionId === "P2PCPResidentAndOccupationDetailSection"){
          if(journeyState.residenceDetailEmailTrigger === false){
            let sendEmailPayload ={
              journeyId: journeyState.journeyId,
              module: "QUOTESMSEMAIL",
              residenceDetailEmailTrigger: true
            }
            // sendEmailBI(sendEmailPayload).then(res => {
            //   console.log(res, "emailRes")
            //   if (res?.status) {
            //     successToastr(res.message)
            //   } else {
            //     errorToastr(res.message)
            //   }
            // })
            setJourneyState(prev => {
              return ({
                ...prev,
                residenceDetailEmailTrigger: true
              })
            })
          }
          
        }

        if (pageId === "pageISelect360FillProposalForm"){
          handleSATPAPage(res?.journeyData?.productDetails?.spouseLaDetails?.wishToSecure)
        }

        if (journeyState?.journeyType === "CanaraPos" || props?.resumeJourneyData?.journeyData?.journeyType === "CanaraPos"){
          if (pageId === "pageISelect360FillProposalForm" && sectionId === "personalDetailsSection"){
            const pages = journeyState.journeySteps?.pages || []
            const tempPageIndexToChange = pages.findIndex(page => page.pageId === "pageISelect360FillProposalForm")
            const tempSectionIndexToChange = pages[tempPageIndexToChange]?.sections?.findIndex(section => section.sectionId === "personalDetailsSection")
            const tempNameComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "fullName")
            const tempNameComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempNameComponentGroupIndexToChange].components
            tempNameComponents.forEach(nameComponent => {
              if (valueObject?.[nameComponent?.formControlKey]){
                nameComponent.disabled = true;
              }
            })
            const tempEmailComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "email")
            const tempEmailComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempEmailComponentGroupIndexToChange].components
            tempEmailComponents.forEach(emailComponent => {
              if (valueObject?.[emailComponent?.formControlKey]){
                emailComponent.disabled = true;
              }
            })
            const tempContactNoComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "contactNo")
            const tempContactComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempContactNoComponentGroupIndexToChange].components
            tempContactComponents.forEach(contactComponent => {
              if (valueObject?.[contactComponent?.formControlKey]){
                contactComponent.disabled = true;
              }
            })
            const tempDOBComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "dob")
            const tempDOBComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempDOBComponentGroupIndexToChange].components
            tempDOBComponents.forEach(dobComponent => {
              if (valueObject?.[dobComponent?.formControlKey]){
                dobComponent.disabled = true;
              }
            })
            const tempIncomeComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "annualIncome")
            const tempIncomeComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempIncomeComponentGroupIndexToChange].components
            tempIncomeComponents.forEach(incomeComponent => {
              if (valueObject?.[incomeComponent?.formControlKey]){
                incomeComponent.disabled = true;
              }
            })
          }
          if (pageId === "pageISelect360FillProposalForm" && sectionId === "residenceDetailsSection"){
            const pages = journeyState.journeySteps?.pages || []
            const tempPageIndexToChange = pages.findIndex(page => page.pageId === "pageISelect360FillProposalForm")
            const tempSectionIndexToChange = pages[tempPageIndexToChange]?.sections?.findIndex(section => section.sectionId === "residenceDetailsSection")

            const tempPinCodeComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "pinCode")
            const tempPinCodeComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempPinCodeComponentGroupIndexToChange].components
            tempPinCodeComponents.forEach(pincodeComponent => {
              if (valueObject?.[pincodeComponent?.formControlKey]){
                pincodeComponent.disabled = true;
              }
            })

            const tempStateComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "state")
            const tempStateComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempStateComponentGroupIndexToChange].components
            tempStateComponents.forEach(stateComponent => {
              if (valueObject?.[stateComponent?.formControlKey]){
                stateComponent.disabled = true;
              }
            })

            const tempCityComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "city")
            const tempCityComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempCityComponentGroupIndexToChange].components
            tempCityComponents.forEach(cityComponent => {
              if (valueObject?.[cityComponent?.formControlKey]){
                cityComponent.disabled = true;
              }
            })

          }
        }

        // if(pageId === "calculatePremiumPage" && sectionId === "CPCustomizePlanSection"){
        //   let payload = {
        //     ProductId: journeyState.productId,
        //     PT: valueObject["CPCustomizePlanPolicyTerm"]
        //   }
        //   getAllInputQuotations(payload)
        //   .then(res => {
        //     if(res.status){
        //       let temp = res.data
        //       let formInputsWithUnifiedKey = res.data.formInputs.filter(element => element.unified_keywordName)
        //       temp.formInputs = formInputsWithUnifiedKey
        //       console.log( "inside all input quotations")
        //       setNvestFilterResult(temp)
        //     }
        //   })
        //   .catch(err => {
        //     console.log(err)
        //   })
        // }
        valueObject = {}
        conditionObject = {}
      }
      }
    })
  }

  //Code to fill data on API call and freeze necessary fields
  const autoFillDataAndFreeze = (pageId,sectionId) => {
     const temp = journeyState.journeySteps
    const changeJourneySteps = (pageId, sectionId, componentGroup, componentFormControlKey, key, value) => {
              try {
                let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
                let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
                let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentGroup)
                let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === componentFormControlKey)
                console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "======>ImpTemp0")
                temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange][key] = value
              } catch (err) {
                console.log(err, "=====>ErrorInPage.js===Line-152")
              }
    }
    let payload = {
      _id: journeyState.journeyId,
    }
    fetchApplicationDetails(payload)
    .then(res => {
      let fetchedPageIndex = res.applicationData.findIndex(element => element.pageId === pageId)
      if(fetchedPageIndex){
        let fetchedSectionIndex = res.applicationData[fetchedPageIndex].pageData.findIndex(element => element.sectionId === sectionId)
        if(fetchedSectionIndex !== -1){
          let valueObject = {}
          let conditionObject = {}
          let requiredSectionData = res.applicationData[fetchedPageIndex].pageData[fetchedSectionIndex].sectionData

          /* Autofillinf Data*/
          Object.keys(requiredSectionData).forEach(element => {
            if(requiredSectionData[element]){
              valueObject[element] = requiredSectionData[element]
              conditionObject[`${pageId}.${sectionId}.${element}`] = requiredSectionData[element]
            }
          })
          console.log(valueObject,conditionObject, "dcdvdv")

          /*Hardcoding for particular fields*/
          let lookupKeyForTitle = "title"
          if(valueObject["gender"] === "M"){
            valueObject["fullNameTitle"] = "MR"
            conditionObject[`${pageId}.${sectionId}.fullNameTitle`] = "MR"
          }else if(valueObject["gender"] === "F"){
              valueObject["fullNameTitle"] =  valueObject["fullNameTitle"]? valueObject["fullNameTitle"] :""
              lookupKeyForTitle = "title-female"
          }
        
            
          let lookupKeyForIdProof = "ID_PROOF"
          let lookupKeyForAddProof = "ADDRESS_PROOF"
          let lookupKeyForAddProofPermanent = "ADDRESS_PROOF"

          if (res?.journeyData?.productDetails?.spouseLaDetails?.wishToSecure === "02"){
            if (!tpaStateSA.isSA){
              setTpaStateSA(prev => {
                return {
                  ...prev,
                  isSA : true,
                }
              })
            }
          }

          if (pageId === "pageISelect360FillProposalForm"){
            handleSATPAPage(res?.journeyData?.productDetails?.spouseLaDetails?.wishToSecure)
          }
          
          if(sectionId === "personalDetailsSection"){
            if(res?.journeyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.country !== "IN"){
              valueObject["prrofIdAge"] = "01"
              conditionObject[`${pageId}.${sectionId}.prrofIdAge`] = "01"
            }
            // else{
            //   if(!(res?.journeyData?.lifeAssuredDetails?.proceedWith === "ekyc" || res?.journeyData?.lifeAssuredDetails?.proceedWith === "ckyc")){
            //     valueObject["prrofIdAge"] = "03"
            //     conditionObject[`${pageId}.${sectionId}.prrofIdAge`] = "03"
            //     lookupKeyForIdProof = "ID_PROOF_PAN"
            //   }
            // }
            if(res?.journeyData?.productDetails?.spouseLaDetails?.wishToSecure === "02"){
              valueObject["maritalStatus"] = "M"
              conditionObject[`${pageId}.${sectionId}.maritalStatus`] = "M"
            }
            
          }
          if(sectionId === "residenceDetailsSection"){
            if(res?.journeyData?.lifeAssuredDetails?.kycVerified === true || res?.journeyData?.lifeAssuredDetails?.ckycVerified === true){
              if((res?.journeyData?.lifeAssuredDetails?.proceedWith === "ekyc" || res?.journeyData?.lifeAssuredDetails?.proceedWith === "ckyc") && res?.journeyData?.lifeAssuredDetails?.addressProceedWith === "permanentAddress"){
                lookupKeyForAddProof = "ADDRESS_PROOF"
                lookupKeyForAddProofPermanent = "ADDRESS_PROOF_VERIFIED"
              }else{
                lookupKeyForAddProof = "ADDRESS_PROOF_VERIFIED"
              }
            }
          }
          /*Hardcoding for particular fields Ends*/
          if(pageId=== "pageISelect360FillProposalForm" && sectionId === "personalDetailsSection" && res?.journeyData?.agentDetails?.rmLedJourneyInd === "01"){ 
            valueObject["AlternateMobCountryCode"]="+91"
            conditionObject[`${pageId}.${sectionId}.AlternateMobCountryCode`]= "+91"
          }

            changeJourneySteps("pageISelect360FillProposalForm", "residenceDetailsSection", "residentialCountry", "residentStatus", "disabled", false)
          if(conditionState["PageP2PCalculatePremium.sectionP2PPersonalDetailsSection.contactCountryCode"]==="+91" 
            ){
              valueObject["residentialStatus"] = "N"
            }else{
              valueObject["residentialStatus"] = "Y"
            }


          setSectionState(prev => {
            return {
              ...prev,
              sectionId: sectionId,
              sectionData: {
                ...prev.sectionData,
                ...valueObject
              }
            }
          })
          setConditionState(prev => {
            return {
              ...prev,
              ...conditionObject
            }
          })
          /* AutoFillingData */

          /*Freezing Data */
          
          if(firstPassForFreezingDataSections[sectionId]){
            let temp = journeyState.journeySteps
            let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
            let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
            let componentGroups = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups
            console.log("23232323232332", componentGroups )
            componentGroups.forEach((componentGroup, componentGroupIndex) => {
              componentGroup.components.forEach((component,componentIndex) => {
                // freezeJson?.[journeyState.journeyIdFromStrapi]?.[pageId]?.[sectionId]?.forEach(element => {
                Object.keys(valueObject)?.forEach(element => {
                  if(element === component.formControlKey && element!=="residentStatus"){
                    temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = true
                  }
                  if(element === component.formControlKey && element === "profesionalOccupationEmployerOrganization"){
                    temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                  }
                  if( element === component.formControlKey && element === "fullNameTitle"){
                    console.log("23232323232332", element,tempPageIndexToChange,tempPageIndexToChange, tempPageIndexToChange,componentIndex)
                    temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupKeyForTitle
                    if(valueObject["gender"]!== "M"){
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                    }
                  }
                  if (element === component.formControlKey && element === "professionalQuestion2") {
                    temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                  }
                  if (element === component.formControlKey && (element === "fatherFirstName" || element === "fatherMiddleName" || element === "fatherLastName" || element === "motherFirstName" || element === "motherMiddleName" || element === "motherLastName")) {
                    temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                  }
                  if (element === component.formControlKey && element === "aadharNumber") {
                    console.log("23232323232332", element, tempPageIndexToChange, tempPageIndexToChange, tempPageIndexToChange, componentIndex)
                    if(valueObject["aadharNumber"]){
                    temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["regex"] = "/^[a-zA-Z0-9]+$/"
                    } 
                  }
                  if( element === component.formControlKey && element === "prrofIdAge"){
                    console.log("23232323232332", element,tempPageIndexToChange,tempPageIndexToChange, tempPageIndexToChange,componentIndex)
                    temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupKeyForIdProof
                    if(valueObject["prrofIdAge"] === "03"){
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                    }
                  }
                  if( element === component.formControlKey && element === "PRAddressProof"){
                    console.log("23232323232332", element,tempPageIndexToChange,tempPageIndexToChange, tempPageIndexToChange,componentIndex)
                    temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupKeyForAddProof
                  }
                  if(res?.journeyData?.journeyType === 'CanaraPos' && element === component.formControlKey && element === "AlternateMobNumber"){
                    temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                  }
                  if( element === component.formControlKey && element === "permanentAddressProof"){
                    console.log("23232323232332", element,tempPageIndexToChange,tempPageIndexToChange, tempPageIndexToChange,componentIndex)
                    temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupKeyForAddProofPermanent
                  }
              
                })
              })
            })

            if(sectionId === "residenceDetailsSection"){
              let fillProposalPageId
              if(journeyState.journeyIdFromStrapi === "iSelectJourney"){
                  fillProposalPageId = "fillProposalForm"
              }else if(journeyState.journeyIdFromStrapi === "ISelect360Journey" || journeyState.journeyIdFromStrapi === "Promise2ProtectJourney"){
                  fillProposalPageId = "pageISelect360FillProposalForm"
              } else {
                return
              }
              let tempPageIndexFillProposalForm = temp.pages.findIndex(element => element.pageId === fillProposalPageId)
              let tempSectionIndexFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections.findIndex(element => element.sectionId === "residenceDetailsSection")
              let tempComponentGroupFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "pinCode")
              let tempComponentFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components.findIndex(element => element.formControlKey === "pincode")
              console.log(tempPageIndexFillProposalForm, tempSectionIndexFillProposalForm, tempComponentGroupFillProposalForm, tempComponentFillProposalForm, "dfefd1278")

              if(valueObject["reisdentialCurrentCountry"] !== "IN"){
                temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["min_len"] = 1
                temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["max_length"] = 9
                temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["regex"] = "/^[a-zA-Z0-9]+$/"
                temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["__typename"] = "ComponentCmpTagTextString"
              }
            }
            if(sectionId === "spouseQuestionnaire"){
              let tempPageIndexFillProposalForm = temp.pages.findIndex(element => element.pageId === "pageISelect360FillProposalForm")
              let tempSectionIndexFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections.findIndex(element => element.sectionId === "spouseQuestionnaire")
              let tempComponentGroupNameOfEmployer = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "orgainsationName-order-13")
              let tempComponentGroupNatureOfIndustry = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "NatureOrganisation-order-14")
              let tempComponentGroupPanNumber = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "pan-order-16")
              let tempComponentNameOfEmployer = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupNameOfEmployer].components.findIndex(element => element.formControlKey === "orgainsationName")
              let tempComponentNatureOfIndustry = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupNatureOfIndustry].components.findIndex(element => element.formControlKey === "NatureOrganisation")
              let tempComponentPanNumber = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupPanNumber].components.findIndex(element => element.formControlKey === "pan")

              let spouseOccupationType = journeyState.journeyIdFromStrapi === "ISelect360Journey" ? conditionState["PageISelect360CalculatePremium.iSelect360CPSpouseCoverDetails.CPSpouseOccupationQuestion"] : conditionState["PageP2PCalculatePremium.P2PCPSpouseCoverDetails.CPSpouseOccupationQuestion"] 
              if(spouseOccupationType && (spouseOccupationType === "NW")) {
                  temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupNameOfEmployer].components[tempComponentNameOfEmployer]["required"] = false
                  temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupNatureOfIndustry].components[tempComponentNatureOfIndustry]["required"] = false
                  temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupPanNumber].components[tempComponentPanNumber]["required"] = false
                  console.log("spouseOccupationType---NW");
                  setErrorState(prev => {
                    return {
                      ...prev,
                      ["orgainsationName"]: "",
                      ["NatureOrganisation"]: "",
                      ["pan"]: "",
                    }
                  })
              } else {
                temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupNameOfEmployer].components[tempComponentNameOfEmployer]["required"] = true
                temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupNatureOfIndustry].components[tempComponentNatureOfIndustry]["required"] = true
                temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupPanNumber].components[tempComponentPanNumber]["required"] = true
                console.log("spouseOccupationType---W");
              }
              
            }
            if(sectionState.sectionData){
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionFirstPass: true,
                }
              })
            }
            setJourneyState(prev => {
              return ({
                ...prev,
                journeySteps: temp
              })
            })
          }
          setFirstPassForFreezingDataSections(prev => {
            return ({
              ...prev,
              [sectionId]: false
            })
          })
          
          valueObject = {}
        }
      }
    })
    .catch(err => {
      console.log(err)
    })
  }

  //Code to Check Nominee Percetage totals 100%
  const checkNomineePercentage = () => {
    if(sectionState.sectionData["nomineePercent"]){
      let values = sectionState.sectionData["nomineePercent"]
      if(values){
        let total
        if(values.length === 1){
          total = parseInt(values[0])
        }else{
          if(values.length>1){
            total = values?.reduce((a,b) => {
              return parseInt(a)+ parseInt(b)
            })
          }
        }
        let temp
        let temp1
        if (errorState["nomineePercent"]) {
          temp1 = errorState["nomineePercent"]
        }else{
          temp1 = []
        }
        if(total !== 100){
          const numberOfNominees = sectionState.sectionData["nomineePercent"].length
          for(let i = 0; i< numberOfNominees; i++){
            temp1[i] = "Total of Nominee Percentages must be 100"
          }
          temp = temp1
          setErrorState(prev => {
            return {
              ...prev,
              ["nomineePercent"]: temp,
            }
          })
        }else{
          const numberOfNominees = sectionState.sectionData["nomineePercent"].length
          for(let i = 0; i< numberOfNominees; i++){
            temp1[i] = ""
          }
          temp = temp1
          setErrorState(prev => {
            return {
              ...prev,
              ["nomineePercent"]: temp,
            }
          })
        }
      }
      
    }
  }

  //Code to call BI for product pages
  const saveApplicationAndCallBi = (formControlKey, value, previousSelectedValue, businessRuleKey) => {
    console.log(formControlKey, "dsfdfd")
    if(formControlKey == "iSelect360CPCustomizePlanSumAssured"){
      let changeSumAssured = parseInt(businessRuleKey)
      console.log(typeof changeSumAssured, "valueKey variable" )
      if(value > changeSumAssured){
        console.log(sectionState, "condition satisfied")
        errorToastr(`Basis your input Maximum sum assured can be offered up to ${changeSumAssured}`)
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [formControlKey]: changeSumAssured,
            },
          }
        })
        setErrorState(prev => {
          return {
            ...prev,
            [formControlKey]: `Maximum sum assured can be offered up to ${changeSumAssured}`,
          }
        })
        return
      }
    }
    console.log(sectionState, "outside")
    if (callBiKeyJson["keysTOCallOn"][sections[currentSectionIndex].sectionId] &&
      callBiKeyJson["keysTOCallOn"][sections[currentSectionIndex].sectionId].includes(formControlKey)) {
      let sectionStateToPass = sectionState
      sectionStateToPass.sectionData[formControlKey] = value
      if (!sectionStateToPass.sectionId) {
        sectionStateToPass.sectionId = sections[currentSectionIndex].sectionId
      }
      let pageData = pageState.pageData.filter(
        element => element.sectionId !== sectionState.sectionId
      )
      let journeyData = journeyState.journeyData.filter(
        element =>
          element.pageId !== props.pages[props.currentPageIndex].pageId
      )
      setPageState(prev => {
        return {
          ...prev,
          pageData: [...pageData, sectionStateToPass], // adding new section
        }
      })

      let LoadPaylod = [
        ...journeyData,
        {
          pageId: props.pages[props.currentPageIndex].pageId,
          pageData: [...pageData, sectionStateToPass],
        },
      ]
      console.log(LoadPaylod, "loadPayload")
      if (formControlKey === "CPCustomizePlanPremiumPaymentTerm") {
        setJourneyState(prev => {
          return({
            ...prev,
            paymentFrequency: sectionState.sectionData["CPCustomizePlanPaymentFrequency"]
          })
        })
      }
      else if(formControlKey === "iSelect360CPCustomizePlanPremiumPaymentTerm"){
        setJourneyState(prev => {
          return({
            ...prev,
            paymentFrequency: sectionState.sectionData["iSelect360CPCustomizePlanPaymentFrequency"]
          })
        })
      }
      if (formControlKey === "CPCustomizePlanPaymentFrequency" || formControlKey === "iSelect360CPCustomizePlanPaymentFrequency") {
        setJourneyState(prev => {
          return({
            ...prev,
            paymentFrequency: value
          })
        })
      }
      if(formControlKey === "gstWaiverInd"){
        setJourneyState(prev => {
          return ({
            ...prev,
            gstWaiverInd: value ?? "N" 
          })
        })
      }
      
      //console.log(firstLoadPaylod)
      let sendPayload = {
        applicationData: LoadPaylod,
        journeyData: {
          _id: journeyState.journeyId,
          // lastPage: getLastPageAndLastSection(props.currentPageIndex, currentSectionIndex, sections.length).lastPage,
          // lastSection: getLastPageAndLastSection(props.currentPageIndex, currentSectionIndex, sections.length).lastSection,
          lastPageCode: props.pageId,
          lastSectionCode: sections[currentSectionIndex].sectionId,
          journeyCode: findCurrentJourneyCode(props.pageId, sections[currentSectionIndex].sectionId),
          applicationNo: journeyState.applicationNo,
          illustrationNumber: journeyState.illustrationNumber,
          proposalEntryId: journeyState.proposalEntryId,
          planOption: journeyState.planOption,
          journeyIdFromStrapi: journeyState.journeyIdFromStrapi,
          premium: journeyState.premium,
          channel: journeyState.channel,
          paymentFrequency: journeyState.paymentFrequency
        },
      }
      let toCallBi
      if (sections[currentSectionIndex].sectionId === "CPSpouseCoverDetails" || sections[currentSectionIndex].sectionId === "CPOptionInBuiltCoversSection" || sections[currentSectionIndex].sectionId === "iSelect360CPOptionalInBuilt" || sections[currentSectionIndex].sectionId === "iSelect360CPSpouseCoverDetails" || sections[currentSectionIndex].sectionId === "P2PCPOptionalInBuilt" || sections[currentSectionIndex].sectionId === "P2PCPSpouseCoverDetails") {
        let keysToCheck = callBiKeyJson["keysToCheck"][sections[currentSectionIndex].sectionId][formControlKey]
        console.log(keysToCheck, "keysToCheck")
        if(Array.isArray(keysToCheck)){
          toCallBi = keysToCheck?.every(key => {
            if (!sectionStateToPass.sectionData[key]) {
              return false
            } else {
              return sectionStateToPass.sectionData[key] !== ""
            }
          })
        }else{
          console.log("previousSelectedValue", previousSelectedValue)
          if (previousSelectedValue || value) {
            if (value) {
              toCallBi = keysToCheck?.[value]?.every(key => {
                if (!sectionStateToPass.sectionData[key]) {
                  return false
                } else {
                  return sectionStateToPass.sectionData[key] !== ""
                }
              })
            } else {
              toCallBi = keysToCheck?.[previousSelectedValue]?.every(key => {
                if (!sectionStateToPass.sectionData[key]) {
                  return false
                } else {
                  return sectionStateToPass.sectionData[key] !== ""
                }
              })
            }

          } else {
            toCallBi = true
          }
        }
      } else {
        toCallBi = true
      }
      console.log(toCallBi, "toCallBi")
      if (toCallBi) {
        saveApplication(sendPayload).then(res => {
          // console.log(res)
          let payload = {
            journeyId: journeyState.journeyId
          }
          generateBI(payload).then(res => {
            console.log(res, "eefe")
            if (res.data.BIJson) {
              console.log("inside if")
              setJourneyState(prev => {
                return ({
                  ...prev,
                  premium: ((res.data.finalKeys.PREMIUM) || 0),
                  premiumWithoutTax : res.data?.finalKeys?.TOTAL_INSTALLMENT,
                  annualPremiumEquivalent : res.data.finalKeys?.TOTAL_AMOUNT_PER_YEAR
                })
              })
              setErrorState(prev => {
                return {
                  ...prev,
                  ["errorFromBI"]: "",
                }
              })
            } else {
              if (res.data.InputValidationStatus && res.data.InputValidationStatus[0]?.ErrorMessage) {
                let str = res.data.InputValidationStatus[0]?.ErrorMessage.map(el => el.value).join(',')
                setErrorState(prev => {
                  return {
                    ...prev,
                    ["errorFromBI"]: str,
                  }
                })
              } else {
                setErrorState(prev => {
                  return {
                    ...prev,
                    ["errorFromBI"]: res.data.Message,
                  }
                })
              }
            }
          })
        })
        .catch(err => {
          console.log("error in save application of save application and call BI function")
        })
      }
    }
  }
  
  const resultCheck = (ele) => {
    if(ele.result == "1"){
      console.log("This product cannnot be offered basis your inputs")
      errorToastr("This product cannnot be offered basis your inputs")
      setErrorState(prev => {
        return {
          ...prev,
          ["errorFromBusinessRule"]: "This product cannnot be offered basis your inputs",
        }
      })
      }
      else if(ele.result == "2"){
        console.log("inside 2")
        let changeSumAssured = parseInt(ele.SumAssured)
        if(conditionState[ele.WatchKeySumAssured] > changeSumAssured){
          setConditionState(prev => {
            return {
              ...prev,
              [ele.WatchKeySumAssured]: ele.SumAssured,
              [ele.WatchKeyValueCpSumAssured]: ele.SumAssured
            }
          })
            let pageData = pageState.pageData.filter(
              element => element.sectionId !== sectionState.sectionId
            )
            let journeyData = journeyState.journeyData.filter(
              element =>
                element.pageId !== props.pages[props.currentPageIndex].pageId
            )
          let payloadData = [
            ...journeyData,
            {
              pageId: props.pages[props.currentPageIndex].pageId,
              pageData: [...pageData, sectionState],
            },
          ]
          let sendPayload = {
            applicationData: payloadData,
            journeyData: {
              _id: journeyState.journeyId,
              lastPageCode: props.pageId,
              lastSectionCode: sections[currentSectionIndex].sectionId,
              journeyCode: findCurrentJourneyCode(props.pageId, sections[currentSectionIndex].sectionId),
              applicationNo: journeyState.applicationNo,
              illustrationNumber: journeyState.illustrationNumber,
              proposalEntryId: journeyState.proposalEntryId,
              planOption: journeyState.planOption,
              journeyIdFromStrapi: journeyState.journeyIdFromStrapi,
              premium: journeyState.premium,
              channel: journeyState.channel,
              paymentFrequency: journeyState.paymentFrequency,
              sumAssured: ele.SumAssured
            },
          }
          console.log(sendPayload, "sendPayload")
          saveApplication(sendPayload).then(res => {
            console.log(res, "response")
            let payload = {
              journeyId: journeyState.journeyId
            }
            generateBI(payload).then(res => {
              console.log(res, "eefe")
              if (res.data.BIJson) {
                setJourneyState(prev => {
                  return ({
                    ...prev,
                    premium: ((res.data.finalKeys.PREMIUM) || 0),
                  })
                })
                setErrorState(prev => {
                  return {
                    ...prev,
                    ["errorFromBI"]: "",
                  }
                })
              } else {
                if (res.data.InputValidationStatus && res.data.InputValidationStatus[0]?.ErrorMessage) {
                  let str = res.data.InputValidationStatus[0]?.ErrorMessage.map(el => el.value).join(',')
                  setErrorState(prev => {
                    return {
                      ...prev,
                      ["errorFromBI"]: str,
                    }
                  })
                } else {
                  setErrorState(prev => {
                    return {
                      ...prev,
                      ["errorFromBI"]: res.data.Message,
                    }
                  })
                }
              }
            })
          }).catch(err => {
            console.log("error in save application of save application and call BI function")
          })

          errorToastr("Basis your input Maximum sum assured can be offered up to 50Lacs")
        }
        else{
          return
        }
      }
      else if(ele.result == "3"){
        console.log(ele.age, "inside 3")
        ele?.age?.filter(e => {
          let minAge = parseInt(e.minAge)
          let maxAge = parseInt(e.maxAge)
          let age = parseInt(conditionState[ele.watchKeyDob])
          if(getAge(age) >= minAge && getAge(age) <= maxAge){
            let availableSA = (e.IncomeMultiple)*conditionState[ele.WatchKeyAnnualIncome]
            let sumassured = parseInt(availableSA)
            let value
            if(sections?.[currentSectionIndex]?.sectionId === "iSelect360CPCustomizePlanSection"){
              value = parseInt(conditionState[ele.WatchKeyValueCpSumAssured])
            }else{
              value = parseInt(conditionState[ele.WatchKeySumAssured])
            }
            
            console.log(availableSA, "available sumAssured")
            if(value > sumassured){
              console.log("Basis the inputs the maximun sum Assured")
              errorToastr(`Basis the inputs maximum sum assured can be ${availableSA}`)
              setErrorState(prev => {
                    return {
                      ...prev,
                      ["errorFromBusinessRule"]: `Basis the inputs maximum sum assured can be ${availableSA}`,
                    }
                  })
            }
            else{
              setErrorState(prev => {
                return {
                  ...prev,
                ["errorFromBusinessRule"]: "",
                }
              })
            }
          }
        })
        return
      }
  }

  const businessRule = (formControlKey) => {
    props.pages?.filter(e => {
        if(e?.condition_checks){
          console.log("condition value", e)
          e?.condition_checks?.map((ele, i) => {
            //console.log("ele state", ele)
            if(conditionState[ele.WatchKeyAnnualIncome]
              && conditionState[ele.WatchKeyOccupationType]
                  && conditionState[ele.WatchKeyEducation]){
                    // if((!ele.maxAnnualIncome && conditionState[ele.WatchKeyAnnualIncome] < ele.minAnnualIncome) ||
                    //       (!ele.minAnnualIncome && conditionState[ele.WatchKeyAnnualIncome] >= ele.maxAnnualIncome) ||
                    //         (conditionState[ele.WatchKeyAnnualIncome] >= ele.minAnnualIncome && conditionState[ele.WatchKeyAnnualIncome] < ele.maxAnnualIncome)){
                      let min = parseInt(ele.minAnnualIncome)
                      let max = parseInt(ele.maxAnnualIncome)
                      let annualIncome = parseInt(conditionState[ele.WatchKeyAnnualIncome])
                      console.log(typeof min, "Annual income Value")
                      console.log(typeof annualIncome, "Annual income Value")
                      if((!max && annualIncome < min)){
                              console.log("inside if block")
                      if(conditionState[ele.WatchKeyOccupationType] == ele.occupationType){
                        if(conditionState[ele.WatchKeyEducation] == ele.educationalQualification){
                          //
                          setErrorState(prev => {
                            return {
                              ...prev,
                              ["errorFromBusinessRule"]: "",
                            }
                          })
                          console.log(ele.result, "inside if of watch")
                          resultCheck(ele)
                          return
                        }
                      }
                      return
                    }
                    else if((!min && annualIncome >= max)){
                      console.log("inside if block")
                      if(conditionState[ele.WatchKeyOccupationType] == ele.occupationType){
                        if(conditionState[ele.WatchKeyEducation] == ele.educationalQualification){
                          setErrorState(prev => {
                            return {
                              ...prev,
                              ["errorFromBusinessRule"]: "",
                            }
                          })
                          console.log(ele.result, "inside if of watch")
                          resultCheck(ele)
                          return
                         }
                       }
                       return
                     }
                     else if(min && max && (min == 250000 && max == 400000) && (annualIncome >= 250000 && annualIncome < 400000)){
                       console.log("inside if block")
                       if(conditionState[ele.WatchKeyOccupationType] == ele.occupationType){
                         if(conditionState[ele.WatchKeyEducation] == ele.educationalQualification){
                           setErrorState(prev => {
                             return {
                               ...prev,
                               ["errorFromBusinessRule"]: "",
                             }
                           })
                           console.log(ele.result, "inside if of watch")
                           resultCheck(ele)
                           return
                         }
                       }
                       return
                     }
                     else if(min && max && (min == 400000 && max == 500000) && (annualIncome >= 400000 && annualIncome < 500000)){
                       console.log("inside if block")
                       if(conditionState[ele.WatchKeyOccupationType] == ele.occupationType){
                         if(conditionState[ele.WatchKeyEducation] == ele.educationalQualification){
                           setErrorState(prev => {
                             return {
                               ...prev,
                               ["errorFromBusinessRule"]: "",
                             }
                           })
                           console.log(ele.result, "inside if of watch")
                           resultCheck(ele)
                           return
                         }
                       }
                       return
                     }
                   }
                   return          
           } )
        }
        return
     })
 }
//                           if(ele.result == "1"){
//                             console.log("inside 1")
//                           console.log("This product cannnot be offered basis your inputs")
//                           errorToastr("This product cannnot be offered basis your inputs")
//                           setErrorState(prev => {
//                             return {
//                               ...prev,
//                               [formControlKey]: "This product cannnot be offered basis your inputs",
//                             }
//                           })
//                           }
//                           else if(ele.result == "2"){
//                             console.log("inside 2")
//                             setConditionState(prev => {
//                               return {
//                                 ...prev,
//                                 [ele.WatchKeySumAssured]: ele.SumAssured,
//                                 [ele.WatchKeyValueCpSumAssured]: ele.SumAssured
//                               }
//                             })
//                               let pageData = pageState.pageData.filter(
//                                 element => element.sectionId !== sectionState.sectionId
//                               )
//                               let journeyData = journeyState.journeyData.filter(
//                                 element =>
//                                   element.pageId !== props.pages[props.currentPageIndex].pageId
//                               )
//                             let payloadData = [
//                               ...journeyData,
//                               {
//                                 pageId: props.pages[props.currentPageIndex].pageId,
//                                 pageData: [...pageData, sectionState],
//                               },
//                             ]
//                             let sendPayload = {
//                               applicationData: payloadData,
//                               journeyData: {
//                                 _id: journeyState.journeyId,
//                                 lastPageCode: props.pageId,
//                                 lastSectionCode: sections[currentSectionIndex].sectionId,
//                                 journeyCode: findCurrentJourneyCode(props.pageId, sections[currentSectionIndex].sectionId),
//                                 applicationNo: journeyState.applicationNo,
//                                 illustrationNumber: journeyState.illustrationNumber,
//                                 proposalEntryId: journeyState.proposalEntryId,
//                                 planOption: journeyState.planOption,
//                                 journeyIdFromStrapi: journeyState.journeyIdFromStrapi,
//                                 premium: journeyState.premium,
//                                 channel: journeyState.channel,
//                                 paymentFrequency: journeyState.paymentFrequency,
//                                 sumAssured: ele.SumAssured
//                               },
//                             }
//                             console.log(sendPayload, "sendPayload")
//                             saveApplication(sendPayload).then(res => {
//                               console.log(res, "response")
//                               let payload = {
//                                 journeyId: journeyState.journeyId
//                               }
//                               generateBI(payload).then(res => {
//                                 console.log(res, "eefe")
//                                 if (res.data.BIJson) {
//                                   setJourneyState(prev => {
//                                     return ({
//                                       ...prev,
//                                       premium: ((res.data.finalKeys.PREMIUM) || 0),
//                                     })
//                                   })
//                                   setErrorState(prev => {
//                                     return {
//                                       ...prev,
//                                       ["errorFromBI"]: "",
//                                     }
//                                   })
//                                 } else {
//                                   if (res.data.InputValidationStatus && res.data.InputValidationStatus[0]?.ErrorMessage) {
//                                     let str = res.data.InputValidationStatus[0]?.ErrorMessage.map(el => el.value).join(',')
//                                     setErrorState(prev => {
//                                       return {
//                                         ...prev,
//                                         ["errorFromBI"]: str,
//                                       }
//                                     })
//                                   } else {
//                                     setErrorState(prev => {
//                                       return {
//                                         ...prev,
//                                         ["errorFromBI"]: res.data.Message,
//                                       }
//                                     })
//                                   }
//                                 }
//                               })
//                             }).catch(err => {
//                               console.log("error in save application of save application and call BI function")
//                             })

//                             errorToastr("Basis your input Maximum sum assured can be offered up to 50Lacs")
//                           }
//                           else if(ele.result == "3"){
//                             console.log(ele.age, "inside 3")
//                             ele?.age?.filter(e => {
//                               if(getAge(conditionState[ele.watchKeyDob]) >= e.minAge && getAge(conditionState[ele.watchKeyDob]) <= e.maxAge){
//                                 let availableSA = (e.IncomeMultiple)*conditionState[ele.WatchKeyAnnualIncome]
//                                 console.log(availableSA, "available sumAssured")
//                                 if(conditionState[ele.WatchKeySumAssured] > availableSA){
//                                   console.log("Basis the inputs the maximun sum Assured")
//                                   errorToastr(`Basis the inputs maximum sum assured can be ${availableSA}`)
//                                   setErrorState(prev => {
//                                     return {
//                                       ...prev,
//                                       [formControlKey]: "This product cannnot be offered basis your inputs",
//                                     }
//                                   })
//                                 }
//                               }
//                             })
//                           }
//                         }
//                       }
//                     }
//                   }
//                   return          
//           } )
//        }
//        return
//     })
// }
  const fullNameConverter = (firstName, middleName, lastName) => {
    let fullName
    if(firstName && middleName && lastName){
      return fullName = firstName + " " + middleName + " " + lastName
    }else if(firstName && lastName){
      return fullName = firstName + " " + lastName
    }else if(firstName &&  middleName){
      return fullName = firstName + " " + middleName
    }else if(firstName){
      return fullName = firstName
    }else{
      return ""
    }
  }

  /*Helper FUnction Ends*/

  //Code to handlePrevious Button Click
  const handlePreviousClick = () => {
    //this function runs on previous button click
    setShowError(false)
    setErrorState({})
    setCallBi(true)
    
    try {
      const payload = {
        journeyId: journeyState.journeyId, 
        buttonClicked:  "Previous", 
      };
      updateUserTrackerDetails(payload)
        .then((response) => {
          if (response?.status) {
            console.log("UserTracker updated successfully:", response.message);
          } else {
            console.error("Error in updating UserTracker:", response?.message);
          }
        })
        .catch((error) => {
          console.error("Error in updateUserTrackerDetails API call:", error);
        })
    } catch (error) {
      console.error("Error in handlePrevious:", error);
    }

    // getAllJourneyData("previous") 
    let journeyFormatData = applicationDataInJourneyFormat()
    DataLayerIntegration(journeyFormatData, "previous", sections?.[currentSectionIndex]?.sectionId,"", journeyState)

    let keysToRemoveFromConditionState = {}
    if(sectionState.sectionId === "CPOptionInBuiltCoversSection" || sectionState.sectionId === "iSelect360CPOptionalInBuilt" || sectionState.sectionId === "P2PCPOptionalInBuilt" || sectionState.sectionId === "residenceDetailsSection" || sectionState.sectionId === "sectionISelect360ProfessionalDetail" || sectionState.sectionId === "nomineeDetailsSection" || sectionState.sectionId === "spouseQuestionnaire" || sectionState.sectionId === "AppointeeDetailSection"){
      Object.keys(sectionState.sectionData).forEach(key => {
        keysToRemoveFromConditionState[`${pageState.pageId}.${sectionState.sectionId}.${key}`] = ""
      })
    }
    console.log(keysToRemoveFromConditionState, 'erefrrgrg')

    //handeling section movement
    if (currentSectionIndex <= 0) {
      // condition to move to previous page

      if (props.currentPageIndex - 1 >= 0) {
        let foundPage = journeyState.journeyData.find(
          element => element.pageId === pageState.pageId
        )
        //console.log(foundPage, "foundPage")
        if (foundPage) {
          let newJourneyData = journeyState.journeyData.filter(
            element => element.pageId !== foundPage.pageId
          )
          setJourneyState(prev => {
            return {
              ...prev,
              journeyData: newJourneyData,
            }
          })
          foundPage = []
        }

        //to add current page to journey context
        setJourneyState(prev => {
          return {
            ...prev,
            journeyData: [...prev.journeyData, pageState],
          }
        })
        props.setCurrentPageIndex(prev => prev - 1) // to change page
        setCurrentSectionIndex(
          props.pages[props.currentPageIndex - 1].sections.length - 1
        ) // to render last section of previous page

        //picking previous page data from journey context
        journeyState.journeyData.map((element, index) => {
          if (
            element.pageId === props.pages[props.currentPageIndex - 1].pageId
          ) {
            setPageState(prev => {
              return {
                ...prev,
                pageId: element.pageId,
                pageData: element.pageData,
              }
            })
          } // picking last section of previous page
          element.pageData.map((section, index) => {
            if (
              section.sectionId ===
              props.pages[props.currentPageIndex - 1].sections[
                props.pages[props.currentPageIndex - 1].sections.length - 1
              ].sectionId
            ) {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionId: section.sectionId,
                  sectionData: section.sectionData,
                }
              })
            }
          })
        })
      }
    } else {
      // condition of same page
      setCurrentSectionIndex(prev => prev - 1) // this moves to previous section on same page
      setSectionState({
        sectionId: null,
        sectionFirstPass: null,
        sectionData: {},
      })

      //handeling context change
      if (pageState.pageId === props.pageId) {
        pageState.pageData.map((element, index) => {
          if (
            element.sectionId === sections[currentSectionIndex - 1]?.sectionId // setting section context from page context
          ) {
            setSectionState(prev => {
              return {
                ...prev,
                sectionId: element.sectionId,
                sectionData: element.sectionData,
              }
            })
          }
        })
      }
      console.log(sectionState, "sectionState previous")
      console.log(pageState, "pageState previous")
      console.log(journeyState, "journeyState previous")
    }
    setConditionState(prev => {
      return {
        ...prev,
        ...keysToRemoveFromConditionState
      }
    })
    keysToRemoveFromConditionState = {}

    setJourneyState(prev => {
      return {
        ...prev,
        lastPage: props.currentPageIndex,
        lastSection: currentSectionIndex,
        lastPageCode: props.pageId,
        lastSectionCode: sections[currentSectionIndex]?.sectionId,
        journeyCode: findCurrentJourneyCode(props.pageId, sections[currentSectionIndex]?.sectionId)
      }
    })
    //console.log(journeyState, "agete jkdcehbce")
  }

  // Promise2Protect Business Rule Validation Handler
  const validateP2PBusinessRulesHandler = () => {
    if (
      journeyState.journeyIdFromStrapi === "Promise2ProtectJourney" &&
      (sections[currentSectionIndex]?.sectionId === "P2PCPResidentAndOccupationDetailSection" ||
       sections[currentSectionIndex]?.sectionId === "sectionP2PPersonalDetailsSection")
    ) {
      const validationResult = validateP2PBusinessRules(
        conditionState,
        props.pageId,
        "sectionP2PPersonalDetailsSection",
        "P2PCPResidentAndOccupationDetailSection",
        journeyState?.channel,
        p2pBusinessRulesConfig
      )

      // Set validation errors
      if (Object.keys(validationResult.errors).length > 0) {
        Object.keys(validationResult.errors).forEach(fieldKey => {
          setErrorState(prev => ({
            ...prev,
            [fieldKey]: validationResult.errors[fieldKey]
          }))
        })
        return { hasErrors: true, validationResult }
      }

      // Handle occupation field freezing (only if no validation errors)
      if (
        validationResult.shouldFreezeOccupation && 
        validationResult.frozenOccupationValue &&
        !validationResult.errors["CPResidentAndOccupationType"]
      ) {
        let temp = journeyState.journeySteps
        const changeJourneySteps = (pageId, sectionId, componentGroup, componentFormControlKey, key, value) => {
          try {
            let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
            if (tempPageIndexToChange === -1) return
            let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
            if (tempSectionIndexToChange === -1) return
            let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentGroup)
            if (tempComponentGroupIndexToChange === -1) return
            let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === componentFormControlKey)
            if (tempComponentIndexToChange !== -1) {
              temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange][key] = value
            }
          } catch (err) {
            console.log(err, "=====>ErrorInPage.js===P2POccupationFreeze")
          }
        }

        // Freeze occupation field to Salaried
        changeJourneySteps(
          props.pageId,
          "P2PCPResidentAndOccupationDetailSection",
          "P2PPlanCPResidentAndOccupationDetail",
          "CPResidentAndOccupationType",
          "disabled",
          true
        )

        // Set occupation value to Salaried in section state if not already set
        // if (sectionState.sectionData?.CPResidentAndOccupationType !== validationResult.frozenOccupationValue) {
          setSectionState(prev => ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              CPResidentAndOccupationType: validationResult.frozenOccupationValue
            }
          }))

          // Update condition state
          setConditionState(prev => ({
            ...prev,
            [`${props.pageId}.P2PCPResidentAndOccupationDetailSection.CPResidentAndOccupationType`]: validationResult.frozenOccupationValue
          }))
        // }

        // Update journey steps
        setJourneyState(prev => ({
          ...prev,
          journeySteps: temp
        }))
      }

      // Clear errors for fields that don't have errors (only P2P business rule errors)
      const allRelevantFields = ["AnnualIncome", "CPResidentAndOccupationType", "sumAssured"]
      allRelevantFields.forEach(fieldKey => {
        if (!validationResult.errors[fieldKey]) {
          setErrorState(prev => {
            const currentError = prev[fieldKey]
            // Only clear if it's a P2P business rule error
            if (currentError === "The Income Criteria does not meet the requirements for this product" || 
                (currentError && typeof currentError === 'string' && currentError.includes("Maximum Sum Assured"))) {
              return {
                ...prev,
                [fieldKey]: ""
              }
            }
            return prev
          })
        }
      })

      return { hasErrors: false, validationResult }
    }
    return { hasErrors: false, validationResult: null }
  }

  // Helper function to patch P2P journeySteps with channel conditions
  // This ensures conditions are preserved when journeySteps is updated from multiple sources
  const patchP2PSteps = (steps, config) => {
    if (!config || !config.channelCode || !Array.isArray(config.channelCode) || config.channelCode.length === 0) {
      return steps
    }

    // Find the page (check on original first to avoid unnecessary deep copy)
    const pageIndex = steps.pages.findIndex(page => page.pageId === "PageP2PCalculatePremium")
    if (pageIndex === -1) {
      return steps
    }

    // Find the section
    const sectionIndex = steps.pages[pageIndex].sections.findIndex(
      section => section.sectionId === "sectionP2PPersonalDetailsSection"
    )
    if (sectionIndex === -1) {
      return steps
    }

    // Find the component group
    const componentGroupIndex = steps.pages[pageIndex].sections[sectionIndex].component_groups.findIndex(
      componentGroup => componentGroup.componentId === "CFAreYouNiftyOrGovEmployee"
    )
    if (componentGroupIndex === -1) {
      return steps
    }

    // Check if conditions are already set (avoid re-applying if already configured)
    const existingConditions = steps.pages[pageIndex].sections[sectionIndex].component_groups[componentGroupIndex].conditions || []
    const hasChannelConditions = existingConditions.length > 0 && 
      existingConditions.some(cond => cond.watchKey === "channel" && cond.journeyContextCheck === true)
    
    // If conditions already exist, return original (no need to modify)
    if (hasChannelConditions) {
      return steps
    }

    // Now deep copy only when we need to modify
    const patchedSteps = JSON.parse(JSON.stringify(steps))
    
    // Build conditions array - one condition per channel code
    // Use "or" logic so component shows if channel matches ANY of the channel codes
    const conditions = config.channelCode.map((channelCode, index) => ({
      watchKey: "channel",
      watchValue: channelCode,
      type: "value",
      condition: "equalTo",
      conditionKey: "Promise2ProtectJourney",
      conditionName: `channelCheck${index + 1}`,
      multipleCondition: "or", // Use "or" for all conditions - component shows if ANY channel matches
      journeyContextCheck: true
    }))

    // Update the conditions array
    patchedSteps.pages[pageIndex].sections[sectionIndex].component_groups[componentGroupIndex].conditions = conditions

    return patchedSteps
  }


  // Real-time validation for Promise2Protect Business Rules
  // useEffect(() => {
  //   const validationResult = validateP2PBusinessRulesHandler()
  //   if (validationResult && validationResult.hasErrors) {
  //     setShowError(true)
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [
  //   conditionState[`${props.pageId}.sectionP2PPersonalDetailsSection.educationalQualification`],
  //   conditionState[`${props.pageId}.sectionP2PPersonalDetailsSection.AnnualIncome`],
  //   conditionState[`${props.pageId}.P2PCPResidentAndOccupationDetailSection.CPResidentAndOccupationType`],
  //   conditionState[`${props.pageId}.personalDetailsSectionId.CFAreYouNiftyOrGovEmployee`],
  //   sectionState.sectionData[`educationalQualification`],
  //   sectionState.sectionData[`AnnualIncome`],
  //   sectionState.sectionData[`CPResidentAndOccupationType`],
  //   sectionState.sectionData[`CFAreYouNiftyOrGovEmployee`],
  //   sections[currentSectionIndex]?.sectionId,
  //   journeyState.journeyIdFromStrapi
  // ])

  //Code to Handle Submit Button Click
  const handleSubmit = async() => {
    console.log(conditionState, "condition state")
    console.log(journeyState, "journey state")
    console.log(sectionState, "section state")
    // errorToastr('validation error')
    console.log(errorState, "inpage")

    try { // for recaptcha v3 implementation
      if (journeyState.applicationNo){
        executeRecaptcha("submit_form")
        .then((token) => {
          verifyCaptcha({
            token : token,
            applicationNumber : journeyState.applicationNo,
            sectionId : sectionState.sectionId,
            pageId : props.pages[props.currentPageIndex].pageId
          })
          .then(res => {
            console.info(res)
          })
          .catch(err => {
            console.info(err)
          })
        })
        .catch(err => {
          console.info(err)
        })
      }
    }catch(err){
      console.info(err)
    }

    // console.log(errorState, "inpage")
    // getAllJourneyData("proceed") 
    // let journeyFormatData =  applicationDataInJourneyFormat()
    // if(journeyState.journeyId){
    //   DataLayerIntegration(journeyFormatData, "proceed", sections?.[currentSectionIndex]?.sectionId)
    // }else{
    //   DataLayerIntegration(journeyFormatData, "", sections?.[currentSectionIndex]?.sectionId, "leadSubmit")
    // }

    //gaId
    var gaId
    try {     
      let cookieArray = document.cookie.split("; ")
      if (cookieArray && cookieArray.length) {
          let gaTagCookie = cookieArray.find(element => {
          if (element.includes("_ga=")) {
            return element.split(".")
          }
        })
        if (gaTagCookie) {
            let gaTagCookieSplit = gaTagCookie.split(".")
            if (gaTagCookieSplit && gaTagCookieSplit.length) {
              gaId = `${gaTagCookieSplit[gaTagCookieSplit.length - 2]}.${
                    gaTagCookieSplit[gaTagCookieSplit.length - 1]
                }`
          } else {
            gaId = ""
        }
        } else {
          gaId = ""
        }
    } else {
      gaId = ""
    }
    } catch (err) {
      console.log("Error geting google tag", "err")
    }

    //For LaTele_Mer page drop
  if(sectionState.sectionId === "iselectTeleMedicalQuestionaire"){
    console.log(Object.values(sectionState.sectionData));
    let LaTeleMerPageDrop = Object.values(sectionState.sectionData).some(el=> el === "Y") 
    if(LaTeleMerPageDrop){
      errorToastr("Basis the Information provided, your application is not eligible under Tele-MER")
    }
  }
    //For SpTele_Mer page drop
    if(sectionState.sectionId === "iselectTeleMedicalSpouseQuestionaire"){
    console.log(Object.values(sectionState.sectionData));
    let SpTeleMerPageDrop = Object.values(sectionState.sectionData).some(el=> el === "Y") 
    if(SpTeleMerPageDrop){
      errorToastr("Basis the Information provided, your application is not eligible under Tele-MER")
    }
  }
    if(sections[currentSectionIndex]?.sectionId === "nomineeDetailsSection"){
      checkNomineePercentage()
    }

    // Promise2Protect Business Rule Validation
    const validationResult = validateP2PBusinessRulesHandler()
    const p2pValidationErrors = validationResult?.validationResult?.errors || {}
    const currentSectionId = sections[currentSectionIndex]?.sectionId
    
    if (validationResult && validationResult.hasErrors) {
      // Block navigation only if error is on the current page
      if (currentSectionId === "sectionP2PPersonalDetailsSection" && (p2pValidationErrors["AnnualIncome"] || p2pValidationErrors["sumAssured"])) {
        // Error is on current page (first page) - block navigation
        setShowError(true)
        return
      } else if (currentSectionId === "P2PCPResidentAndOccupationDetailSection" && p2pValidationErrors["CPResidentAndOccupationType"]) {
        // Error is on current page (occupation page) - block navigation
        setShowError(true)
        return
      }
      // If error is on a different page, allow navigation to proceed
    }

    // For Promise2Protect journey, use validation result errors directly (avoid async state issue)
    // Merge P2P validation errors with current errorState for accurate validation
    let effectiveErrorState = { ...errorState }
    if (journeyState.journeyIdFromStrapi === "Promise2ProtectJourney") {
      // P2P business rule fields that should be checked
      const p2pBusinessRuleFields = ["AnnualIncome", "CPResidentAndOccupationType", "sumAssured"]
      
      // Update effectiveErrorState with latest P2P validation errors
      // If field is not in validation errors (validation passed), clear it in effectiveErrorState
      p2pBusinessRuleFields.forEach(fieldKey => {
        if (p2pValidationErrors[fieldKey]) {
          // Validation failed - use the error
          effectiveErrorState[fieldKey] = p2pValidationErrors[fieldKey]
        } else {
          // Validation passed - clear the error (only if it's a P2P business rule error)
          const currentError = effectiveErrorState[fieldKey]
          if (currentError === "The Income Criteria does not meet the requirements for this product" || 
              (currentError && typeof currentError === 'string' && currentError.includes("Maximum Sum Assured"))) {
            effectiveErrorState[fieldKey] = ""
          }
        }
      })
    }

    // For Promise2Protect journey, only check errors relevant to current section
    let isValidSection = Object.keys(effectiveErrorState).every(element => {
      // For Promise2Protect journey, exclude P2P business rule errors from other pages
      if (journeyState.journeyIdFromStrapi === "Promise2ProtectJourney") {
        // If we're on personal details section, ignore occupation field errors
        if (currentSectionId === "sectionP2PPersonalDetailsSection" && element === "CPResidentAndOccupationType") {
          return true // Ignore this error, it's on a different page
        }
        
        // If we're on occupation section, ignore personal details field errors
        if (currentSectionId === "P2PCPResidentAndOccupationDetailSection" && (element === "AnnualIncome" || element === "sumAssured")) {
          return true // Ignore this error, it's on a different page
        }
      }
      
      if (Array.isArray(effectiveErrorState[element])) {
        return effectiveErrorState[element].every(subElement => {
          return subElement === ""
        })
      } else {
        return effectiveErrorState[element] === ""
      }
    })
    // For BI error Show
    if (props.currentPageIndex === 0) {
      if (!isValidSection) {
        if (errorState["errorFromBI"]){
          errorToastr(errorState["errorFromBI"])
          setShowError(true)
          console.log("For BI error Show")
          return
        }
        if(errorState["errorFromBusinessRule"]){
          errorToastr(errorState["errorFromBusinessRule"])
          setShowError(true)
          return
        }
      }
    }
    if(journeyState.journeyIdFromStrapi === "GuaranteedSavingJourney" && props.pages[props.currentPageIndex].pageId === "PageGuaranteedSavingCalculatePremium" && sections[currentSectionIndex].sectionId === "SectionGuaranteedSavingInvestmentDetails"){
      if(!sectionState.sectionData["sumAssured"] || !sectionState.sectionData["GspAddition"] || !sectionState.sectionData["totalAmount"]){
        errorToastr("Please calculate the benefit illustration before proceeding")
        return
      }
    }

    if (isValidSection) {
      let journeyFormatData =  applicationDataInJourneyFormat()
      if (props.pages[props.currentPageIndex].pageId === "PageP2PCalculatePremium" && sections[currentSectionIndex].sectionId === "P2PCPResidentAndOccupationDetailSection"){
        sessionStorage.setItem("isResidentDetailsSubmitted", true)
      }
      if (props.pages[props.currentPageIndex].pageId === "PageP2PCalculatePremium" && sections[currentSectionIndex].sectionId === "P2PCPCustomizePlanSection"){
        sessionStorage.setItem("isCustomiseDetailsSubmitted",true)
      }
      if (props.pages[props.currentPageIndex].pageId === "PageP2PCalculatePremium" && sections[currentSectionIndex].sectionId === "P2PCPSpouseCoverDetails"){
        sessionStorage.setItem("isSpouseDetailsSubmitted",true)
      }
      if (props.pages[props.currentPageIndex].pageId === "pageISelect360FillProposalForm" && sections[currentSectionIndex].sectionId === "nomineeDetailsSection"){
        sessionStorage.setItem("isNomineeDetailsSubmitted",true)
      }
      if(journeyState.journeyId){
        DataLayerIntegration(journeyFormatData, "proceed", sections?.[currentSectionIndex]?.sectionId, "", journeyState)
      }
      let otpVerified = "N"
      // if(props.currentPageIndex === 0 
      //   && currentSectionIndex === 0
      //   && journeyState.corpDiscOpt === "Y"
      //   && journeyState.otpVerified === "N"){
      //     let corpDiscOptVerifyPayload = {
      //       mobileNo: `${sectionState.sectionData.contactNumber}`,
      //       otp: `${sectionState.sectionData.corpDiscOtp}`,
      //       date: Math.floor(new Date().getTime() / 1000),
      //     }
      //     let verifyOtpResponse = await verifyCorpDiscOtp(corpDiscOptVerifyPayload)
      //     console.log(verifyOtpResponse, "verifyOtpResponse")
      //     if(!verifyOtpResponse.status){
      //       errorToastr("Please enter correct OTP")
      //       return
      //     }else{
      //       otpVerified = "Y"
      //     }
      //   }



      if (props.currentPageIndex === 0 && currentSectionIndex === 0 && (props.showFirstSectionFields === false)) {
        props.setShowFirstSectionFields(true)
        setShowError(false)
        if(sectionState?.sectionData?.privacyPolicy){
          
          let temp = journeyState.journeySteps
          const tempComponentGroupIndexToChange = temp.pages[props.currentPageIndex].sections[currentSectionIndex].component_groups.findIndex(element => element.componentId === "privacypolicy-MD-12-order-25")
          const tempComponentIndex = temp.pages[props.currentPageIndex].sections[currentSectionIndex].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "privacyPolicy")
          temp.pages[props.currentPageIndex].sections[currentSectionIndex].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndex]["display"] = false;
          setJourneyState(prev => {
            return ({
              ...prev,
              otpVerified: otpVerified,
              journeySteps: temp
            })
          })
        }
        async function applicationNumberGeneration() {
          let anurConfigChannels=[];
            try{
              const res=await getConfigByType({ type: "anur-config" })
              if (res?.data[0]?.config?.products?.hasOwnProperty(journeyState?.journeyIdFromStrapi)) {
                anurConfigChannels = res?.data[0]?.config?.products?.[journeyState?.journeyIdFromStrapi]?.channels || [];
                anurConfigChannels = anurConfigChannels.map(c => c.toUpperCase());
              }

            }
             catch(error){
              console.error(error)
              errorToastr(error?.response?.data?.message || error.message)
            }
          let payloadForApplicationNumber = {
            planCode: journeyState.planOption,
            channelType: "HSBC",
            userId: "ONLINE",
            source: "I",
          }
          let payloadForSaveJounrey = {
            basicDetails: {
              applicationNumber: "",
              journeyEncrypt: true,
              emailID: sectionState.sectionData.email,
              mobileNo: sectionState.sectionData.contactNumber,
              countryCode: sectionState.sectionData.contactCountryCode,
              channel: journeyState.channel,
              planCode: journeyState.planOption,
              planName: journeyState.planOption,
              journey: "1",
              illustrationNumber: "",
              proposalEntryId: "",
              fnaDetails: {
                // FNAID: journeyState?.fnaData?.FNAID,
                PROPOSERFULLNAME: journeyState?.fnaData?.PROPOSERFULLNAME,
                BIRTHDATE: journeyState?.fnaData?.BIRTHDATE,
                PHONENUMBER: journeyState?.fnaData?.PHONENUMBER,
                EMAILID: journeyState?.fnaData?.EMAILID,
                ANNUALINCOME: journeyState?.fnaData?.ANNUALINCOME,
                ANNUALEXPENSES: journeyState?.fnaData?.ANNUALEXPENSES,
                ANNUALDISPOSABLRINCOME: journeyState?.fnaData?.ANNUALDISPOSABLRINCOME,
                EXISTINGLIFECOVER: journeyState?.fnaData?.EXISTINGLIFECOVER,
                LIFECOVERREQUIRED: journeyState?.fnaData?.LIFECOVERREQUIRED,
                GOALTOACHIEVE: journeyState?.fnaData?.GOALTOACHIEVE,
                TIMEHORIZON: journeyState?.fnaData?.TIMEHORIZON,
                CAPITALPROTECTION: journeyState?.fnaData?.CAPITALPROTECTION,
                PREFERREDPLAN: journeyState?.fnaData?.PREFERREDPLAN,
                // PROPOSALENTRYID: journeyState?.fnaData?.PROPOSALENTRYID,
                // CREATEDATE: journeyState?.fnaData?.CREATEDATE,
                // FNAFLAG: journeyState?.fnaData?.FNAFLAG

              },
              utmParams: utmParams,
              videoVcApplicable:anurConfigChannels.includes(journeyState?.channel?.toUpperCase())?"Y":"N"
            },
            agentDetails: {
              eSPCode: journeyState.eSPCode,
              subChannel: journeyState.subChannel,
              ...journeyState.agentDetails,
              rmLedJourneyInd: journeyState.channel !== "A" ? "02" : journeyState.agentDetails.rmLedJourneyInd
            },

            lastSection: 0,
            lastPage: 0,
            lastPageCode: "calculatePremiumPage",
            lastSectionCode: "CPPersonalDetailsSection",
            journeyCode: "J1_001",
            uniqueId: journeyState?.uid,
          }
          let firstLoadPaylod = [
            {
              pageId: props.pages[props.currentPageIndex].pageId,
              pageData: [sectionState],
            },
          ]
          let collectionToBeMapped
          if(props?.canaraPosData){
            collectionToBeMapped = {
              fnaId: props?.canaraPosData?.canaraPosData[0]?.fnaData?._id,
              canaraPosId: props?.canaraPosData?.canaraPosData[1]?.canaraPosData?._id
            }
          }
          let saveApplicationPayload = {
            sendResponseData: true,
            applicationData: firstLoadPaylod,
            journeyData: {
              _id: "",
              lastPage: 0,
              lastSection: 0,
              lastPageCode: props.pageId,
              lastSectionCode: sections[currentSectionIndex].sectionId,
              journeyCode: "J1_001",
              applicationNo: "",
              illustrationNumber: "",
              planOption: journeyState.planOption,
              journeyIdFromStrapi: journeyState.journeyIdFromStrapi,
              proposalEntryId: "",
              channel: journeyState.channel,
              premium: journeyState.premium ? journeyState.premium : 0,
              corporateDiscountInd: journeyState.corpDiscOpt,
              gaId: gaId,
              journeyType: journeyState?.journeyType,
              hsbcJourneyID: journeyState?.hsbcJourneyID,
              collectionToBeMapped: collectionToBeMapped
            },
          }
          let finalPayloadForApplicationNumberGeneration = {
            payloadForApplicationNumber: payloadForApplicationNumber,
            payloadForSaveJounrey: payloadForSaveJounrey,
            saveApplicationPayload: saveApplicationPayload
          }
          try {
            console.log(journeyState);
            if(journeyState?.applicationNo){
              let sendPayload = {
                applicationData: firstLoadPaylod,
                journeyData: {
                  _id: journeyState.journeyId,
                  lastPage: getLastPageAndLastSection(props.currentPageIndex, currentSectionIndex, sections.length).lastPage,
                  lastSection: getLastPageAndLastSection(props.currentPageIndex, currentSectionIndex, sections.length).lastSection,
                  lastPageCode: props.pageId,
                  lastSectionCode: sections[currentSectionIndex].sectionId,
                  journeyCode: findCurrentJourneyCode(props.pageId, sections[currentSectionIndex].sectionId),
                  applicationNo: journeyState.applicationNo,
                  illustrationNumber: journeyState.illustrationNumber,
                  planOption : journeyState.planOption,
                  journeyIdFromStrapi: journeyState.journeyIdFromStrapi,
                  proposalEntryId: journeyState.proposalEntryId,
                  premium: journeyState.premium,
                  channel: journeyState.channel,
                  gaId: gaId
                },
              }
              console.log(sendPayload);
              let saveApplicationResponse = await saveApplication(sendPayload)
              console.log(saveApplicationResponse);
            }else{
              let applicationNumberResponse = await saveApplicationDetailsOverall(finalPayloadForApplicationNumberGeneration)
              sessionStorage.setItem("appNo",applicationNumberResponse.alljounreyData.basicDetails.applicationNumber)
              // Events to called post lead generation
              DataLayerIntegration(journeyFormatData, "", sections?.[currentSectionIndex]?.sectionId, "leadSubmit", journeyState)
              DataLayerIntegration(journeyFormatData, "", sections?.[currentSectionIndex]?.sectionId, "secondPageLanded", journeyState)
              console.log(applicationNumberResponse.alljounreyData.basicDetails.applicationNumber, "applicationNumberResponse")
              setJourneyState(prev => {
                return {
                  ...prev,
                  proposalEntryId: applicationNumberResponse.alljounreyData.basicDetails.proposalEntryId,
                  applicationNo: applicationNumberResponse.alljounreyData.basicDetails.applicationNumber,
                  illustrationNumber: applicationNumberResponse.alljounreyData.basicDetails.illustrationNumber,
                  otpVerified : otpVerified,
                  journeyId: applicationNumberResponse.alljounreyData._id,
                }
              })
            }
          } catch (err) {
            console.log(err)
          }
        }
        applicationNumberGeneration()
        return
      }
      setFirstPassForPremiumPaymentBicall(true)
      setFirstPageAutoFillApiCall(true)
      setErrorState({})
      setShowError(false)
      // this function runs on submit button click
      //handeling section movement
      if (currentSectionIndex >= sections.length - 1) {
        console.log("inside if")
        // condition to move to next page

        /*to remove duplicate page state */
        let foundSection = pageState.pageData.find(
          //to prevent duplicate section
          element => element.sectionId === sectionState.sectionId
        )
        //console.log(foundSection, "foundSection")

        if (foundSection) {
          // removing the old section to add new section
          let newPageData = pageState.pageData.filter(
            element => element.sectionId !== foundSection.sectionId
          )
          setPageState(prev => {
            return {
              ...prev,
              pageData: [...newPageData, sectionState], //newPageData has all sections except founded section
            }
          })
          foundSection = {}
        } else {
          setPageState(prev => {
            return {
              ...prev,
              pageData: [...prev.pageData, sectionState], // adding new section
            }
          })
        }

        let foundPage = journeyState.journeyData.find(
          element => element.pageId === pageState.pageId
        )
        console.log(foundPage, "foundPage")
        if (foundPage) {
          let newJourneyData = journeyState.journeyData.filter(
            element => element.pageId !== foundPage.pageId
          )
          let pageData = pageState.pageData.filter(
            element => element.sectionId !== sectionState.sectionId
          )
          setJourneyState(prev => {
            return {
              ...prev,
              otpVerified: journeyState.otpVerified,
              journeyData: [
                ...newJourneyData,
                {
                  pageId: props.pages[props.currentPageIndex].pageId,
                  pageData: [...pageData, sectionState],
                },
              ],
            }
          })
          foundPage = {}
        } else {
          let pageData = pageState.pageData.filter(
            element => element.sectionId !== sectionState.sectionId
          )

          setJourneyState(prev => {
            return {
              ...prev,
              otpVerified: journeyState.otpVerified,
              journeyData: [
                ...prev.journeyData,
                {
                  pageId: props.pages[props.currentPageIndex].pageId,
                  pageData: [...pageData, sectionState],
                },
              ],
            }
          })
        }

        setPageState(prev => {
          return {
            ...prev,
            pageId: null,
            pageData: [],
          }
        })
        setSectionState(prev => {
          return {
            ...prev,
            sectionId: null,
            sectionFirstPass: null,
            sectionData: {},
          }
        })
        /*to remove duplicate page state */

        journeyState.journeyData.map((element, index) => {
          // to get pageState if exists
          if (
            element.pageId === props.pages[props.currentPageIndex + 1].pageId
          ) {
            setPageState(prev => {
              return {
                ...prev,
                pageId: element.pageId,
                pageData: element.pageData,
              }
            })
            element.pageData.map((section, index) => {
              if (
                section.sectionId ===
                props.pages[props.currentPageIndex + 1].sections[0].sectionId
              ) {
                setSectionState(prev => {
                  return {
                    ...prev,
                    sectionId: section.sectionId,
                    sectionData: section.sectionData,
                  }
                })
              }
            })
          }
        })

        if (props.currentPageIndex < props.pages.length - 1) {
          // edge case condition for last page
          props.setCurrentPageIndex(prev => prev + 1)
          setCurrentSectionIndex(0)
          //console.log(journeyState, "journey state")
        }
      } else {
        // condition of same page

        //Handeling context change
        if (sectionState.sectionId !== null) {
          //console.log("is section ID null")
          if (pageState.pageId === props.pageId) {
            let foundSection = pageState.pageData.find(
              //to prevent duplicate section
              element => element.sectionId === sectionState.sectionId
            )
            //console.log(foundSection, "foundSection")

            if (foundSection) {
              // removing the old section to add new section
              const newPageData = pageState.pageData.filter(
                element => element.sectionId !== foundSection.sectionId
              )
              setPageState(prev => {
                return {
                  ...prev,
                  pageData: newPageData, //newPageData has all sections except founded section
                }
              })
              foundSection = {}
            }

            setPageState(prev => {
              return {
                ...prev,
                pageData: [...prev.pageData, sectionState], // adding new section
              }
            })
          } else {
            setPageState(prev => {
              // case of new page
              return {
                ...prev,
                pageId: props.pageId,
                pageData: [...prev.pageData, sectionState],
              }
            })
          }
        }

        setSectionState(prev => {
          // making section data empty to load new sectionData
          return {
            ...prev,
            sectionId: null,
            sectionFirstPass: null,
            sectionData: {},
          }
        })

        pageState.pageData.map((element, index) => {
          if (
            element.sectionId === sections[currentSectionIndex + 1].sectionId
          ) {
            //loading section state if already present
            setSectionState(prev => {
              return {
                ...prev,
                sectionId: element.sectionId,
                sectionData: element.sectionData,
              }
            })
          }
        })

        console.log(sectionState, "section state")
        console.log(pageState, "pageState")
        console.log(journeyState, "journey state else")
         console.log("setCurrentSectionIndex6");
        setCurrentSectionIndex(prev => prev + 1)
        props.sections[currentSectionIndex].class = "active"
      }

      // save application details
      setJourneyState(prev => {
        return {
          ...prev,
          lastPage: props.currentPageIndex,
          lastSection: currentSectionIndex,
          lastPageCode: props.pageId,
          otpVerified: journeyState.otpVerified,
          lastSectionCode: sections[currentSectionIndex].sectionId,
          journeyCode: findCurrentJourneyCode(props.pageId, sections[currentSectionIndex].sectionId)
        }
      })
      // console.log(journeyState, "agete jkdcehbce")

      
        let pageData = pageState.pageData.filter(
          element => element.sectionId !== sectionState.sectionId
        )
        let journeyData = journeyState.journeyData.filter(
          element =>
            element.pageId !== props.pages[props.currentPageIndex].pageId
        )

        let LoadPaylod = [
          ...journeyData,
          {
            pageId: props.pages[props.currentPageIndex].pageId,
            pageData: [...pageData, sectionState],
          },
        ]

        //console.log(firstLoadPaylod)
        let sendPayload = {
          applicationData: LoadPaylod,
          journeyData: {
            _id: journeyState.journeyId,
            lastPage: getLastPageAndLastSection(props.currentPageIndex, currentSectionIndex, sections.length).lastPage,
            lastSection: getLastPageAndLastSection(props.currentPageIndex, currentSectionIndex, sections.length).lastSection,
            lastPageCode: props.pageId,
            lastSectionCode: sections[currentSectionIndex].sectionId,
            journeyCode: findCurrentJourneyCode(props.pageId, sections[currentSectionIndex].sectionId),
            applicationNo: journeyState.applicationNo,
            illustrationNumber: journeyState.illustrationNumber,
            planOption : journeyState.planOption,
            journeyIdFromStrapi: journeyState.journeyIdFromStrapi,
            proposalEntryId: journeyState.proposalEntryId,
            premium: journeyState.premium,
            channel: journeyState.channel,
            gaId: gaId,
            sendCaseToCustomerFirstResume: journeyState?.sendCaseToCustomerFirstResume
          },
          posDashboardListingData:{
            sendCaseToCustomerFirstResume: journeyState?.sendCaseToCustomerFirstResume
          }
        }
        saveApplication(sendPayload).then(async res => {
          setCallBi(true);
          // if(sections[currentSectionIndex].sectionId === "residenceDetailsSection"){
          //   const data = await checkDocuments({_id:journeyState.journeyId});
          // }
          setSaveApplicationCounter(prev => prev + 1)
          //console.log(res)
        }).catch(error => {
          console.log("asdsadasd", errorState)
          if (currentSectionIndex === sections.length -1) {
            if (props.currentPageIndex >= 0) {
              // let foundPage = journeyState.journeyData.find(
              //   element => element.pageId === props.pages[props.currentPageIndex - 1].pageId
              // )
              // if (foundPage) {
                setPageState({
                  pageId: pageState.pageId,
                  pageData: pageState.pageData
                })
                // let foundSection = foundPage.pageData.find(
                //   element => element.sectionId === props.pages[props.currentPageIndex -1].sections[sections.length -1].sectionId
                // )
                // if (foundSection) {
                  setSectionState({
                    sectionId: sectionState.sectionId,
                    sectionData: sectionState.sectionData
                  })
                // }
              }
              props.setCurrentPageIndex(prev => prev - 1)
              setCurrentSectionIndex(props.pages[props.currentPageIndex]?.sections.length - 1)
              setErrorState({})
          } else {
            // let foundSection = pageState.pageData.find(element => {
            //   console.log(element, "sdfdf", sectionState)
            //   return element.sectionId === sectionState.sectionId
            // })
            // if(foundSection){
              setSectionState({
                sectionId: sectionState.sectionId,
                sectionData: sectionState.sectionData
              })
            // }
            setCurrentSectionIndex(prev => prev - 1)
            setErrorState({})

          }
        })
        // .then(res => {
        //   if(currentSectionIndex >= sections.length - 1){
        //     if(props.currentPageIndex < props.pages.length - 1) {
        //       // edge case condition for last page
        //       props.setCurrentPageIndex(prev => prev + 1)
        //       setCurrentSectionIndex(0)
        //       //console.log(journeyState, "journey state")
        //     }
        //   }else{
        //     setCurrentSectionIndex(prev => prev + 1);
        //   }
        // })
    } else {
      if(((sections[currentSectionIndex].sectionId === "CPPersonalDetailsSection" && errorState["educationalQualification"] && errorState["educationalQualification"] === "This option is not available for this plan")
        || (sections[currentSectionIndex].sectionId === "CPResidentAndOccupationDetailSection" && errorState["CPResidentAndOccupationType"] && errorState["CPResidentAndOccupationType"] === "This option is not available for this plan")
        || (sections[currentSectionIndex].sectionId === "iSelect360CPResidentAndOccupationDetailSection" && errorState["CPResidentAndOccupationType"] && errorState["CPResidentAndOccupationType"] === "This option is not available for this plan")
        || (sections[currentSectionIndex].sectionId === "CPPersonalDetailsSection" && errorState["AnnualIncome"] && errorState["AnnualIncome"] === "This option is not available for this plan")) && (journeyState.journeyIdFromStrapi === "ISelect360Journey"|| journeyState.journeyIdFromStrapi === "iSelectJourney")
        || (sections[currentSectionIndex].sectionId === "sectionP2PPersonalDetailsSection" && errorState["educationalQualification"] && errorState["educationalQualification"] === "This option is not available for this plan")
        || (sections[currentSectionIndex].sectionId === "P2PCPResidentAndOccupationDetailSection" && errorState["CPResidentAndOccupationType"] && errorState["CPResidentAndOccupationType"] === "This option is not available for this plan")
        || (sections[currentSectionIndex].sectionId === "CPPersonalDetailsSection" && errorState["AnnualIncome"] && errorState["AnnualIncome"] === "This option is not available for this plan")
        || (sections[currentSectionIndex].sectionId === "iSelect360CPResidentAndOccupationDetailSection" && errorState["pincode"] && errorState["pincode"] === "This Pincode is not serviceable")
        || (sections[currentSectionIndex].sectionId === "P2PCPResidentAndOccupationDetailSection" && errorState["pincode"] && errorState["pincode"] === "This Pincode is not serviceable")
      ){
        errorToastr(`Thank You for choosing Canara HSBC Life Insurance Company Limited -${journeyState.journeyIdFromStrapi === "iSelectJourney" ? "iSelect Star Plan" : journeyState.journeyIdFromStrapi === "ISelect360Journey" ? "iSelect Smart360 Term Plan" : journeyState.journeyIdFromStrapi === "Promise2ProtectJourney" ? "Promise 2 Protect Plan" : ""}. Basis your input this Plan is not available.`)
      }
      setShowError(true)
    }
  }

  // code of tab enter
  const handleEnterPrevious = (event) =>{
    if(event?.key == 'Enter'){
      handlePreviousClick();
    }
  }

  return (
    <>
      <style>
        {`
            .journey-buttons{
              clear: both;
              margin: -20px 0px 0px 0px;
              padding: 0px;
              display: inline-block;
              width: 100%;
              text-align: center;
            }
            @media (max-width: 767px){
              .journey-buttons {
                padding: 15px 0px !important;
                margin: -20px 0px 0px 0px;
              }
            }
            // button{
            //   color: white;
            //   background-color: var(--lumiq-tertiary);
            //   height: 50px;
            //   width: 80px;
            //   margin-right: 20px;
            //   border-radius: 10px;
            //   border: none;
            // }  
          `}
      </style>
      {/* body-section */}
      {sections?.[currentSectionIndex] &&
      sections[currentSectionIndex].sectionId === "provide-your-consent" ? (
        <ProvideYourConsent
          journeyDataState={journeyDataState}
          applicationDataInJourneyFormat={applicationDataInJourneyFormat}
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "ekyc" ? (
        <Ekyc
          journeyDataState={journeyDataState}
          applicationDataInJourneyFormat={applicationDataInJourneyFormat}
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "ckyc" ? (
        <Ckyc
          journeyDataState={journeyDataState}
          applicationDataInJourneyFormat={applicationDataInJourneyFormat}
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "benefit-illustration" ? ( // for iselect star
        <BenefitIllustration
          journeyDataState={journeyDataState}
          applicationDataInJourneyFormat={applicationDataInJourneyFormat}
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
        />
        ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "P2P-benefit-illustration" ? ( // for promise 2 protect Plan
        <Promise2ProtectBenefitIllustration
          journeyDataState={journeyDataState}
          applicationDataInJourneyFormat={applicationDataInJourneyFormat}
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
        />
        ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "sectionGuaranteedSavingBenefitIllustration" ? ( // for flexi Edge
        <BenefitIllustrationGSP
          applicationDataInJourneyFormat={applicationDataInJourneyFormat}
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
        />
      ) : sections?.[currentSectionIndex] &&
      sections[currentSectionIndex].sectionId === "SectionPOSBenefitIllustration" ? ( //For POS-EasyBachat
        <BenefitIllustrationPos
          applicationDataInJourneyFormat={applicationDataInJourneyFormat}
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
        />
      ) : sections?.[currentSectionIndex] &&
      sections[currentSectionIndex].sectionId === "SectionPOSPremiumQuotation" ? ( //For POS-EasyBachat
        <EasyBachatPremium
          applicationDataInJourneyFormat={applicationDataInJourneyFormat}
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
        />
      ) : sections?.[currentSectionIndex] &&
      sections[currentSectionIndex].sectionId === "SectionULIPBenefitIllustration" ? ( //For invest4g
        <BenefitIllustrationUlip
          applicationDataInJourneyFormat={applicationDataInJourneyFormat}
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
        />
      ): sections?.[currentSectionIndex] &&
      sections[currentSectionIndex].sectionId === "SectionULIPYourFundValue" ? ( //For invest4g
        <Invest4GFundValue
          applicationDataInJourneyFormat={applicationDataInJourneyFormat}
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "make-Payment" ? (
        <Payment
          channel={journeyState.channel}
          journeyDataState={journeyDataState}
          applicationDataInJourneyFormat={applicationDataInJourneyFormat}
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "UploadDocuments" ? (
        <UploadDocuments
          journeyDataState={journeyDataState}
          applicationDataInJourneyFormat={applicationDataInJourneyFormat}
          channel={journeyState.channel} 
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "CPChoosePlanSection" ? (
        <ChooseYourPlan
          journeyDataState={journeyDataState}
          applicationDataInJourneyFormat={applicationDataInJourneyFormat}
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          pages={props.pages}
          callBi={callBi}
          setCallBi={setCallBi}
        />
        ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "P2PCPChoosePlanSection" ? (
        <ChooseYourPlanP2P
          journeyDataState={journeyDataState}
          applicationDataInJourneyFormat={applicationDataInJourneyFormat}
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          pages={props.pages}
          callBi={callBi}
          setCallBi={setCallBi}
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "successful-transaction" ? (
        <SuccessfulTransactions
          journeyDataState={journeyDataState}
          applicationDataInJourneyFormat={applicationDataInJourneyFormat}
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          pages={props.pages}
          callBi={callBi}
        />
      ) : sections?.[currentSectionIndex] &&
      sections[currentSectionIndex].sectionId === "unsuccessful-transaction" ? (
      <UnsuccessfulTransaction
        applicationDataInJourneyFormat={applicationDataInJourneyFormat}
        currentPageIndex={props.currentPageIndex}
        currentSectionIndex={currentSectionIndex}
        setCurrentSectionIndex={setCurrentSectionIndex}
        setCurrentPageIndex={props.setCurrentPageIndex}
        sections={sections}
        pageId={props.pageId}
      />
      ) : sections?.[currentSectionIndex] &&
      sections[currentSectionIndex].sectionId === "pending-transaction" ? (
      <PendingTransaction
        applicationDataInJourneyFormat={applicationDataInJourneyFormat}
        currentPageIndex={props.currentPageIndex}
        currentSectionIndex={currentSectionIndex}
        setCurrentSectionIndex={setCurrentSectionIndex}
        setCurrentPageIndex={props.setCurrentPageIndex}
        sections={sections}
        pageId={props.pageId}
      />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "pending-transaction-basba" ? (
        <PendingTransactionBasba
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
        />
      ) : sections?.[currentSectionIndex] &&
      sections[currentSectionIndex].sectionId === "eNach-physicalMandate" ? (
      <ENachPhysicalMandate
        applicationDataInJourneyFormat={applicationDataInJourneyFormat}
          channel={journeyState.channel}
        currentPageIndex={props.currentPageIndex}
        currentSectionIndex={currentSectionIndex}
        setCurrentSectionIndex={setCurrentSectionIndex}
        setCurrentPageIndex={props.setCurrentPageIndex}
        sections={sections}
        pageId={props.pageId}
      />
      ) : sections?.[currentSectionIndex] &&
      sections[currentSectionIndex].sectionId === "declaration" ? (
      <Declaration
        journeyDataState={journeyDataState}
        applicationDataInJourneyFormat={applicationDataInJourneyFormat}
        currentPageIndex={props.currentPageIndex}
        currentSectionIndex={currentSectionIndex}
        setCurrentSectionIndex={setCurrentSectionIndex}
        setCurrentPageIndex={props.setCurrentPageIndex}
        sections={sections}
        pageId={props.pageId}
      />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "salesConfidentialReport" ? (
        <SalesConfidentialReport
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pages={props.pages}
          pageId={props.pageId}
        />
      ) : sections?.[currentSectionIndex] &&
      sections[currentSectionIndex].sectionId === "application-submission" ? (
      <Submission
        journeyDataState={journeyDataState}
        applicationDataInJourneyFormat={applicationDataInJourneyFormat}
        currentPageIndex={props.currentPageIndex}
        currentSectionIndex={currentSectionIndex}
        setCurrentSectionIndex={setCurrentSectionIndex}
        setCurrentPageIndex={props.setCurrentPageIndex}
        sections={sections}
        pageId={props.pageId}
      />
      ) : sections?.[currentSectionIndex] &&
      sections[currentSectionIndex].sectionId === "reviewDetails" ? (
      <ReviewDetails
        journeyDataState={journeyDataState}
        applicationDataInJourneyFormat={applicationDataInJourneyFormat}
        currentPageIndex={props.currentPageIndex}
        currentSectionIndex={currentSectionIndex}
        setCurrentSectionIndex={setCurrentSectionIndex}
        setCurrentPageIndex={props.setCurrentPageIndex}
        sections={sections}
        pageId={props.pageId}
        saveApplicationCounter={saveApplicationCounter}
      />
      ) : sections?.[currentSectionIndex] &&
      sections[currentSectionIndex].sectionId === "Tele-MER" ? (
      <TeleMer
        currentPageIndex={props.currentPageIndex}
        currentSectionIndex={currentSectionIndex}
        setCurrentSectionIndex={setCurrentSectionIndex}
        setCurrentPageIndex={props.setCurrentPageIndex}
        sections={sections}
        pageId={props.pageId}
        saveApplicationCounter={saveApplicationCounter}
      />
      ) : sections?.[currentSectionIndex] &&
      sections[currentSectionIndex].sectionId === "ThankYou" ? (
      <ThankYou
      journeyDataState={journeyDataState}
      applicationDataInJourneyFormat={applicationDataInJourneyFormat}
      currentPageIndex={props.currentPageIndex}
      currentSectionIndex={currentSectionIndex}
      setCurrentSectionIndex={setCurrentSectionIndex}
      setCurrentPageIndex={props.setCurrentPageIndex}
      sections={sections}
      pageId={props.pageId}
      />
      ) : sections?.[currentSectionIndex] &&
      sections[currentSectionIndex].sectionId === "sectionBookSlot" ? (
      <BookTPASlot
        currentPageIndex={props.currentPageIndex}
        currentSectionIndex={currentSectionIndex}
        setCurrentSectionIndex={setCurrentSectionIndex}
        setCurrentPageIndex={props.setCurrentPageIndex}
        sections={sections}
        pageId={props.pageId}
        saveApplicationCounter={saveApplicationCounter}
        applicationDataInJourneyFormat={applicationDataInJourneyFormat}
      />
      ) :  sections?.[currentSectionIndex] &&
      sections[currentSectionIndex].sectionId === "sectionBookSlotSA" ? (
      <BookTPASlotSA
        currentPageIndex={props.currentPageIndex}
        currentSectionIndex={currentSectionIndex}
        setCurrentSectionIndex={setCurrentSectionIndex}
        setCurrentPageIndex={props.setCurrentPageIndex}
        sections={sections}
        pageId={props.pageId}
        saveApplicationCounter={saveApplicationCounter}
        applicationDataInJourneyFormat={applicationDataInJourneyFormat}
      />
      ) : (
        <>
          <div className="landing-page1-design">
            <div className="container">
              <div className="row">
                {/* left-side */}

                <Section
                  journeyDataState={journeyDataState}
                  applicationDataInJourneyFormat={applicationDataInJourneyFormat}
                  section={sections?.[currentSectionIndex]}
                  currentSectionIndex={currentSectionIndex}
                  currentPageIndex={props.currentPageIndex}
                  pageId={props.pageId}
                  showError={showError}
                  pages={props.pages}
                  sections={sections}
                  sectionId={sections?.[currentSectionIndex]?.sectionId}
                  nvestFilterResult={nvestFilterResult}
                  saveApplicationAndCallBi={saveApplicationAndCallBi}
                  businessRule={businessRule}
                  showFirstSectionFields={props.showFirstSectionFields}
                  firstPassForPremiumPaymentBicall={firstPassForPremiumPaymentBicall}
                  setFirstPassForPremiumPaymentBicall={setFirstPassForPremiumPaymentBicall}
                />
                {/* left-side */}

                {/* <!--right-side--> */}
                <RightSideBar
                  sections={sections}
                  setCallBi={setCallBi}
                  currentSectionIndex={currentSectionIndex} 
                  setCurrentSectionIndex={setCurrentSectionIndex} 
                  channelForColorChange = {journeyState.channel}
                />
                {/* <!--right-side--> */}
              </div>
            </div>
          </div>
         
          <div className="container" >
          <div className="col-lg-9 col-md-12">
            <div className="journey-buttons hidden-desktop-screen">
              {/* {console.log("page indexing",props,props.currentPageIndex , currentSectionIndex )} */}
              {!((props.currentPageIndex === 0 || props.pageId === "fillProposalForm" || props.pageId === "pageISelect360FillProposalForm") && currentSectionIndex === 0) && (
                <div className="provider submit-btn cen" tabIndex="0"
                onKeyPress={(e)=>handleEnterPrevious(e)}
                >
                  <a aria-hidden="true" onClick={handlePreviousClick}>Previous</a>
                </div>
              )}
              <input
                type="submit"
                className="provider previous-btn cen"
                tabIndex="0"
                style={{
                  color: "white",
                  padding: "14px 40px",
                  border: "none",
                }}
                onClick={handleSubmit}
                value="Proceed"
              />
            </div>
          </div>
          </div>

          {/* <!--mobile view button--> */}
        
          <div className="mobile-view-btn-Q1 pd-mobile-space-structure">
            <div className="iselect-mg-bottom">
              <div className="col-md-12">
                <div className="but-center text-center">
                  {!(
                    (props.currentPageIndex === 0 || props.pageId === "fillProposalForm" || props.pageId === "pageISelect360FillProposalForm") && currentSectionIndex === 0
                  ) && (
                    <div className="submit-btn cen">
                      <a aria-hidden="true" onClick={handlePreviousClick}>Previous</a>
                    </div>
                  )}
                  <input
                    type="submit"
                    className="previous-btn cen"
                    style={{
                      color: "white",
                      padding: "14px 40px",
                      border: "none",
                      marginLeft: "8px",
                    }}
                    onClick={handleSubmit}
                    value="Proceed"
                  />
                </div>
              </div>
            </div>
          </div>
          {/* <!--mobile view button-->   */}
          {/* body-section */}
        </>
      )}
    </>
  )
}

export default Page
